var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
define("ts/util/fsm", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // Finite State Machine
    class FSM {
        // Create a new finite state machine with the supplied start state
        constructor(start) {
            this.stateHandlers = new SetMap();
            this.onceHandlers = new SetMap();
            this.transitions = {};
            this.wilds = {};
            this.state = start;
        }
        // Assign a handler to be execute on arrival to a new state
        on(state, handler) {
            this.stateHandlers.add(state.toString(), handler);
        }
        // Like on, but handler is removed after execution
        once(state, handler) {
            this.onceHandlers.add(state.toString(), handler);
        }
        // Specify state transition and a handler to execute on it. The handler must
        // return the next state of FSM.
        act(start, event, handler) {
            this.transitions[this.transitionString(start, event)] = handler;
        }
        // Specify an event and handler, that will execute, when this event is fired
        // on any state.
        wildAct(event, handler) {
            this.wilds[event.toString()] = handler;
        }
        // Feed an event to the FSM
        feed(event, arg) {
            let result;
            const e = event.toString();
            if (e in this.wilds) {
                result = this.wilds[e](arg);
            }
            else {
                const transition = this.transitionString(this.state, event);
                const handler = this.transitions[transition];
                if (!handler) {
                    // Not registered. NOOP
                    return;
                }
                result = handler(arg);
            }
            this.state = result;
            const r = result.toString();
            this.stateHandlers.forEach(r, (fn) => fn(arg));
            this.onceHandlers.forEach(r, (fn) => fn(arg));
            this.onceHandlers.removeAll(r);
        }
        // Returns a function that executes FSM.prototype.feed with the passed
        // argument
        feeder(event) {
            return (arg) => this.feed(event, arg);
        }
        // Generate a transition string representation
        transitionString(start, event) {
            return `${start}+${event}`;
        }
    }
    exports.default = FSM;
    // Simple map of sets with automatic array creation and removal
    class SetMap {
        constructor() {
            this.map = {};
        }
        // Add item to key
        add(key, item) {
            if (!(key in this.map)) {
                this.map[key] = new Set();
            }
            this.map[key].add(item);
        }
        // Remove an item from a key
        remove(key, item) {
            const set = this.map[key];
            if (!set) {
                return;
            }
            set.delete(item);
            if (set.size === 0) {
                delete this.map[key];
            }
        }
        // Remove all items from a key
        removeAll(key) {
            delete this.map[key];
        }
        // Execute a function for each item under a key
        forEach(key, fn) {
            const set = this.map[key];
            if (!set) {
                return;
            }
            set.forEach(fn);
        }
    }
});
/**
 * Helper functions for communicating with the server's API.
 */
define("ts/util/fetch", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class AbortError extends Error {
    }
    exports.AbortError = AbortError;
    function toFormData(data) {
        const form = new FormData();
        for (let k of Object.keys(data)) {
            const v = data[k];
            if (Array.isArray(v)) {
                k += "[]";
                v.forEach((item) => form.append(k, item));
            }
            else if (typeof v === "boolean") {
                if (v) {
                    form.append(k, "on");
                }
            }
            else {
                form.append(k, v);
            }
        }
        return form;
    }
    function xhrToFetchHeaders(xhr) {
        const headers = new Headers();
        const hStr = xhr.getAllResponseHeaders();
        for (const h of hStr.trim().split(/\r\n/)) {
            const [k, v] = h.split(/: (.+)/);
            headers.append(k, v);
        }
        return headers;
    }
    // Avoids stale fetches from the browser cache.
    function uncachedGET(url) {
        return fetch(url, {
            credentials: "same-origin",
            headers: { "Cache-Control": "no-cache" },
            method: "GET",
        });
    }
    exports.uncachedGET = uncachedGET;
    // Fetch JSON data.
    function fetchJSON(url) {
        return fetch(url).then((res) => {
            if (!res.ok) {
                return res.text().then((text) => {
                    throw new Error(text);
                });
            }
            return res.json();
        });
    }
    exports.fetchJSON = fetchJSON;
    // Send a JSON request to the server.
    function sendJSON(url, data, method = "POST") {
        return fetch(url, {
            body: JSON.stringify(data),
            credentials: "same-origin",
            method,
        });
    }
    exports.sendJSON = sendJSON;
    // Send a multipart/form-data request to the server.
    function sendForm(url, data, method = "POST") {
        return fetch(url, {
            body: toFormData(data),
            credentials: "same-origin",
            method,
        });
    }
    exports.sendForm = sendForm;
    // Send a multipart/form-data request to the server, accepting optional
    // progress callback and storage for XHR API methods like `abort`.
    // Implemented using XHR underneath because Fetch API currently lacks
    // this functionality, but provides roughly same API as fetch version.
    function sendFormProgress(url, data, method = "POST", onProgress, api) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open(method, url);
            xhr.onload = () => {
                const { status, statusText } = xhr;
                const headers = xhrToFetchHeaders(xhr);
                const init = { status, statusText, headers };
                resolve(new Response(xhr.responseText, init));
            };
            xhr.onerror = reject;
            if (onProgress) {
                xhr.upload.onprogress = onProgress;
            }
            if (api) {
                // A bit kludgy but there is no other way..
                api.abort = () => {
                    xhr.abort();
                    reject(new AbortError());
                };
            }
            xhr.send(toFormData(data));
        });
    }
    exports.sendFormProgress = sendFormProgress;
});
/**
 * Hooks for optional modules to execute code in exposed functions.
 */
// TODO(Kagami): Use this module instead of util/fsm and util/changes.
define("ts/util/hooks", ["require", "exports", "events"], function (require, exports, events_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    const hooks = new events_1.EventEmitter();
    /** Assigns a handler to execute on a hook name. */
    function hook(name, fn) {
        hooks.addListener(name.toString(), fn);
    }
    exports.hook = hook;
    /** Remove hook. */
    function unhook(name, fn) {
        hooks.removeListener(name.toString(), fn);
    }
    exports.unhook = unhook;
    /** Execute handler for a hook. */
    function trigger(name, ...args) {
        hooks.emit(name.toString(), ...args);
    }
    exports.trigger = trigger;
});
/**
 * Subscribable properties container.
 */
define("ts/util/changes", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // Wrap an object with a Proxy that executes handlers on property changes.
    // To add new handlers, call the .onChange method on the object.
    // For type safety, the passed generic interface must extend ChangeEmitter.
    function emitChanges(obj) {
        const changeHooks = {};
        // Proxies do not have a prototype. Some hacks required.
        // Add a function to be executed, when a key is set on the object.
        obj.onChange = (key, func) => {
            const hooks = changeHooks[key];
            if (hooks) {
                hooks.push(func);
            }
            else {
                changeHooks[key] = [func];
            }
        };
        return new Proxy(obj, {
            set(target, key, val) {
                target[key] = val;
                (changeHooks[key] || []).forEach((fn) => fn(val));
                return true;
            },
        });
    }
    exports.emitChanges = emitChanges;
});
/**
 * Shared constants, should be used everywhere.
 */
// Don't import here anything!
define("ts/vars/index", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // Selectors, must be kept in sync with markup and styles!
    exports.MAIN_CONTAINER_SEL = ".main";
    exports.ALERTS_CONTAINER_SEL = ".alerts-container";
    exports.HOVER_CONTAINER_SEL = ".hover-container";
    exports.POPUP_CONTAINER_SEL = ".popup-container";
    exports.MODAL_CONTAINER_SEL = ".modal-container";
    exports.REPLY_CONTAINER_SEL = ".reply-container";
    exports.PROFILES_CONTAINER_SEL = ".header-profiles";
    exports.BOARD_SEARCH_INPUT_SEL = ".board-search-input";
    exports.BOARD_SEARCH_SORT_SEL = ".board-search-sort";
    exports.THREAD_SEL = ".thread";
    exports.POST_SEL = ".post";
    exports.POST_LINK_SEL = ".post-link";
    exports.POST_BODY_SEL = ".post-body";
    exports.POST_FILE_TITLE_SEL = ".post-file-title";
    exports.POST_FILE_LINK_SEL = ".post-file-link";
    exports.POST_FILE_THUMB_SEL = ".post-file-thumb";
    exports.POST_BACKLINKS_SEL = ".post-backlinks";
    exports.POST_EMBED_SEL = ".post-embed";
    exports.PAGE_NAV_TOP_SEL = ".page-nav-top";
    exports.PAGE_NAV_BOTTOM_SEL = ".page-nav-bottom";
    // Action trigger selectors, might appear multiple times in markup.
    exports.TRIGGER_OPEN_REPLY_SEL = ".trigger-open-reply";
    exports.TRIGGER_QUOTE_POST_SEL = ".trigger-quote-post";
    exports.TRIGGER_DELETE_POST_SEL = ".trigger-delete-post";
    exports.TRIGGER_BAN_BY_POST_SEL = ".trigger-ban-by-post";
    exports.TRIGGER_IGNORE_USER_SEL = ".trigger-ignore-user";
    exports.TRIGGER_MEDIA_HOVER_SEL = ".trigger-media-hover";
    exports.TRIGGER_MEDIA_POPUP_SEL = ".trigger-media-popup";
    exports.TRIGGER_PAGE_NAV_TOP_SEL = ".trigger-page-nav-top";
    exports.TRIGGER_PAGE_NAV_BOTTOM_SEL = ".trigger-page-nav-bottom";
    // Constants.
    exports.ALERT_HIDE_TIMEOUT_SECS = 4;
    exports.RELATIVE_TIME_PERIOD_SECS = 60;
    exports.HOVER_TRIGGER_TIMEOUT_SECS = 0.1;
    exports.POST_HOVER_TIMEOUT_SECS = 0.5;
    exports.ZOOM_STEP_PX = 100;
    exports.HEADER_HEIGHT_PX = 30;
    exports.REPLY_THREAD_WIDTH_PX = 700;
    exports.REPLY_BOARD_WIDTH_PX = 1000;
    exports.REPLY_HEIGHT_PX = 200;
    exports.DEFAULT_NOTIFICATION_IMAGE_URL = "/static/img/notification.png";
    const DAY_MS = 24 * 60 * 60 * 1000;
    exports.EMBED_CACHE_EXPIRY_MS = 30 * DAY_MS;
});
/**
 * Various utility functions.
 */
define("ts/util/index", ["require", "exports", "ts/util/fsm", "ts/util/fetch", "ts/util/hooks", "ts/util/changes", "ts/vars/index"], function (require, exports, fsm_1, fetch_1, hooks_1, changes_1, vars_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FSM = fsm_1.default;
    exports.AbortError = fetch_1.AbortError;
    exports.uncachedGET = fetch_1.uncachedGET;
    exports.fetchJSON = fetch_1.fetchJSON;
    exports.sendJSON = fetch_1.sendJSON;
    exports.sendForm = fetch_1.sendForm;
    exports.sendFormProgress = fetch_1.sendFormProgress;
    exports.hook = hooks_1.hook;
    exports.unhook = hooks_1.unhook;
    exports.trigger = hooks_1.trigger;
    exports.emitChanges = changes_1.emitChanges;
    // Retrieve element id.
    function getID(el) {
        return el ? +el.getAttribute("data-id") : 0;
    }
    exports.getID = getID;
    // Retrieve post number of closest parent post element.
    function getClosestID(el) {
        return el ? getID(el.closest(vars_1.POST_SEL)) : 0;
    }
    exports.getClosestID = getClosestID;
    // Parse HTML string to a single Node
    function makeNode(html) {
        const el = document.createElement("div");
        el.innerHTML = html;
        return el.firstChild;
    }
    exports.makeNode = makeNode;
    // Parse HTML string to node array
    // TODO(Kagami): Remove.
    function makeFrag(html) {
        return document.createRange().createContextualFragment(html);
    }
    exports.makeFrag = makeFrag;
    // Add an event listener that optionally filters targets according to a
    // CSS selector.
    function on(el, type, fn, opts) {
        if (opts && opts.selector) {
            const origFn = fn;
            const selector = Array.isArray(opts.selector)
                ? opts.selector.join(",")
                : opts.selector;
            fn = (event) => {
                const t = event.target;
                if (t instanceof Element && t.matches(selector)) {
                    origFn(event);
                }
            };
        }
        el.addEventListener(type, fn, opts);
    }
    exports.on = on;
    // Pad an integer with a leading zero, if below 10
    function pad(n) {
        return (n < 10 ? "0" : "") + n;
    }
    exports.pad = pad;
    const escapeMap = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&apos;",
    };
    const unescapeMap = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&apos;": "'",
    };
    // Escape a user-submitted unsafe string to protect against XSS.
    function escape(str) {
        return str.replace(/[&<>"']/g, (ch) => escapeMap[ch]);
    }
    exports.escape = escape;
    // Reverse escape() effect.
    function unescape(html) {
        return html.replace(/&(amp|lt|gt|quot|apos);/g, (entity) => unescapeMap[entity]);
    }
    exports.unescape = unescape;
    // Find the first child of an element, that matches a check function, if any
    function firstChild(el, check) {
        for (const ch of Array.from(el.children)) {
            if (check(ch)) {
                return ch;
            }
        }
        return null;
    }
    exports.firstChild = firstChild;
    // Returns an input element inside the parent by name
    function inputElement(parent, name) {
        return parent.querySelector(`input[name="${name}"]`);
    }
    exports.inputElement = inputElement;
    // Extract JSON from a <script> tag by ID
    function extractJSON(id) {
        const el = document.getElementById(id);
        if (!el) {
            return null;
        }
        return JSON.parse(el.textContent);
    }
    exports.extractJSON = extractJSON;
    // Are we at bottom of the page.
    function isAtBottom() {
        const el = document.documentElement;
        return el.scrollHeight - el.scrollTop <= el.clientHeight + 10;
    }
    exports.isAtBottom = isAtBottom;
    // Scroll to the top of the page.
    function scrollToTop() {
        window.scrollTo(0, 0);
    }
    exports.scrollToTop = scrollToTop;
    // Scroll to the bottom of the thread.
    function scrollToBottom() {
        window.scrollTo(0, document.documentElement.scrollHeight);
    }
    exports.scrollToBottom = scrollToBottom;
    // https://stackoverflow.com/a/30810322
    function copyToClipboard(text) {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        try {
            document.execCommand("copy");
        }
        finally {
            document.body.removeChild(textarea);
        }
    }
    exports.copyToClipboard = copyToClipboard;
    /** Remove item from array in place. */
    function remove(arr, item) {
        const idx = arr.indexOf(item);
        if (idx >= 0) {
            arr.splice(idx, 1);
        }
    }
    exports.remove = remove;
    /** Replace array's content in place. */
    function replace(arr, contents) {
        arr.length = 0;
        arr.push(...contents);
    }
    exports.replace = replace;
    /** Very cool function! */
    function noop() {
        /* skip */
    }
    exports.noop = noop;
    function setter(self, name) {
        return (el) => {
            self[name] = el;
        };
    }
    exports.setter = setter;
    /** Simple string reverse. */
    function reverse(s) {
        let s2 = "";
        for (let i = s.length - 1; i >= 0; i--) {
            s2 += s[i];
        }
        return s2;
    }
    exports.reverse = reverse;
    /** Rotate recent alike list structure. */
    function rotateRecent(list, item, max) {
        // O(n) search so passed array is supposed to be small.
        const idx = list.indexOf(item);
        return idx < 0
            ? [item, ...list.slice(0, max - 1)]
            : [item, ...list.slice(0, idx), ...list.slice(idx + 1)];
    }
    exports.rotateRecent = rotateRecent;
    /** Printf-alike helper. */
    function printf(s, ...args) {
        return s.replace(/%s/g, () => args.shift());
    }
    exports.printf = printf;
});
/**
 * User-set settings storage and change handling.
 */
define("ts/options/index", ["require", "exports", "ts/util/index"], function (require, exports, util_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // Specifications of option behavior, where needed. Some properties defined as
    // getters to prevent race with "state" module
    const specs = {
        // Boss key toggle
        workModeToggle: {
            default: false,
            exec: (on) => {
                document.documentElement.classList.toggle("work-mode", on);
            },
            type: 0 /* checkbox */,
        },
        // Backdrop clicking
        popupBackdrop: {
            default: true,
        },
        // Image hover expansion
        imageHover: {
            default: true,
        },
        // Desktop Notifications
        notification: {
            default: false,
            exec(enabled) {
                const req = enabled &&
                    typeof Notification === "function" &&
                    Notification.permission !== "granted";
                if (req) {
                    Notification.requestPermission();
                }
            },
        },
        // Relative post timestamps
        relativeTime: {
            default: true,
        },
        // Scroll to bottom
        scrollToBottom: {
            default: true,
        },
        // Change language
        lang: {
            get default() {
                return window.lang;
            },
            exec(l) {
                const d = new Date();
                d.setFullYear(d.getFullYear() + 10);
                document.cookie = `lang=${l}; expires=${d.toUTCString()}; path=/`;
                location.reload();
            },
            noExecOnStart: true,
            type: 4 /* menu */,
        },
        // Change theme
        theme: {
            get default() {
                return window.config.defaultCSS;
            },
            exec(theme) {
                if (!theme) {
                    return;
                }
                document
                    .getElementById("theme-css")
                    .setAttribute("href", `/static/css/${theme}.css`);
            },
            noExecOnStart: true,
            type: 4 /* menu */,
        },
        // Shortcuts.
        workMode: {
            default: "A",
            type: 3 /* shortcut */,
        },
        newPost: {
            default: "N",
            type: 3 /* shortcut */,
        },
        cancelPost: {
            default: "C",
            type: 3 /* shortcut */,
        },
        selectFile: {
            default: "O",
            type: 3 /* shortcut */,
        },
        previewPost: {
            default: "E",
            type: 3 /* shortcut */,
        },
        bold: {
            default: "B",
            type: 3 /* shortcut */,
        },
        italic: {
            default: "I",
            type: 3 /* shortcut */,
        },
        spoiler: {
            default: "P",
            type: 3 /* shortcut */,
        },
        idolSearch: {
            default: "F",
            type: 3 /* shortcut */,
        },
        // Other settings.
        volume: {
            default: 1,
        },
    };
    // Central options storage model.
    const options = (() => {
        // Need to define all properties ahead of time for the ES5 Proxy
        // polyfill to work.
        const opts = {};
        for (const k of Object.keys(specs)) {
            opts[k] = undefined;
        }
        return util_1.emitChanges(opts);
    })();
    exports.default = options;
    // All loaded option models
    exports.models = {};
    // Controller for each individual option
    class OptionModel {
        // Create new option model from template spec
        constructor(id, spec) {
            this.spec = spec = Object.assign({}, spec);
            this.id = id;
            // No type = checkbox + default false
            if (!spec.type) {
                spec.type = 0 /* checkbox */;
            }
            if (spec.type === 3 /* shortcut */) {
                spec.default = spec.default.charCodeAt(0);
            }
            // Store option value in central storage options Model
            const val = (options[this.id] = this.get());
            options.onChange(this.id, (v) => this.onChange(v));
            if (!spec.noExecOnStart) {
                this.execute(val);
            }
            exports.models[this.id] = this;
        }
        // Retrieve option value from storage and parse result. If none, return
        get() {
            const stored = this.read();
            if (!stored) {
                return this.spec.default;
            }
            else {
                if (stored === "false") {
                    return false;
                }
                if (stored === "true") {
                    return true;
                }
                const num = +stored;
                if (num || num === 0) {
                    return num;
                }
                return stored;
            }
        }
        // Execute handler function, if any
        execute(val) {
            if (this.spec.exec) {
                this.spec.exec(val);
            }
        }
        // Write value to localStorage, if needed
        set(val) {
            if (val !== this.spec.default || this.read()) {
                localStorage.setItem(this.id, val.toString());
            }
            util_1.trigger("renderOptionValue", this.id, this.spec.type, val);
        }
        // Perform value validation, if any. Otherwise return true.
        validate(val) {
            if (this.spec.validation) {
                return this.spec.validation(val);
            }
            return true;
        }
        // Read value from localStorage
        read() {
            return localStorage.getItem(this.id) || "";
        }
        // Handler to be executed on field change in central options storage model
        onChange(val) {
            this.execute(val);
            this.set(val);
        }
    }
    function init() {
        // Populate option model collection and central model
        for (const id of Object.keys(specs)) {
            // tslint:disable-next-line:no-unused-expression
            new OptionModel(id, specs[id]);
        }
    }
    exports.init = init;
});
/**
 * Internationalization support.
 */
define("ts/lang/index", ["require", "exports", "cc-langs", "ts/options/index"], function (require, exports, cc_langs_1, options_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    cc_langs_1 = __importDefault(cc_langs_1);
    options_1 = __importDefault(options_1);
    let lang = null;
    function gettext(msgid) {
        return lang.messages[msgid] || msgid;
    }
    exports.gettext = gettext;
    function ngettext(msgid1, msgid2, n) {
        const forms = lang.messages[msgid1];
        if (forms) {
            const idx = +lang.getPluralN(n);
            return forms[idx];
        }
        else {
            return n === 1 ? msgid1 : msgid2;
        }
    }
    exports.ngettext = ngettext;
    const _ = gettext;
    exports._ = _;
    exports.default = _;
    exports.months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    exports.days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    function init() {
        lang = cc_langs_1.default[options_1.default.lang];
    }
    exports.init = init;
});
/**
 * Simple notification system with auto-disposable messages.
 * Can be triggered from anywhere.
 *
 * @module cutechan/alerts
 */
define("ts/alerts/index", ["require", "exports", "classnames", "preact", "ts/lang/index", "ts/util/index", "ts/vars/index"], function (require, exports, classnames_1, preact_1, lang_1, util_2, vars_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    classnames_1 = __importDefault(classnames_1);
    lang_1 = __importDefault(lang_1);
    class Alerts extends preact_1.Component {
        constructor() {
            super(...arguments);
            this.state = {
                alerts: [],
            };
            this.id = 0;
            this.show = (a) => {
                a = Object.assign({}, a, { id: this.id++ });
                const alerts = [a].concat(this.state.alerts);
                this.setState({ alerts });
                if (!a.sticky) {
                    setTimeout(this.makeClose(a.id), vars_2.ALERT_HIDE_TIMEOUT_SECS * 1000);
                }
            };
            this.renderAlert = ({ id, title, message, closing }) => {
                return (preact_1.h("article", { class: classnames_1.default("alert", closing && "alert_closing"), key: id.toString() },
                    preact_1.h("a", { class: "control alert-close-control", onClick: this.makeClose(id, true) },
                        preact_1.h("i", { class: "fa fa-remove" })),
                    this.renderTitle(title),
                    preact_1.h("section", { class: "alert-message" }, message)));
            };
        }
        componentDidMount() {
            util_2.hook(3 /* showAlert */, this.show);
        }
        componentWillUnmount() {
            util_2.unhook(3 /* showAlert */, this.show);
        }
        render({}, { alerts }) {
            return (preact_1.h("div", { class: "alerts-container-inner" }, alerts.map(this.renderAlert)));
        }
        makeClose(id, force = false) {
            return () => {
                let alerts = this.state.alerts;
                if (force) {
                    alerts = alerts.filter((a) => a.id !== id);
                    this.setState({ alerts });
                    return;
                }
                alerts = alerts.map((a) => (a.id === id ? Object.assign({}, a, { closing: true }) : a));
                this.setState({ alerts });
                setTimeout(() => {
                    alerts = this.state.alerts.filter((a) => a.id !== id);
                    this.setState({ alerts });
                }, 1000);
            };
        }
        renderTitle(title) {
            return title ? preact_1.h("header", { class: "alert-title" }, title) : null;
        }
    }
    function showAlert(a) {
        if (typeof a === "string") {
            a = { message: a };
        }
        else if (a instanceof Error) {
            a = { message: a.message };
        }
        else if (Array.isArray(a)) {
            a = { title: a[0], message: a[1].message };
        }
        util_2.trigger(3 /* showAlert */, a);
    }
    exports.showAlert = showAlert;
    function showSendAlert(err) {
        showAlert([lang_1.default("sendErr"), err]);
    }
    exports.showSendAlert = showSendAlert;
    function init() {
        const container = document.querySelector(vars_2.ALERTS_CONTAINER_SEL);
        if (container) {
            preact_1.render(preact_1.h(Alerts, null), container);
        }
    }
    exports.init = init;
});
/**
 * Module with all available API methods.
 */
// TODO(Kagami): Port everything to the use of this module.
define("ts/api/index", ["require", "exports", "ts/lang/index", "ts/util/index"], function (require, exports, lang_2, util_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    lang_2 = __importDefault(lang_2);
    function isJson(res) {
        const ctype = res.headers.get("Content-Type") || "";
        return ctype.startsWith("application/json");
    }
    function isHtml(res) {
        const ctype = res.headers.get("Content-Type") || "";
        return ctype.startsWith("text/html");
    }
    function handleResponse(res) {
        return res.ok ? res.json() : handleErrorCode(res);
    }
    function handleErrorCode(res) {
        if (isHtml(res)) {
            // Probably 404/500 page, don't bother parsing.
            throw new Error(lang_2.default("unknownErr"));
        }
        else if (isJson(res)) {
            // Probably standardly-shaped JSON error.
            return res.json().then((data) => {
                throw new Error((data && data.error) || lang_2.default("unknownErr"));
            });
        }
        else {
            // Probably text/plain or something like this.
            return res.text().then((data) => {
                throw new Error(data || lang_2.default("unknownErr"));
            });
        }
    }
    function handleError(err) {
        throw new Error(err.message || lang_2.default("unknownErr"));
    }
    function makeReq(reqFn, method) {
        return (url) => (data, onProgress, api) => reqFn(`/api/${url}`, data, method, onProgress, api).then(handleResponse, handleError);
    }
    // Convenient helper.
    const emit = {
        GET: {
            JSON: makeReq(util_3.uncachedGET),
        },
        POST: {
            Form: makeReq(util_3.sendFormProgress),
            JSON: makeReq(util_3.sendJSON),
        },
        PUT: {
            JSON: makeReq(util_3.sendJSON, "PUT"),
        },
    };
    exports.API = {
        post: {
            create: emit.POST.Form("post"),
            createToken: emit.POST.JSON("post/token"),
            delete: emit.POST.JSON("delete-post"),
            get: (id) => emit.GET.JSON(`post/${id}`)(),
        },
        thread: {
            create: emit.POST.Form("thread"),
        },
        user: {
            banByPost: emit.POST.JSON("ban"),
        },
        account: {
            setSettings: emit.POST.JSON("account/settings"),
        },
        board: {
            save: (b, data) => emit.PUT.JSON(`boards/${b}`)(data),
        },
    };
    exports.default = exports.API;
});
define("ts/base/view", ["require", "exports", "ts/util/index"], function (require, exports, util_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // Generic model class, that all other model classes extend
    class Model {
    }
    exports.Model = Model;
    // Generic view class, that all over view classes extend
    class View {
        // Creates a new View and binds it to the target model, id any. If no
        // element supplied, creates a new one from the attributes.
        constructor({ el, model, tag, class: cls, id }) {
            if (model) {
                this.model = model;
            }
            if (!el) {
                this.el = document.createElement(tag || "div");
                if (id) {
                    this.el.setAttribute("id", id);
                    this.id = id;
                }
                if (cls) {
                    this.el.setAttribute("class", cls);
                }
            }
            else {
                this.el = el;
                const elId = el.getAttribute("id");
                if (elId) {
                    this.id = elId;
                }
            }
        }
        // Remove the from the DOM without causing a redraw
        remove() {
            this.el.remove();
        }
        // Returns input element inside the view by name
        inputElement(name) {
            return util_4.inputElement(this.el, name);
        }
        // Add  optionally selector-specific event listeners to the view
        on(type, fn, opts) {
            util_4.on(this.el, type, fn, opts);
        }
        // Shorthand for adding multiple click event listeners as an object.
        // We use those the most, so nice to have. Also prevents default behavior
        // from triggering.
        onClick(events) {
            for (const selector of Object.keys(events)) {
                this.on("click", events[selector], { selector, capture: true });
            }
        }
    }
    exports.default = View;
});
define("ts/base/header", ["require", "exports", "ts/base/view"], function (require, exports, view_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    view_1 = __importDefault(view_1);
    // View of the modal currently displayed, if any
    let visible;
    // A modal element, that is positioned fixed right beneath the header
    class HeaderModal extends view_1.default {
        constructor(el, toggleEl) {
            super({ el });
            // Show the element, if hidden, hide - if shown. Hide already visible
            // header modal, if any.
            this.toggle = () => {
                if (visible) {
                    const old = visible;
                    visible.hide();
                    if (old !== this) {
                        this.show();
                    }
                }
                else {
                    this.show();
                }
            };
            // Unhide the element. If the element has not been rendered yet, do it.
            this.show = () => {
                this.el.style.display = "block";
                visible = this;
                this.showHook();
            };
            // Hide the element
            this.hide = () => {
                this.el.style.display = "none";
                visible = null;
            };
            toggleEl.addEventListener("click", this.toggle);
        }
        // Hook to execute when the the modal is displayed.
        // Do nothing by default.
        showHook() {
            /* empty */
        }
    }
    exports.HeaderModal = HeaderModal;
    // A view that supports switching between multiple tabs.
    class TabbedModal extends HeaderModal {
        constructor(el, toggleEl) {
            super(el, toggleEl);
            this.onClick({
                ".tab-link": (e) => this.switchTab(e),
            });
        }
        // Show/hide modal content.
        // XXX(Kagami): These modals are awful.
        toggleContent(show) {
            this.el.classList.toggle("tab-modal_empty", !show);
        }
        // Trigger hook for current tab.
        showHook() {
            const tabEl = this.el.querySelector(".tab-cont .tab-sel");
            if (tabEl) {
                this.tabHook(tabEl);
            }
        }
        // Function to execute on tab switching.
        // Do nothing by default.
        tabHook(tabEl) {
            /* empty */
        }
        // Switch to a tab, when clicking the tab header.
        switchTab(event) {
            for (const el of this.el.querySelectorAll(".tab-sel")) {
                el.classList.remove("tab-sel");
            }
            const tabHeadEl = event.target;
            tabHeadEl.classList.add("tab-sel");
            const id = +tabHeadEl.getAttribute("data-id");
            const tabEl = this.el.querySelector(`.tab-cont [data-id='${id}']`);
            tabEl.classList.add("tab-sel");
            this.tabHook(tabEl);
        }
    }
    exports.TabbedModal = TabbedModal;
});
define("ts/base/index", ["require", "exports", "ts/base/view", "ts/base/header"], function (require, exports, view_2, header_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.View = view_2.default;
    exports.Model = view_2.Model;
    exports.HeaderModal = header_1.HeaderModal;
    exports.TabbedModal = header_1.TabbedModal;
});
/** Common types and constants. */
define("ts/common/index", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    /** Possible file types of a post image. */
    // MUST BE KEPT IN SYNC WITH go/src/meguca/common/images.go!
    var fileTypes;
    (function (fileTypes) {
        fileTypes[fileTypes["jpg"] = 0] = "jpg";
        fileTypes[fileTypes["png"] = 1] = "png";
        fileTypes[fileTypes["gif"] = 2] = "gif";
        fileTypes[fileTypes["webm"] = 3] = "webm";
        fileTypes[fileTypes["pdf"] = 4] = "pdf";
        fileTypes[fileTypes["svg"] = 5] = "svg";
        fileTypes[fileTypes["mp4"] = 6] = "mp4";
        fileTypes[fileTypes["mp3"] = 7] = "mp3";
        fileTypes[fileTypes["ogg"] = 8] = "ogg";
        fileTypes[fileTypes["zip"] = 9] = "zip";
        fileTypes[fileTypes["7z"] = 10] = "7z";
        fileTypes[fileTypes["tar.gz"] = 11] = "tar.gz";
        fileTypes[fileTypes["tar.xz"] = 12] = "tar.xz";
    })(fileTypes = exports.fileTypes || (exports.fileTypes = {}));
    exports.thumbSize = 200;
});
/**
 * IndexedDB database controller.
 */
define("ts/db/index", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    const DB_VERSION = 8;
    let db = null;
    let dbDisabled = false;
    // Post number sets.
    const postStores = ["mine"];
    // Store for caching embed metadata.
    const embedStore = "embedCache";
    /** Open a connection to the IndexedDB database. */
    function init() {
        return new Promise((resolve, reject) => {
            const r = indexedDB.open("cutechan", DB_VERSION);
            // Prepare for operation.
            r.onsuccess = () => {
                db = r.result;
                db.onerror = logErr;
                // Reload this tab, if another tab requires a DB upgrade.
                // TODO(Kagami): Set onbeforeunload in reply-form in order to
                // avoid losing typed text.
                db.onversionchange = () => {
                    db.close();
                    location.reload(true);
                };
                // Delay for quicker starts.
                setTimeout(() => {
                    deleteExpired(embedStore);
                }, 10000);
                resolve();
            };
            r.onupgradeneeded = upgradeDB;
            r.onerror = () => {
                reject(r.error);
            };
        }).catch((err) => {
            if (
            // IndexedDB is null in Tor Browser. This also ignores old
            // browsers without IDB which is fine.
            !window.indexedDB ||
                // FF IndexedDB implementation is broken in private mode, see:
                // <https://bugzilla.mozilla.org/show_bug.cgi?id=781982>.
                err.message ===
                    "A mutation operation was attempted on a database that did not allow mutations.") {
                dbDisabled = true;
                return;
            }
            throw err;
        });
    }
    exports.init = init;
    // Upgrade or initialize the database.
    function upgradeDB({ oldVersion, target }) {
        db = target.result;
        const t = target.transaction;
        // Helpers because case statements are not blocks.
        let s = null;
        switch (oldVersion) {
            // Clean state.
            case 0:
                for (const name of postStores) {
                    s = db.createObjectStore(name, { keyPath: "id" });
                    s.createIndex("op", "op");
                }
                s = db.createObjectStore(embedStore, { keyPath: "url" });
                s.createIndex("expires", "expires");
                break;
            // Migrations. Must fall through.
            case 7:
                t.objectStore(embedStore).clear();
            /* fall-through */
        }
    }
    // Helper for logging errors with event-based error passing.
    function logErr(err) {
        // tslint:disable-next-line:no-console
        console.error(err);
    }
    // Delete expired records from object store.
    function deleteExpired(name) {
        const r = newTransaction(name, true)
            .index("expires")
            .openCursor(IDBKeyRange.upperBound(Date.now()));
        r.onsuccess = (event) => {
            const cursor = event.target.result;
            if (cursor) {
                cursor.delete();
                cursor.continue();
            }
        };
        r.onerror = logErr;
    }
    // Helper for initiating transactions on a single object store.
    function newTransaction(store, write) {
        const t = db.transaction(store, write ? "readwrite" : "readonly");
        t.onerror = logErr;
        return t.objectStore(store);
    }
    // Retrieve an object from a specific object store.
    function getObj(store, id) {
        if (dbDisabled)
            return Promise.reject(new Error("db unavailable"));
        return new Promise((resolve, reject) => {
            const r = newTransaction(store, false).get(id);
            r.onsuccess = () => {
                if (!r.result) {
                    reject(new Error("empty getObj result"));
                    return;
                }
                resolve(r.result);
            };
            r.onerror = () => {
                reject(r.error);
            };
        });
    }
    // Insert or update object.
    function putObj(store, obj) {
        if (dbDisabled)
            return;
        newTransaction(store, true).put(obj).onerror = logErr;
    }
    /** Read the contents of a postStore for specific threads into an array. */
    function getIDs(store, ...ops) {
        if (dbDisabled || !ops.length)
            return Promise.resolve([]);
        return new Promise((resolve, reject) => {
            const ids = [];
            // DB API doesn't support queries like `op IN (1, 2, 3)`, so use
            // `first_op < op < last_op` instead. Doesn't matter if we will read
            // more IDs than needed.
            ops.sort((a, b) => a - b);
            const r = newTransaction(store, false)
                .index("op")
                .openCursor(IDBKeyRange.bound(ops[0], ops[ops.length - 1]));
            r.onsuccess = (e) => {
                const cursor = e.target.result;
                if (cursor) {
                    ids.push(cursor.value.id);
                    cursor.continue();
                }
                else {
                    resolve(ids);
                }
            };
            r.onerror = () => {
                reject(r.error);
            };
        });
    }
    exports.getIDs = getIDs;
    /** Asynchronously add new post id object into postStore. */
    function setID(store, id, op) {
        putObj(store, { id, op });
    }
    exports.setID = setID;
    /** Clear the target object store asynchronously. */
    function clearStore(store) {
        if (dbDisabled)
            return;
        newTransaction(store, true).clear().onerror = logErr;
    }
    exports.clearStore = clearStore;
    // TODO(Kagami): Normalize urls, e.g. `youtube.com/watch?v=xxx` and
    // `youtu.be/xxx` should be stored under the same key.
    function getEmbed(url) {
        return getObj(embedStore, url);
    }
    exports.getEmbed = getEmbed;
    function setEmbed(url, obj, expiry) {
        const expires = Date.now() + expiry;
        return putObj(embedStore, Object.assign({}, obj, { url, expires }));
    }
    exports.setEmbed = setEmbed;
});
// Stores the central state of the web application
define("ts/state/index", ["require", "exports", "ts/db/index", "ts/posts/index", "ts/util/index"], function (require, exports, db_1, posts_1, util_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // Retrieve model of closest parent post
    function getModel(el) {
        const id = util_5.getClosestID(el);
        if (!id)
            return null;
        return exports.posts.get(id);
    }
    exports.getModel = getModel;
    // Read page state by parsing a URL
    function getState(href) {
        const u = document.createElement("a");
        u.href = href;
        // WTF, IE?
        // https://stackoverflow.com/a/956376
        let pathname = u.pathname;
        if (!pathname.startsWith("/")) {
            pathname = "/" + pathname;
        }
        const admin = pathname.match(/^\/admin\/(\w+)?/);
        const thread = pathname.match(/^\/\w+\/(\d+)/);
        const pageN = u.search.match(/[&\?]page=(\d+)/);
        return {
            board: pathname.match(/^\/(\w+)?\/?/)[1],
            catalog: /^\/\w+\/catalog/.test(pathname),
            href,
            landing: pathname === "/",
            stickers: pathname.startsWith("/stickers/"),
            admin: admin ? admin[1] || "all" : "",
            lastN: /[&\?]last=100/.test(u.search) ? 100 : 0,
            page: pageN ? parseInt(pageN[1], 10) : 0,
            thread: parseInt(thread && thread[1], 10) || 0,
        };
    }
    // Load initial page state
    exports.page = getState(location.href);
    // Configuration passed from the server. Some values can be changed during
    // runtime.
    exports.config = window.config;
    // Currently existing boards
    exports.boards = window.boards;
    // All posts currently displayed
    exports.posts = new posts_1.PostCollection();
    // Posts I made in any tab
    exports.mine = new Set();
    function loadMine() {
        try {
            return JSON.parse(localStorage.mine);
        }
        catch (e) {
            return [];
        }
    }
    // Load post number sets
    function loadPostStores() {
        const ids = loadMine();
        for (const id of ids) {
            exports.mine.add(id);
        }
    }
    exports.loadPostStores = loadPostStores;
    // Store the ID of a post this client created
    function storeMine(id, op) {
        exports.mine.add(id);
        const ids = Array.from(exports.mine);
        localStorage.mine = JSON.stringify(ids);
        // Save in second storage just for possible future purposes.
        db_1.setID("mine", id, op);
    }
    exports.storeMine = storeMine;
    window.addEventListener("storage", loadPostStores);
});
define("ts/ui/forms", ["require", "exports", "ts/base/index"], function (require, exports, base_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class FormView extends base_1.View {
        constructor(attrs) {
            super(attrs);
            this.onClick({
                "input[name=cancel]": () => this.remove(),
            });
            this.on("submit", (e) => this.submit(e));
        }
        // Render a text comment about the response status below the form
        renderFormResponse(text) {
            this.el.querySelector(".form-response").textContent = text;
        }
        // Submit form to server. Pass it to the assigned handler function
        submit(event) {
            event.preventDefault();
            this.send();
        }
    }
    exports.default = FormView;
});
define("ts/connection/messages", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // Websocket message handlers. Each handler responds to its distinct message
    // type.
    exports.handlers = {};
});
/**
 * Core websocket message handlers.
 */
define("ts/client/index", ["require", "exports", "ts/alerts/index", "ts/connection/index", "ts/options/index", "ts/posts/index", "ts/state/index", "ts/ui/index", "ts/util/index"], function (require, exports, alerts_1, connection_1, options_2, posts_2, state_1, ui_1, util_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    options_2 = __importDefault(options_2);
    // Run a function on a model, if it exists
    function handle(id, fn) {
        const model = state_1.posts.get(id);
        if (model) {
            fn(model);
        }
    }
    // Insert a post into the models and DOM
    function insertPost(data) {
        const atBottom = util_6.isAtBottom();
        const model = new posts_2.Post(data);
        model.op = state_1.page.thread;
        model.board = state_1.page.board;
        state_1.posts.add(model);
        const view = new posts_2.PostView(model, null);
        view.afterRender();
        model.propagateLinks();
        // Find last allocated post and insert after it
        const last = document.getElementById("thread-container").firstChild
            .lastElementChild;
        last.after(view.el);
        ui_1.postAdded(model);
        if (options_2.default.scrollToBottom && atBottom && !posts_2.isHoverActive()) {
            util_6.scrollToBottom();
        }
        // Fire event to signal userscripts that a new post was added
        document.dispatchEvent(new CustomEvent('new_post_hook', { bubbles: true,
            detail: { post: view.el } }));
    }
    exports.insertPost = insertPost;
    function init() {
        connection_1.handlers[0 /* invalid */] = (msg) => {
            alerts_1.showAlert(msg);
            connection_1.connSM.feed(4 /* error */);
            throw new Error(msg);
        };
        connection_1.handlers[2 /* insertPost */] = insertPost;
        connection_1.handlers[10 /* deletePost */] = (id) => handle(id, (m) => m.setDeleted());
        connection_1.handlers[37 /* redirect */] = (board) => {
            location.href = `/${board}/`;
        };
        // handlers[message.notification] = (text: string) =>
        //   new OverlayNotification(text);
        // handlers[message.insertImage] = (msg: ImageMessage) =>
        //   handle(msg.id, (m) => {
        //     delete msg.id;
        //     m.insertImage(msg);
        //   });
        // handlers[message.append] = ([id, char]: [number, number]) =>
        //   handle(id, (m) =>
        //     m.append(char));
        // handlers[message.backspace] = (id: number) =>
        //   handle(id, (m) =>
        //     m.backspace());
        // handlers[message.splice] = (msg: SpliceResponse) =>
        //   handle(msg.id, (m) =>
        //     m.splice(msg));
        // handlers[message.closePost] = ({ id, links }: CloseMessage) =>
        //   handle(id, (m) => {
        //     if (links) {
        //       m.links = links;
        //       m.propagateLinks();
        //     }
        //     m.closePost();
        //   });
        // handlers[message.deleteImage] = (id: number) =>
        //   handle(id, (m) =>
        //     m.removeImage());
        // handlers[message.banned] = (id: number) =>
        //   handle(id, (m) =>
        //     m.setBanned());
    }
    exports.init = init;
});
define("ts/connection/synchronization", ["require", "exports", "ts/alerts/index", "ts/api/index", "ts/client/index", "ts/state/index", "ts/connection/messages", "ts/connection/state"], function (require, exports, alerts_2, api_1, client_1, state_2, messages_1, state_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    api_1 = __importDefault(api_1);
    // Send a requests to the server to synchronise to the current page and
    // subscribe to the appropriate event feeds
    function synchronise() {
        state_3.send(30 /* synchronise */, {
            board: state_2.page.board,
            thread: state_2.page.thread,
        });
    }
    exports.synchronise = synchronise;
    // Fetch a post not present on the client and render it
    function fetchMissingPost(id) {
        return __awaiter(this, void 0, void 0, function* () {
            client_1.insertPost(yield api_1.default.post.get(id));
            state_2.posts.get(id).view.reposition();
        });
    }
    // Synchronise to the server and start receiving updates on the appropriate
    // channel. If there are any missed messages, fetch them.
    messages_1.handlers[30 /* synchronise */] = (data) => __awaiter(this, void 0, void 0, function* () {
        // Skip posts before the first post in a shortened thread
        let minID = 0;
        if (state_2.page.lastN) {
            minID = Infinity;
            for (const { id } of state_2.posts) {
                if (id < minID && id !== state_2.page.thread) {
                    minID = id;
                }
            }
            // No replies ;_;
            if (minID === Infinity) {
                minID = state_2.page.thread;
            }
        }
        // Board pages currently have no sync data
        if (data) {
            const { recent, deleted } = data;
            const proms = [];
            for (const id of recent) {
                if (id >= minID && !state_2.posts.has(id)) {
                    // FIXME(Kagami): Remove deleted posts from recent.
                    proms.push(fetchMissingPost(id).catch(() => {
                        /* skip */
                    }));
                }
            }
            for (const id of deleted) {
                const post = state_2.posts.get(id);
                if (post && !post.deleted) {
                    post.setDeleted();
                }
            }
            // for (const id of banned) {
            //   const post = posts.get(id);
            //   if (post && !post.banned) {
            //     post.setBanned();
            //   }
            // }
            // for (const id of deletedImage) {
            //   const post = posts.get(id);
            //   if (post && post.image) {
            //     post.removeImage();
            //   }
            // }
            yield Promise.all(proms).catch((e) => {
                alerts_2.showAlert(e.message);
                throw e;
            });
        }
        state_3.connSM.feed(5 /* sync */);
    });
});
define("ts/connection/ui", ["require", "exports", "ts/connection/messages"], function (require, exports, messages_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    const syncEl = document.querySelector(".header-status");
    // const syncedCount = document.getElementById("sync-counter")
    function statusToClass(status) {
        switch (status) {
            case 3 /* synced */:
                return "fa-link";
            case 4 /* desynced */:
                return "fa-unlink";
            default:
                return "fa-spinner fa-pulse fa-fw";
        }
    }
    // Render connection status indicator
    function renderStatus(status) {
        const cls = statusToClass(status);
        syncEl.innerHTML = `<i class="fa ${cls}"></i>`;
    }
    exports.renderStatus = renderStatus;
    // Set synced IP count to n
    function renderSyncCount(n) {
        // syncedCount.innerHTML = n
        //   ? `${n} <i class="fa fa-user"></i>`
        //   : ""
    }
    exports.renderSyncCount = renderSyncCount;
    messages_2.handlers[35 /* syncCount */] = renderSyncCount;
});
define("ts/connection/state", ["require", "exports", "ts/util/index", "ts/connection/messages", "ts/connection/synchronization", "ts/connection/ui"], function (require, exports, util_7, messages_3, synchronization_1, ui_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    const path = (location.protocol === "https:" ? "wss" : "ws") +
        `://${location.host}/api/socket`;
    let socket;
    let attempts;
    let attemptTimer;
    // Finite state machine for managing websocket connectivity
    exports.connSM = new util_7.FSM(0 /* loading */);
    function connect() {
        nullSocket();
        if (window.location.protocol === "file:") {
            // tslint:disable-next-line:no-console
            console.error("Page downloaded locally. Refusing to sync.");
            return;
        }
        socket = new WebSocket(path);
        socket.onopen = exports.connSM.feeder(1 /* open */);
        socket.onclose = exports.connSM.feeder(2 /* close */);
        socket.onerror = exports.connSM.feeder(2 /* close */);
        socket.onmessage = ({ data }) => {
            onMessage(data, false);
        };
    }
    // Strip all handlers and remove references from Websocket instance
    function nullSocket() {
        if (socket) {
            socket.onclose = socket.onmessage = socket.onopen = socket.onclose = socket.onerror = socket = null;
        }
    }
    // Send a message to the server. If msg is null, it is omitted from sent
    // websocket message.
    function send(type, msg) {
        if (socket.readyState !== 1) {
            // tslint:disable-next-line:no-console
            console.warn("Attempting to send while socket closed");
            return;
        }
        let str = leftPad(type);
        if (msg !== null) {
            str += JSON.stringify(msg);
        }
        socket.send(str);
    }
    exports.send = send;
    // Ensure message type is always a 2 characters long string
    function leftPad(type) {
        let str = type.toString();
        if (str.length === 1) {
            str = "0" + str;
        }
        return str;
    }
    // Routes messages from the server to the respective handler
    function onMessage(data, extracted) {
        // First two characters of a message define its type
        const type = parseInt(data.slice(0, 2), 10);
        // Split several concatenated messages
        if (type === 33 /* concat */) {
            for (const msg of data.slice(2).split("\u0000")) {
                onMessage(msg, true);
            }
            return;
        }
        const handler = messages_3.handlers[type];
        if (handler) {
            handler(JSON.parse(data.slice(2)));
        }
    }
    function prepareToSync() {
        ui_2.renderStatus(1 /* connecting */);
        synchronization_1.synchronise();
        attemptTimer = setTimeout(resetAttempts, 10000);
        return 2 /* syncing */;
    }
    function clearModuleState() {
        nullSocket();
        if (attemptTimer) {
            clearTimeout(attemptTimer);
            attemptTimer = 0;
        }
    }
    // Work around browser slowing down/suspending tabs and keep the FSM up to date
    // with the actual status.
    function onWindowFocus() {
        if (!navigator.onLine) {
            return;
        }
        switch (exports.connSM.state) {
            // Ensure still connected, in case the computer went to sleep or
            // hibernate or the mobile browser tab was suspended.
            case 3 /* synced */:
                send(34 /* NOOP */, null);
                break;
            case 6 /* desynced */:
                break;
            default:
                exports.connSM.feed(3 /* retry */);
        }
    }
    // Reset the reconnection attempt counter and timers
    function resetAttempts() {
        if (attemptTimer) {
            clearTimeout(attemptTimer);
            attemptTimer = 0;
        }
        attempts = 0;
    }
    function init() {
        exports.connSM.feed(0 /* start */);
    }
    exports.init = init;
    exports.connSM.act(0 /* loading */, 0 /* start */, () => {
        ui_2.renderStatus(1 /* connecting */);
        attempts = 0;
        connect();
        return 1 /* connecting */;
    });
    for (const state of [1 /* connecting */, 4 /* reconnecting */]) {
        exports.connSM.act(state, 1 /* open */, prepareToSync);
    }
    exports.connSM.act(2 /* syncing */, 5 /* sync */, () => {
        ui_2.renderStatus(3 /* synced */);
        return 3 /* synced */;
    });
    exports.connSM.wildAct(2 /* close */, (event) => {
        clearModuleState();
        ui_2.renderStatus(0 /* disconnected */);
        // Wait maxes out at ~1min
        const wait = 500 * Math.pow(1.5, Math.min(Math.floor(++attempts / 2), 12));
        setTimeout(exports.connSM.feeder(3 /* retry */), wait);
        return 5 /* dropped */;
    });
    exports.connSM.act(5 /* dropped */, 3 /* retry */, () => {
        if (!navigator.onLine) {
            return 5 /* dropped */;
        }
        connect();
        // Don't show this immediately so we don't thrash on network loss
        setTimeout(() => {
            if (exports.connSM.state === 4 /* reconnecting */) {
                ui_2.renderStatus(1 /* connecting */);
            }
        }, 100);
        return 4 /* reconnecting */;
    });
    // Invalid message or some other critical error
    exports.connSM.wildAct(4 /* error */, () => {
        ui_2.renderStatus(4 /* desynced */);
        clearModuleState();
        return 6 /* desynced */;
    });
    document.addEventListener("visibilitychange", (event) => {
        if (!event.target.hidden) {
            onWindowFocus();
        }
    });
    window.addEventListener("online", () => {
        resetAttempts();
        exports.connSM.feed(3 /* retry */);
    });
    window.addEventListener("offline", exports.connSM.feeder(2 /* close */));
});
/**
 * Handles Websocket connectivity and messaging.
 */
define("ts/connection/index", ["require", "exports", "ts/connection/state", "ts/connection/messages", "ts/connection/synchronization", "ts/connection/ui"], function (require, exports, state_4, messages_4, synchronization_2, ui_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.connSM = state_4.connSM;
    exports.send = state_4.send;
    exports.init = state_4.init;
    exports.handlers = messages_4.handlers;
    exports.synchronise = synchronization_2.synchronise;
    exports.renderStatus = ui_3.renderStatus;
    exports.renderSyncCount = ui_3.renderSyncCount;
});
/**
 * Tab title and favicon rendering.
 */
define("ts/ui/tab", ["require", "exports", "ts/connection/index", "ts/state/index"], function (require, exports, connection_2, state_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // Hardcoded because needs to be available without connectivity.
    // tslint:disable-next-line:max-line-length
    const discoFavicon = "data:image/x-icon;base64,AAABAAEAEBAAAAEAIABoBAAAFgAAACgAAAAQAAAAIAAAAAEAIAAAAAAAAAQAACMuAAAjLgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAL0AAAC9CgAAvQoAAL0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAL0AAAC9BQAAva0AAL2tAAC9BQAAvQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAL0AAAC9BQAAvakAALz/AAC8/wAAvakAAL0FAAC9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAL0AAAC9BQAAvakAALz/AADG/wAAxv8AALz/AAC9qQAAvQUAAL0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAL0AAAC9BQAAvakAALz/AADF/wAA1v8AANb/AADF/wAAvP8AAL2pAAC9BQAAvQAAAAAAAAAAAAAAAAAAAL0AAAC9BQAAvakAALz/AADF/wAA1v8AANb/AADW/wAA1v8AAMX/AAC8/wAAvakAAL0FAAC9AAAAAAAAAL0AAAC9BQAAvakAALz/AADF/wAA1v8AANb/AADW/wAA1v8AANb/AADW/wAAxf8AALz/AAC9qQAAvQUAAL0AAAC9BQAAvagAALz/AADF/wAA1v8AANb/AADW/wAA1v8AANb/AADW/wAA1v8AANb/AADF/wAAvP8AAL2oAAC9BQAAvVgAALz/AADF/wAA1v8AANb/AADW/wAA1v8AANb/AADW/wAA1v8AANb/AADW/wAA1v8AAMX/AAC8/wAAvVgAALueAADF/wAA1v8AANb/AADW/wAA1v8AANb/AADW/wAA1v8AANb/AADW/wAA1v8AANb/AADW/wAAxf8AALueAADI3wAA1v8AANb/AADW/wAA1v8AANb/AADW/wAA1v8AANb/AADW/wAA1v8AANb/AADW/wAA1v8AANb/AADI3wAA1rIAANb/AADW/wAA1v8AANb/AADW/wAA1v8AANalAADWpQAA1v8AANb/AADW/wAA1v8AANb/AADW/wAA1rIAANYGAADWqAAA1v8AANb/AADW/wAA1v8AANapAADWBAAA1gQAANapAADW/wAA1v8AANb/AADW/wAA1qgAANYGAADWAAAA1gUAANapAADW/wAA1v8AANapAADWBQAA1gAAANYAAADWBQAA1qkAANb/AADW/wAA1qkAANYFAADWAAAAAAAAANYAAADWBQAA1q0AANatAADWBQAA1gAAAAAAAAAAAAAA1gAAANYFAADWrQAA1q0AANYFAADWAAAAAAAAAAAAAAAAAAAA1gAAANYKAADWCgAA1gAAAAAAAAAAAAAAAAAAAAAAAADWAAAA1goAANYKAADWAAAAAAAAAAAA/n8AAPw/AAD4HwAA8A8AAOAHAADAAwAAgAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIGBAADDwwAA5+cAAA==";
    const faviconEl = document.getElementById("favicon");
    const urlBase = "/static/favicons/";
    const baseTitle = document.title;
    let queue = [];
    // Last state rendered as a favicon. Used to reduce DOM & tab header
    // writes.
    const lastRendered = {
        state: 0 /* default */,
        unseenPosts: 0,
    };
    let unseenPosts = 0;
    let unseenReplies = false;
    let recalcPending = false;
    function processQueue() {
        for (const post of queue) {
            if (!post.seen()) {
                unseenPosts += 1;
            }
        }
        queue = [];
        resolve();
    }
    // Recalculate unseen post status.
    function recalc() {
        unseenPosts = 0;
        unseenReplies = false;
        recalcPending = false;
        for (const post of state_5.posts) {
            if (post.seen())
                continue;
            unseenPosts += 1;
            if (post.isReply()) {
                unseenReplies = true;
            }
        }
        resolve();
    }
    // Resolve tab title and favicon.
    function resolve() {
        let prefix = "";
        let state = 0 /* default */;
        if (connection_2.connSM.state === 6 /* desynced */) {
            prefix = "--- ";
            state = 2 /* error */;
        }
        else if (connection_2.connSM.state === 5 /* dropped */) {
            prefix = "--- ";
            state = 1 /* disconnected */;
        }
        else {
            if (unseenPosts) {
                prefix = `(${unseenPosts}) `;
                state = 3 /* unread */;
            }
            if (unseenReplies) {
                prefix = ">> " + prefix;
                state = 4 /* replied */;
            }
        }
        apply(prefix, state);
    }
    // Write tab title and favicon to DOM.
    function apply(prefix, state) {
        // Same data - skip write to DOM.
        if (lastRendered.state === state &&
            lastRendered.unseenPosts === unseenPosts) {
            return;
        }
        lastRendered.unseenPosts = unseenPosts;
        lastRendered.state = state;
        document.title = prefix + baseTitle;
        let url = urlBase;
        switch (state) {
            case 0 /* default */:
                url += "default.ico";
                break;
            case 3 /* unread */:
                url += "unread.ico";
                break;
            case 4 /* replied */:
                url += "reply.ico";
                break;
            case 2 /* error */:
                url += "error.ico";
                break;
            case 1 /* disconnected */:
                url = discoFavicon;
                break;
        }
        faviconEl.setAttribute("href", url);
    }
    // Account for immediate reconnection and only render favicon, if not
    // reconnected in few seconds.
    function delayedDiscoRender() {
        setTimeout(() => {
            if (connection_2.connSM.state === 5 /* dropped */ ||
                connection_2.connSM.state === 6 /* desynced */) {
                resolve();
            }
        }, 5000);
    }
    function onScroll() {
        if (recalcPending || document.hidden)
            return;
        recalcPending = true;
        setTimeout(recalc, 200);
    }
    // Update unseen post count based on post visibility and scroll
    // position.
    function postAdded(post) {
        // Async batch processing since visibility calculations force a
        // layout.
        if (!queue.length) {
            // Can't use RAF since it's disabled in background tabs.
            setTimeout(processQueue, 16);
        }
        queue.push(post);
    }
    exports.postAdded = postAdded;
    // Add unseen reply indicator to tab header.
    function repliedToMe(post) {
        if (!post.seen()) {
            unseenReplies = true;
            resolve();
        }
    }
    exports.repliedToMe = repliedToMe;
    function init() {
        connection_2.connSM.on(3 /* synced */, resolve);
        connection_2.connSM.on(5 /* dropped */, delayedDiscoRender);
        connection_2.connSM.on(6 /* desynced */, delayedDiscoRender);
        document.addEventListener("scroll", onScroll, { passive: true });
        document.addEventListener("visibilitychange", onScroll);
    }
    exports.init = init;
});
define("ts/ui/notification", ["require", "exports", "ts/base/index", "ts/lang/index", "ts/options/index", "ts/state/index", "ts/vars/index", "ts/ui/tab"], function (require, exports, base_2, lang_3, options_3, state_6, vars_3, tab_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    lang_3 = __importDefault(lang_3);
    options_3 = __importDefault(options_3);
    // Notify the user that one of their posts has been replied to.
    function notifyAboutReply(post) {
        // Ignore my replies to me (lol samefag).
        if (state_6.mine.has(post.id))
            return;
        // Check if already seen.
        if (post.seen())
            return;
        // Update favicon status;
        tab_1.repliedToMe(post);
        // Check if notifications are available.
        if (!options_3.default.notification ||
            typeof Notification !== "function" ||
            Notification.permission !== "granted")
            return;
        // Finally display sticky notification.
        let icon = "";
        if (!options_3.default.workModeToggle) {
            if (post.files) {
                icon = post.getFileByIndex(0).thumb;
            }
            else {
                icon = vars_3.DEFAULT_NOTIFICATION_IMAGE_URL;
            }
        }
        const n = new Notification(lang_3.default("quoted"), {
            body: post.body,
            icon,
            vibrate: true,
        });
        n.onclick = () => {
            n.close();
            window.focus();
            location.hash = "#" + post.id;
        };
    }
    exports.default = notifyAboutReply;
    // Textual notification at the top of the page
    // TODO(Kagami): Rework.
    class OverlayNotification extends base_2.View {
        constructor(text) {
            super({ el: null }); // importTemplate("notification").firstChild as HTMLElement });
            this.on("click", () => this.remove());
            this.el.querySelector("b").textContent = text;
            // overlay.prepend(this.el)
        }
    }
    exports.OverlayNotification = OverlayNotification;
});
define("ts/ui/faq", ["require", "exports", "ts/base/index"], function (require, exports, base_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    const faqTemplate = `
cutechan is licensed under the
<a href="https://www.gnu.org/licenses/agpl.html" target="_blank"
>GNU Affero General Public License</a>
<br>

source code repository:
<a href="https://github.com/cutechan/cutechan" target="_blank"
>github.com/cutechan/cutechan</a>
<br>

original project:
<a href="https://github.com/bakape/meguca" target="_blank"
>github.com/bakape/meguca</a>
<br>

contacts:
<a href="mailto:kagami@genshiken.org"
>kagami@genshiken.org</a>
`;
    class FAQPanel extends base_3.HeaderModal {
        constructor() {
            super(document.querySelector(".faq-modal"), document.querySelector(".header-faq-icon"));
        }
        showHook() {
            this.el.innerHTML = faqTemplate;
        }
    }
    exports.default = FAQPanel;
});
/**
 * Keyboard shortcuts handling.
 */
define("ts/ui/keyboard", ["require", "exports", "ts/options/index", "ts/state/index", "ts/util/index"], function (require, exports, options_4, state_7, util_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    options_4 = __importDefault(options_4);
    // Navigate one level up the board tree, if possible.
    function navigateUp() {
        if (state_7.page.thread) {
            location.href = `/${state_7.page.board}/`;
        }
        else if (state_7.page.board !== "all") {
            location.href = "/all/";
        }
        else {
            location.href = "/";
        }
    }
    function handleShortcut(e) {
        let caught = false;
        if (e.altKey) {
            switch (e.which) {
                case options_4.default.newPost:
                    caught = true;
                    util_8.trigger(0 /* openReply */);
                    break;
                case options_4.default.cancelPost:
                    caught = true;
                    util_8.trigger(1 /* closeReply */);
                    break;
                case options_4.default.selectFile:
                    caught = true;
                    util_8.trigger(5 /* selectFile */);
                    break;
                case options_4.default.previewPost:
                    caught = true;
                    util_8.trigger(6 /* previewPost */);
                    break;
                case options_4.default.bold:
                    caught = true;
                    util_8.trigger(7 /* boldMarkup */);
                    break;
                case options_4.default.italic:
                    caught = true;
                    util_8.trigger(8 /* italicMarkup */);
                    break;
                case options_4.default.spoiler:
                    caught = true;
                    util_8.trigger(9 /* spoilerMarkup */);
                    break;
                case options_4.default.idolSearch:
                    caught = true;
                    util_8.trigger(10 /* focusIdolSearch */);
                    break;
                case options_4.default.workMode:
                    caught = true;
                    options_4.default.workModeToggle = !options_4.default.workModeToggle;
                    break;
                case 38:
                    caught = true;
                    navigateUp();
                    break;
            }
        }
        else if (e.ctrlKey) {
            switch (e.key) {
                case "Enter":
                    caught = true;
                    util_8.trigger(2 /* sendReply */);
                    break;
            }
        }
        if (caught) {
            e.stopImmediatePropagation();
            e.preventDefault();
        }
    }
    // Bind keyboard event listener to the document.
    function init() {
        document.addEventListener("keydown", handleShortcut);
    }
    exports.init = init;
});
/**
 * Handle page navigation.
 */
define("ts/ui/nav", ["require", "exports", "ts/util/index", "ts/vars/index"], function (require, exports, util_9, vars_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    let recalcPending = false;
    let topBtn = null;
    let bottomBtn = null;
    function recalc() {
        const el = document.documentElement;
        const needTop = el.scrollTop > 300;
        const needBottom = el.scrollHeight - el.scrollTop > el.clientHeight + 300;
        topBtn.style.display = needTop ? "" : "none";
        bottomBtn.style.display = needBottom ? "" : "none";
        topBtn.classList.toggle("page-nav-item_active", needTop);
        bottomBtn.classList.toggle("page-nav-item_active", needBottom);
        recalcPending = false;
    }
    function onScroll() {
        if (recalcPending)
            return;
        recalcPending = true;
        setTimeout(recalc, 100);
    }
    function init() {
        topBtn = document.querySelector(vars_4.PAGE_NAV_TOP_SEL);
        bottomBtn = document.querySelector(vars_4.PAGE_NAV_BOTTOM_SEL);
        if (!topBtn || !bottomBtn)
            return;
        document.addEventListener("scroll", onScroll, { passive: true });
        util_9.on(document, "click", util_9.scrollToTop, { selector: vars_4.TRIGGER_PAGE_NAV_TOP_SEL });
        util_9.on(document, "click", util_9.scrollToBottom, {
            selector: vars_4.TRIGGER_PAGE_NAV_BOTTOM_SEL,
        });
        onScroll();
    }
    exports.init = init;
});
define("ts/ui/options", ["require", "exports", "ts/base/index", "ts/options/index", "ts/util/index"], function (require, exports, base_4, options_5, util_10) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    options_5 = __importStar(options_5);
    // View of the options panel
    class OptionsPanel extends base_4.TabbedModal {
        constructor() {
            super(document.querySelector(".options-modal"), document.querySelector(".header-options-icon"));
            exports.panel = this;
            this.on("change", (e) => this.applyChange(e));
            this.assignValues();
            util_10.hook("renderOptionValue", this.assignValue.bind(this));
        }
        // Assign loaded option settings to the respective elements in the options
        // panel
        assignValues() {
            for (const id of Object.keys(options_5.models)) {
                const model = options_5.models[id];
                const val = model.get();
                this.assignValue(id, model.spec.type, val);
            }
        }
        // Assign a single option value. Called on changes to the options externally
        // not from the options panel
        assignValue(id, type, val) {
            const el = document.getElementById(id);
            if (!el)
                return;
            switch (type) {
                case 0 /* checkbox */:
                    el.checked = val;
                    break;
                case 1 /* number */:
                case 4 /* menu */:
                case 5 /* textarea */:
                    el.value = val || "";
                    break;
                case 3 /* shortcut */:
                    el.value = String.fromCodePoint(val).toUpperCase();
                    break;
            }
            // 'image' type simply falls through, as those don't need to be set
        }
        // Propagate options panel changes through
        // options-panel -> options -> OptionModel
        applyChange(event) {
            const el = event.target;
            const id = el.getAttribute("id");
            const model = options_5.models[id];
            // Not an option input element
            if (!model) {
                return;
            }
            let val;
            switch (model.spec.type) {
                case 0 /* checkbox */:
                    val = el.checked;
                    break;
                case 1 /* number */:
                    val = parseInt(el.value, 10);
                    break;
                case 4 /* menu */:
                case 5 /* textarea */:
                    val = el.value;
                    break;
                case 3 /* shortcut */:
                    val = el.value.toUpperCase().codePointAt(0);
                    break;
            }
            if (!model.validate(val)) {
                el.value = "";
            }
            else {
                options_5.default[id] = val;
            }
        }
    }
    exports.default = OptionsPanel;
});
define("ts/ui/index", ["require", "exports", "ts/ui/forms", "ts/ui/tab", "ts/ui/notification", "ts/state/index", "ts/ui/faq", "ts/ui/keyboard", "ts/ui/nav", "ts/ui/options", "ts/ui/tab"], function (require, exports, forms_1, tab_2, notification_1, state_8, faq_1, keyboard_1, nav_1, options_6, tab_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    faq_1 = __importDefault(faq_1);
    options_6 = __importDefault(options_6);
    exports.FormView = forms_1.default;
    exports.postAdded = tab_2.postAdded;
    exports.notifyAboutReply = notification_1.default;
    exports.OverlayNotification = notification_1.OverlayNotification;
    function init() {
        keyboard_1.init();
        nav_1.init();
        if (state_8.page.thread) {
            tab_3.init();
        }
        // tslint:disable-next-line:no-unused-expression
        new faq_1.default();
        // tslint:disable-next-line:no-unused-expression
        new options_6.default();
    }
    exports.init = init;
});
define("ts/posts/collection", ["require", "exports", "ts/base/index"], function (require, exports, base_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    /** Holds a collection of Post models. */
    class PostCollection extends base_5.Model {
        constructor() {
            super();
            this.models = {};
        }
        /** Return weather a post exists in the collection. */
        has(id) {
            return id in this.models;
        }
        /** Retrieve a model by its ID. */
        get(id) {
            return this.models[id];
        }
        /** Add model to the collection. */
        add(model) {
            model.collection = this;
            this.models[model.id] = model;
        }
        /** Remove model from the collection. */
        remove(model) {
            delete model.collection;
            delete this.models[model.id];
        }
        /** Remove all related models from the collection. */
        removeThread(opModel) {
            for (const model of this) {
                if (model.op === opModel.id) {
                    this.remove(model);
                }
            }
        }
        /** Remove all models from the collection. */
        clear() {
            for (const model of this) {
                delete model.collection;
            }
            this.models = {};
        }
        /** Return all models. */
        all() {
            return Object.keys(this.models).map((id) => this.models[id]);
        }
        /** Make collection iterable. */
        *[Symbol.iterator]() {
            yield* this.all();
        }
    }
    exports.default = PostCollection;
});
define("ts/posts/images", ["require", "exports", "ts/common/index", "ts/state/index"], function (require, exports, common_1, state_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function getFilePrefix() {
        return state_9.config.imageRootOverride || "/uploads";
    }
    exports.getFilePrefix = getFilePrefix;
    // Get the thumbnail path of an image.
    function thumbPath(thumbType, sha1) {
        return `${getFilePrefix()}/thumb/${sha1.slice(0, 2)}/${sha1.slice(2)}.${common_1.fileTypes[thumbType]}`;
    }
    exports.thumbPath = thumbPath;
    // Resolve the path to the source file of an upload.
    function sourcePath(fileType, sha1) {
        return `${getFilePrefix()}/src/${sha1.slice(0, 2)}/${sha1.slice(2)}.${common_1.fileTypes[fileType]}`;
    }
    exports.sourcePath = sourcePath;
});
/** Template structs, helper routines and context providers. */
// MUST BE KEPT IN SYNC WITH go/src/meguca/templates/isomorph.go!
define("ts/templates/isomorph", ["require", "exports", "cc-templates", "mustache", "ts/templates/index", "ts/common/index", "ts/lang/index", "ts/posts/index", "ts/state/index", "ts/util/index"], function (require, exports, cc_templates_1, mustache_1, _1, common_2, lang_4, posts_3, state_10, util_11) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    cc_templates_1 = __importDefault(cc_templates_1);
    mustache_1 = __importDefault(mustache_1);
    class TemplateContext {
        constructor(name, ctx) {
            this.template = cc_templates_1.default[name];
            this.ctx = ctx;
        }
        render() {
            return mustache_1.default.render(this.template, this.ctx);
        }
        renderNode() {
            return util_11.makeNode(this.render());
        }
    }
    exports.TemplateContext = TemplateContext;
    function makePostContext(t, p, bls, index, all) {
        const ctx = {
            ID: p.id,
            TID: t.id,
            Index: index,
            OP: t.id === p.id,
            HasBoard: t.id === p.id && index && all,
            Board: p.board,
            Subject: p.subject,
            Badge: !!p.auth,
            Auth: lang_4._(p.auth),
            Name: p.userName,
            HasFiles: !!p.files,
            post: p,
            backlinks: bls,
        };
        ctx.PostClass = () => {
            const classes = ["post"];
            if (ctx.OP) {
                classes.push("post_op");
            }
            if (ctx.post.files) {
                classes.push("post_file");
                if (ctx.post.files.length > 1) {
                    classes.push("post_files");
                }
            }
            for (const provider of Object.keys(_1.bodyEmbeds)) {
                if (_1.bodyEmbeds[provider].test(ctx.post.body)) {
                    classes.push("post_embed");
                    break;
                }
            }
            if (!p.userID) {
                classes.push("post_by-anon");
            }
            else {
                const src = unescape(encodeURIComponent(p.userID));
                const id = btoa(src).replace(/=+$/, "");
                classes.push("post_by-" + id);
            }
            return classes.join(" ");
        };
        ctx.URL = () => {
            let url = "";
            if (!ctx.OP) {
                url = `#${ctx.ID}`;
            }
            if (ctx.Index) {
                url = `/${ctx.Board}/${ctx.TID}${url}`;
            }
            return url;
        };
        // NOOP because we need to re-render based on relativeTime setting.
        ctx.Time = "";
        ctx.Files = (p.files || []).map((img, n) => new TemplateContext("post-file", {
            SHA1: img.SHA1,
            HasTitle: !!img.title,
            LCopy: lang_4._("clickToCopy"),
            Title: img.title,
            HasVideo: img.video,
            HasAudio: img.audio,
            HasLength: img.video || img.audio,
            Length: duration(img.length || 0),
            Record: img.audio && !img.video,
            Size: fileSize(img.size),
            Width: img.dims[0],
            Height: img.dims[1],
            TWidth: img.dims[2],
            THeight: img.dims[3],
            DName: getDownloadName(p, img, n),
            SourcePath: posts_3.sourcePath(img.fileType, img.SHA1),
            ThumbPath: posts_3.thumbPath(img.thumbType, img.SHA1),
        }).render());
        ctx.Body = _1.renderBody(p);
        // NOOP because we will need to update already rendered posts so avoid
        // code duplication.
        ctx.Backlinks = "";
        return new TemplateContext("post", ctx);
    }
    exports.makePostContext = makePostContext;
    function getDownloadName(post, img, n) {
        const numStr = n > 0 ? `(${n + 1})` : "";
        return `${post.board}-${post.id}${numStr}.${common_2.fileTypes[img.fileType]}`;
    }
    // Renders classic absolute timestamp.
    function readableTime(time) {
        const d = new Date(time * 1000);
        return (`${util_11.pad(d.getDate())} ${lang_4._(lang_4.months[d.getMonth()])} ` +
            `${d.getFullYear()} (${lang_4._(lang_4.days[d.getDay()])}) ` +
            `${util_11.pad(d.getHours())}:${util_11.pad(d.getMinutes())}`);
    }
    exports.readableTime = readableTime;
    function duration(l) {
        return util_11.pad(Math.floor(l / 60)) + ":" + util_11.pad(Math.floor(l % 60));
    }
    exports.duration = duration;
    // Formats a human-readable representation of file size.
    function fileSize(size) {
        if (size < 1024) {
            return size + lang_4._("b");
        }
        else if (size < 1024 * 1024) {
            return (size / 1024).toFixed(2) + lang_4._("kb");
        }
        else {
            return (size / 1024 / 1024).toFixed(2) + lang_4._("mb");
        }
    }
    exports.fileSize = fileSize;
    // Render a link to other post.
    function renderPostLink(id, cross, index) {
        const url = `${cross || index ? `/all/${id}` : ""}#${id}`;
        return new TemplateContext("post-link", {
            Cross: cross,
            ID: id,
            LYou: lang_4._("you"),
            Mine: state_10.mine.has(id),
            URL: url,
        }).render();
    }
    exports.renderPostLink = renderPostLink;
    // Renders readable elapsed time since post. Numbers are in seconds.
    function relativeTime(then) {
        const now = Math.floor(Date.now() / 1000);
        let time = Math.floor((now - then) / 60);
        let isFuture = false;
        if (time < 1) {
            if (time > -5) {
                // Assume to be client clock imprecision
                return lang_4._("justNow");
            }
            else {
                isFuture = true;
                time = -time;
            }
        }
        const divide = [60, 24, 30, 12];
        const unit = ["minute", "hour", "day", "month"];
        const unitPlural = ["minutes", "hours", "days", "months"];
        for (let i = 0; i < divide.length; i++) {
            if (time < divide[i]) {
                return ago(unit[i], unitPlural[i], time, isFuture);
            }
            time = Math.floor(time / divide[i]);
        }
        return ago("year", "years", time, isFuture);
    }
    exports.relativeTime = relativeTime;
    // Renders "56 minutes ago" or "in 56 minutes" like relative time text.
    function ago(msgid1, msgid2, time, isFuture) {
        const unit = lang_4.ngettext(msgid1, msgid2, time);
        return isFuture
            ? util_11.printf(lang_4._("in %s %s"), time, unit)
            : util_11.printf(lang_4._("%s %s ago"), time, unit);
    }
});
define("smiles-pp/smiles", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // AUTOGENERATED, DO NOT EDIT
    exports.default = new Set(["arin_cute", "arin_lol", "arin_plsno", "arin_smile", "arin_susp", "asuka_sad", "autism", "beast", "bell_sad", "bibi_smile", "bibi_smug", "bibi_think", "bin_feels", "bin_happy", "bin_sad", "bin_smile", "bin_supersad", "bomi_hnng", "bona_cry", "bona_cute", "bona_disgust", "booba", "cha_angry", "cha_drink", "cha_fing", "cha_hnng", "cha_satisfied", "cha_shh", "cha_smile", "cha_sulk", "cha_wut", "chae_dead", "chaer_shy", "chaer_sulk", "chen_lol", "chen_smile", "chen_sulk", "chips", "choaoa_cry", "choaoa_smile", "choaoa_susp", "choaoa_wut", "choerry_eat", "chungha_lol", "chuu_angry", "chuu_wut", "cigarette", "cola", "cool", "dahyun_angry", "dahyun_dab", "dahyun_pray", "dahyun_scream", "dana_sad", "doah_sulk", "doyeon_lol", "elk_hey", "elk_lol", "elk_smile", "eunbin_sulk", "eunbin_wut", "eunbin_wut2", "eunha_wut", "euns_angry", "euns_cute", "euns_dead", "euns_lol", "euns_smile", "euns_wut", "exy_tired", "goose", "gun", "gun2", "hani_sad", "hayoung_pray", "hayoung_wut", "heart", "heart2", "heart3", "heart4", "heechul", "heejin_wut", "hyejeong_wut", "hyeri_cute", "hyperlol", "hyperlol2", "hyuna_lol", "hyunjin_gasm", "hyunjin_smilewink", "hyunsuk", "hyunyoung_wut", "irene_palm", "irene_wut", "isa_lol", "iu_susp", "iu_think", "iu_wut", "jane_sad", "jennie_disgust", "jennie_gasm", "jiae_welp", "jisoo_drink", "jisoo_wut", "jiwon_smile", "jooe_wut", "jyp", "jyp2", "kei_wut", "knife", "kyul_grr", "kyul_sad", "kyul_scream", "kyul_smile", "kyul_susp", "kyul_vom", "kyungri_smile", "lookup", "luda_angry", "luda_boring", "luda_lol", "luda_sulk", "meiqi_sad", "meiqi_smug", "mijoo_boring", "mijoo_cool", "mijoo_sulk", "mimi_smile", "mina_lol", "minaoa", "minaoa_sad", "minaoa_wut", "naky_cool", "nancy_disgust", "nancy_happy", "nancy_lewdsmile", "nancy_lol", "nancy_sad", "nancy_smile", "nancy_sulk", "nancy_susp", "nancy_wut", "nay_cool", "nay_lol", "nay_nice", "nay_scream", "nay_smile", "nay_stone", "nay_susp", "nogoose", "nunu_angry", "nunu_boring", "nunu_cry", "nunu_gasm", "nunu_grr", "nunu_heart", "nunu_lol", "nunu_palm", "nunu_sad", "nunu_smart", "nunu_susp", "nunu_teehee", "nunu_think", "nunu_think2", "nunu_wut", "orly", "plsno", "police", "ramyun", "rena_angry", "rena_shh", "roa_boring", "roa_cry", "roa_disgust", "roa_hey", "roa_pray", "roa_shh", "sana_dumb", "sana_pray", "sej_angry", "sej_hey", "sekshie", "sekshie2", "seohyun_sulk", "seoy_happy", "seoy_welp", "seul_cute", "seul_disgust", "seul_fear", "seul_lol", "seul_pain", "seul_shh", "seul_smart", "seul_welp", "seul_wut", "seul_yessir", "shinhye_cry", "shu_heart", "shu_welp", "shy", "sihy_happy", "soh_lol", "soh_think", "soju", "som_angry", "som_why", "som_wut", "sooman", "tae_disgust", "tae_smile", "tae_smile2", "tellmemore", "wend_susp", "wendy_scream", "wine", "winter_welp", "wony_disgust", "wony_lol", "wony_neutral", "wony_phew", "woohee_why", "xi_happy", "xi_scream", "yeha_nice", "yein_boring", "yein_cry", "yein_sad", "yein_smart", "yein_smile", "yein_smilewink", "yein_wut", "yein_wut2", "yeji_lol", "yena_tired", "yeonjung_lol", "yeonwoo_angry", "yeonwoo_cry", "yeonwoo_lol", "yeonwoo_sad", "yeonwoo_smile", "yeonwoo_sulk", "yeonwoo_think", "yeonwoo_tired", "yeonwoo_why", "yeonwoo_wut", "yeri_angry", "yoona_cry", "yoona_wut", "yuji_bday", "yuji_cool", "yuju_lol", "yuju_smart", "yuna_sulk", "yuqi_cool", "yuqi_neutral", "yuqi_shy"]);
});
/**
 * marked - a markdown parser
 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/chjj/marked
 */
define("ts/templates/marked", ["require", "exports", "smiles-pp/smiles"], function (require, exports, smiles_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    smiles_1 = __importDefault(smiles_1);
    /**
     * Block-Level Grammar
     */
    var block = {
        newline: /^\n+/,
        code: /^( {4}[^\n]+\n*)+/,
        fences: noop,
        hr: /^( *[-*_]){3,} *(?:\n+|$)/,
        heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
        nptable: noop,
        lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
        blockquote: /^( *>[^>\n][^\n]*)/,
        list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
        html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,
        table: noop,
        paragraph: /^((?:[^\n]+?(?!hr|heading|lheading|blockquote|tag|def))+)/,
        text: /^[^\n]+/
    };
    block.bullet = /\*/;
    block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;
    block.item = replace(block.item, 'gm')(/bull/g, block.bullet)();
    block.list = replace(block.list)(/bull/g, block.bullet)('hr', '\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))')('def', '\\n+(?=' + block.def.source + ')')();
    block.blockquote = replace(block.blockquote)('def', block.def)();
    block._tag = '(?!(?:'
        + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code'
        + '|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo'
        + '|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b';
    block.html = replace(block.html)('comment', /<!--[\s\S]*?-->/)('closed', /<(tag)[\s\S]+?<\/\1>/)('closing', /<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g, block._tag)();
    block.paragraph = replace(block.paragraph)('hr', block.hr)('heading', block.heading)('lheading', block.lheading)('blockquote', block.blockquote)('tag', '<' + block._tag)('def', block.def)();
    /**
     * Normal Block Grammar
     */
    block.normal = merge({}, block);
    /**
     * GFM Block Grammar
     */
    block.gfm = merge({}, block.normal, {
        fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,
        paragraph: /^/,
        heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
    });
    block.gfm.paragraph = replace(block.paragraph)('(?!', '(?!'
        + block.gfm.fences.source.replace('\\1', '\\2') + '|'
        + block.list.source.replace('\\1', '\\3') + '|')();
    /**
     * GFM + Tables Block Grammar
     */
    block.tables = merge({}, block.gfm, {
        nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
        table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
    });
    /**
     * Block Lexer
     */
    function Lexer(options) {
        this.tokens = [];
        this.tokens.links = {};
        this.options = options || marked.defaults;
        this.rules = block.normal;
        if (this.options.gfm) {
            if (this.options.tables) {
                this.rules = block.tables;
            }
            else {
                this.rules = block.gfm;
            }
        }
    }
    /**
     * Expose Block Rules
     */
    Lexer.rules = block;
    /**
     * Static Lex Method
     */
    Lexer.lex = function (src, options) {
        var lexer = new Lexer(options);
        return lexer.lex(src);
    };
    /**
     * Preprocessing
     */
    Lexer.prototype.lex = function (src) {
        src = src
            .replace(/\r\n|\r/g, '\n')
            .replace(/\t/g, '    ')
            .replace(/\u00a0/g, ' ')
            .replace(/\u2424/g, '\n');
        return this.token(src, true);
    };
    /**
     * Lexing
     */
    Lexer.prototype.token = function (src, top, bq) {
        var src = src.replace(/^ +$/gm, ''), next, loose, cap, bull, b, item, space, i, l;
        while (src) {
            // newline
            if (cap = this.rules.newline.exec(src)) {
                src = src.substring(cap[0].length);
                if (cap[0].length > 1) {
                    this.tokens.push({
                        type: 'space'
                    });
                }
            }
            // code
            if (cap = this.rules.code.exec(src)) {
                src = src.substring(cap[0].length);
                cap = cap[0].replace(/^ {4}/gm, '');
                this.tokens.push({
                    type: 'code',
                    text: !this.options.pedantic
                        ? cap.replace(/\n+$/, '')
                        : cap
                });
                continue;
            }
            // fences (gfm)
            if (cap = this.rules.fences.exec(src)) {
                src = src.substring(cap[0].length);
                this.tokens.push({
                    type: 'code',
                    lang: cap[2],
                    text: cap[3] || ''
                });
                continue;
            }
            // heading
            if (cap = this.rules.heading.exec(src)) {
                src = src.substring(cap[0].length);
                this.tokens.push({
                    type: 'heading',
                    depth: cap[1].length,
                    text: cap[2]
                });
                continue;
            }
            // table no leading pipe (gfm)
            if (top && (cap = this.rules.nptable.exec(src))) {
                src = src.substring(cap[0].length);
                item = {
                    type: 'table',
                    header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
                    align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
                    cells: cap[3].replace(/\n$/, '').split('\n')
                };
                for (i = 0; i < item.align.length; i++) {
                    if (/^ *-+: *$/.test(item.align[i])) {
                        item.align[i] = 'right';
                    }
                    else if (/^ *:-+: *$/.test(item.align[i])) {
                        item.align[i] = 'center';
                    }
                    else if (/^ *:-+ *$/.test(item.align[i])) {
                        item.align[i] = 'left';
                    }
                    else {
                        item.align[i] = null;
                    }
                }
                for (i = 0; i < item.cells.length; i++) {
                    item.cells[i] = item.cells[i].split(/ *\| */);
                }
                this.tokens.push(item);
                continue;
            }
            // lheading
            if (cap = this.rules.lheading.exec(src)) {
                src = src.substring(cap[0].length);
                this.tokens.push({
                    type: 'heading',
                    depth: cap[2] === '=' ? 1 : 2,
                    text: cap[1]
                });
                continue;
            }
            // hr
            if (cap = this.rules.hr.exec(src)) {
                src = src.substring(cap[0].length);
                this.tokens.push({
                    type: 'hr'
                });
                continue;
            }
            // blockquote
            if (cap = this.rules.blockquote.exec(src)) {
                src = src.substring(cap[0].length);
                this.tokens.push({
                    type: 'blockquote_start'
                });
                cap = cap[0].replace(/^ *> ?/gm, '');
                // Pass `top` to keep the current
                // "toplevel" state. This is exactly
                // how markdown.pl works.
                this.token(cap, top, true);
                this.tokens.push({
                    type: 'blockquote_end'
                });
                continue;
            }
            // list
            if (cap = this.rules.list.exec(src)) {
                src = src.substring(cap[0].length);
                bull = cap[2];
                this.tokens.push({
                    type: 'list_start',
                    ordered: bull.length > 1
                });
                // Get each top-level item.
                cap = cap[0].match(this.rules.item);
                next = false;
                l = cap.length;
                i = 0;
                for (; i < l; i++) {
                    item = cap[i];
                    // Remove the list item's bullet
                    // so it is seen as the next token.
                    space = item.length;
                    item = item.replace(/^ *([*+-]|\d+\.) +/, '');
                    // Outdent whatever the
                    // list item contains. Hacky.
                    if (~item.indexOf('\n ')) {
                        space -= item.length;
                        item = !this.options.pedantic
                            ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '')
                            : item.replace(/^ {1,4}/gm, '');
                    }
                    // Determine whether the next list item belongs here.
                    // Backpedal if it does not belong in this list.
                    if (this.options.smartLists && i !== l - 1) {
                        b = block.bullet.exec(cap[i + 1])[0];
                        if (bull !== b && !(bull.length > 1 && b.length > 1)) {
                            src = cap.slice(i + 1).join('\n') + src;
                            i = l - 1;
                        }
                    }
                    // Determine whether item is loose or not.
                    // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
                    // for discount behavior.
                    loose = true || next || /\n\n(?!\s*$)/.test(item);
                    if (i !== l - 1) {
                        next = item.charAt(item.length - 1) === '\n';
                        if (!loose)
                            loose = next;
                    }
                    this.tokens.push({
                        type: loose
                            ? 'loose_item_start'
                            : 'list_item_start'
                    });
                    // Recurse.
                    this.token(item, false, bq);
                    this.tokens.push({
                        type: 'list_item_end'
                    });
                }
                this.tokens.push({
                    type: 'list_end'
                });
                continue;
            }
            // html
            if (cap = this.rules.html.exec(src)) {
                src = src.substring(cap[0].length);
                this.tokens.push({
                    type: this.options.sanitize
                        ? 'paragraph'
                        : 'html',
                    pre: !this.options.sanitizer
                        && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
                    text: cap[0]
                });
                continue;
            }
            // def
            if ((!bq && top) && (cap = this.rules.def.exec(src))) {
                src = src.substring(cap[0].length);
                this.tokens.links[cap[1].toLowerCase()] = {
                    href: cap[2],
                    title: cap[3]
                };
                continue;
            }
            // table (gfm)
            if (top && (cap = this.rules.table.exec(src))) {
                src = src.substring(cap[0].length);
                item = {
                    type: 'table',
                    header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
                    align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
                    cells: cap[3].replace(/(?: *\| *)?\n$/, '').split('\n')
                };
                for (i = 0; i < item.align.length; i++) {
                    if (/^ *-+: *$/.test(item.align[i])) {
                        item.align[i] = 'right';
                    }
                    else if (/^ *:-+: *$/.test(item.align[i])) {
                        item.align[i] = 'center';
                    }
                    else if (/^ *:-+ *$/.test(item.align[i])) {
                        item.align[i] = 'left';
                    }
                    else {
                        item.align[i] = null;
                    }
                }
                for (i = 0; i < item.cells.length; i++) {
                    item.cells[i] = item.cells[i]
                        .replace(/^ *\| *| *\| *$/g, '')
                        .split(/ *\| */);
                }
                this.tokens.push(item);
                continue;
            }
            // top-level paragraph
            if (top && (cap = this.rules.paragraph.exec(src))) {
                src = src.substring(cap[0].length);
                this.tokens.push({
                    type: 'paragraph',
                    text: cap[1].charAt(cap[1].length - 1) === '\n'
                        ? cap[1].slice(0, -1)
                        : cap[1]
                });
                continue;
            }
            // text
            if (cap = this.rules.text.exec(src)) {
                // Top-level should never reach here.
                src = src.substring(cap[0].length);
                this.tokens.push({
                    type: 'text',
                    text: cap[0]
                });
                continue;
            }
            if (src) {
                throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
            }
        }
        return this.tokens;
    };
    /**
     * Inline-Level Grammar
     */
    var inline = {
        escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
        autolink: /^<([^ >]+(@|:\/)[^ >]+)>/,
        url: noop,
        tag: /^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,
        link: /^!?\[(inside)\]\(href\)/,
        reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
        nolink: /^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
        strong: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
        em: /^\b_((?:[^_]|__)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,
        code: /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,
        br: /^ {2,}\n(?!\s*$)/,
        del: noop,
        smile: /^:([a-z0-9_]+):/,
        command: /^!(roll(?:0|[1-9][0-9]?)-[1-9][0-9]?[0-9]?|flip[1-9][0-9]?%)/,
        text: /^[\s\S]+?(?=[\\<!\[_*`:]| {2,}\n|$)/
    };
    inline._inside = /(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;
    inline._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;
    inline.link = replace(inline.link)('inside', inline._inside)('href', inline._href)();
    inline.reflink = replace(inline.reflink)('inside', inline._inside)();
    /**
     * Normal Inline Grammar
     */
    inline.normal = merge({}, inline);
    /**
     * Pedantic Inline Grammar
     */
    inline.pedantic = merge({}, inline.normal, {
        strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
        em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
    });
    /**
     * GFM Inline Grammar
     */
    inline.gfm = merge({}, inline.normal, {
        escape: replace(inline.escape)('])', '~|])')(),
        url: /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
        del: /^~~(?=\S)([\s\S]*?\S)~~/,
        text: replace(inline.text)(']|', '~]|')('|', '|https?://|')()
    });
    /**
     * GFM + Line Breaks Inline Grammar
     */
    inline.breaks = merge({}, inline.gfm, {
        br: replace(inline.br)('{2,}', '*')(),
        text: replace(inline.gfm.text)('{2,}', '*')()
    });
    /**
     * Inline Lexer & Compiler
     */
    function InlineLexer(links, options) {
        this.options = options || marked.defaults;
        this.links = links;
        this.rules = inline.normal;
        this.renderer = this.options.renderer || new Renderer;
        this.renderer.options = this.options;
        if (!this.links) {
            throw new Error('Tokens array requires a `links` property.');
        }
        if (this.options.gfm) {
            if (this.options.breaks) {
                this.rules = inline.breaks;
            }
            else {
                this.rules = inline.gfm;
            }
        }
        else if (this.options.pedantic) {
            this.rules = inline.pedantic;
        }
    }
    /**
     * Expose Inline Rules
     */
    InlineLexer.rules = inline;
    /**
     * Static Lexing/Compiling Method
     */
    InlineLexer.output = function (src, links, options) {
        var inline = new InlineLexer(links, options);
        return inline.output(src);
    };
    /**
     * Lexing/Compiling
     */
    InlineLexer.prototype.output = function (src) {
        var out = '', link, text, href, cap;
        while (src) {
            // escape
            if (cap = this.rules.escape.exec(src)) {
                src = src.substring(cap[0].length);
                out += cap[1];
                continue;
            }
            // autolink
            if (cap = this.rules.autolink.exec(src)) {
                src = src.substring(cap[0].length);
                if (cap[2] === '@') {
                    text = cap[1].charAt(6) === ':'
                        ? this.mangle(cap[1].substring(7))
                        : this.mangle(cap[1]);
                    href = this.mangle('mailto:') + text;
                }
                else {
                    text = escape(cap[1]);
                    href = text;
                }
                out += this.renderer.link(href, null, text);
                continue;
            }
            // url (gfm)
            if (!this.inLink && (cap = this.rules.url.exec(src))) {
                src = src.substring(cap[0].length);
                text = escape(cap[1]);
                href = text;
                out += this.renderer.link(href, null, text);
                continue;
            }
            // tag
            if (cap = this.rules.tag.exec(src)) {
                if (!this.inLink && /^<a /i.test(cap[0])) {
                    this.inLink = true;
                }
                else if (this.inLink && /^<\/a>/i.test(cap[0])) {
                    this.inLink = false;
                }
                src = src.substring(cap[0].length);
                out += this.options.sanitize
                    ? this.options.sanitizer
                        ? this.options.sanitizer(cap[0])
                        : escape(cap[0])
                    : cap[0];
                continue;
            }
            // link
            if (cap = this.rules.link.exec(src)) {
                src = src.substring(cap[0].length);
                this.inLink = true;
                out += this.outputLink(cap, {
                    href: cap[2],
                    title: cap[3]
                });
                this.inLink = false;
                continue;
            }
            // reflink, nolink
            if ((cap = this.rules.reflink.exec(src))
                || (cap = this.rules.nolink.exec(src))) {
                src = src.substring(cap[0].length);
                link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
                link = this.links[link.toLowerCase()];
                if (!link || !link.href) {
                    out += cap[0].charAt(0);
                    src = cap[0].substring(1) + src;
                    continue;
                }
                this.inLink = true;
                out += this.outputLink(cap, link);
                this.inLink = false;
                continue;
            }
            // strong
            if (cap = this.rules.strong.exec(src)) {
                src = src.substring(cap[0].length);
                out += this.renderer.strong(this.output(cap[2] || cap[1]));
                continue;
            }
            // em
            if (cap = this.rules.em.exec(src)) {
                src = src.substring(cap[0].length);
                out += this.renderer.em(this.output(cap[2] || cap[1]));
                continue;
            }
            // code
            if (cap = this.rules.code.exec(src)) {
                src = src.substring(cap[0].length);
                out += this.renderer.codespan(escape(cap[2], true));
                continue;
            }
            // br
            if (cap = this.rules.br.exec(src)) {
                src = src.substring(cap[0].length);
                out += this.renderer.br();
                continue;
            }
            // del (gfm)
            if (cap = this.rules.del.exec(src)) {
                src = src.substring(cap[0].length);
                out += this.renderer.del(this.output(cap[1]));
                continue;
            }
            // smile (cutechan)
            if (cap = this.rules.smile.exec(src)) {
                if (smiles_1.default.has(cap[1])) {
                    src = src.substring(cap[0].length);
                    out += this.renderer.smile(cap[1]);
                    continue;
                }
            }
            // command (cutechan)
            if (cap = this.rules.command.exec(src)) {
                src = src.substring(cap[0].length);
                out += this.renderer.command(cap[0], cap[1].slice(0, 4), cap[1].slice(4));
                continue;
            }
            // text
            if (cap = this.rules.text.exec(src)) {
                src = src.substring(cap[0].length);
                out += this.renderer.text(escape(this.smartypants(cap[0])));
                continue;
            }
            if (src) {
                throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
            }
        }
        return out;
    };
    /**
     * Compile Link
     */
    InlineLexer.prototype.outputLink = function (cap, link) {
        var href = escape(link.href), title = link.title ? escape(link.title) : null;
        return this.renderer.link(href, title, this.output(cap[1]));
    };
    /**
     * Smartypants Transformations
     */
    InlineLexer.prototype.smartypants = function (text) {
        if (!this.options.smartypants)
            return text;
        return text
            // em-dashes
            .replace(/---/g, '\u2014')
            // en-dashes
            .replace(/--/g, '\u2013')
            // opening singles
            .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
            // closing singles & apostrophes
            .replace(/'/g, '\u2019')
            // opening doubles
            .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
            // closing doubles
            .replace(/"/g, '\u201d')
            // ellipses
            .replace(/\.{3}/g, '\u2026');
    };
    /**
     * Mangle Links
     */
    InlineLexer.prototype.mangle = function (text) {
        if (!this.options.mangle)
            return text;
        var out = '', l = text.length, i = 0, ch;
        for (; i < l; i++) {
            ch = text.charCodeAt(i);
            if (Math.random() > 0.5) {
                ch = 'x' + ch.toString(16);
            }
            out += '&#' + ch + ';';
        }
        return out;
    };
    /**
     * Renderer
     */
    function Renderer(options) {
        this.options = options || {};
    }
    Renderer.prototype.code = function (code, lang, escaped) {
        if (this.options.highlight) {
            var out = this.options.highlight(code, lang);
            if (out != null && out !== code) {
                escaped = true;
                code = out;
            }
        }
        if (!lang) {
            return '<pre><code>'
                + (escaped ? code : escape(code, true))
                + '\n</code></pre>';
        }
        return '<pre><code class="'
            + this.options.langPrefix
            + escape(lang, true)
            + '">'
            + (escaped ? code : escape(code, true))
            + '\n</code></pre>\n';
    };
    Renderer.prototype.blockquote = function (quote) {
        return '<blockquote>\n' + quote + '</blockquote>\n';
    };
    Renderer.prototype.html = function (html) {
        return html;
    };
    Renderer.prototype.heading = function (text, level, raw) {
        return '<h'
            + level
            + ' id="'
            + this.options.headerPrefix
            + raw.toLowerCase().replace(/[^\w]+/g, '-')
            + '">'
            + text
            + '</h'
            + level
            + '>\n';
    };
    Renderer.prototype.hr = function () {
        return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
    };
    Renderer.prototype.list = function (body, ordered) {
        var type = ordered ? 'ol' : 'ul';
        return '<' + type + '>\n' + body + '</' + type + '>\n';
    };
    Renderer.prototype.listitem = function (text) {
        return '<li>' + text + '</li>\n';
    };
    Renderer.prototype.paragraph = function (text) {
        return '<p>' + text + '</p>\n';
    };
    Renderer.prototype.table = function (header, body) {
        return '<table>\n'
            + '<thead>\n'
            + header
            + '</thead>\n'
            + '<tbody>\n'
            + body
            + '</tbody>\n'
            + '</table>\n';
    };
    Renderer.prototype.tablerow = function (content) {
        return '<tr>\n' + content + '</tr>\n';
    };
    Renderer.prototype.tablecell = function (content, flags) {
        var type = flags.header ? 'th' : 'td';
        var tag = flags.align
            ? '<' + type + ' style="text-align:' + flags.align + '">'
            : '<' + type + '>';
        return tag + content + '</' + type + '>\n';
    };
    // span level renderer
    Renderer.prototype.strong = function (text) {
        return '<strong>' + text + '</strong>';
    };
    Renderer.prototype.em = function (text) {
        return '<em>' + text + '</em>';
    };
    Renderer.prototype.codespan = function (text) {
        return '<code>' + text + '</code>';
    };
    Renderer.prototype.br = function () {
        return this.options.xhtml ? '<br/>' : '<br>';
    };
    Renderer.prototype.del = function (text) {
        return '<del>' + text + '</del>';
    };
    Renderer.prototype.smile = function (id) {
        return `<i class="smile smile-${id}" title=":${id}:"></i>`;
    };
    Renderer.prototype.command = function (text, c, q) {
        if (!this.commands || this.cmdi >= this.commands.length)
            return escape(text);
        const cmd = this.commands[this.cmdi];
        switch (c) {
            case "roll":
                this.cmdi++;
                return `<i class="fa fa-cube post-command post-roll-command"` +
                    `title="${text}"> ${cmd.val} (${q})</i>`;
            case "flip":
                this.cmdi++;
                return `<i class="fa fa-cube post-command post-flip-command ` +
                    `post-flip-command_${cmd.val ? "hit" : "miss"}"` +
                    `title="${text}"> ${q}</i>`;
        }
    };
    Renderer.prototype.link = function (href, title, text) {
        if (this.options.sanitize) {
            try {
                var prot = decodeURIComponent(unescape(href))
                    .replace(/[^\w:]/g, '')
                    .toLowerCase();
            }
            catch (e) {
                return '';
            }
            if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0) {
                return '';
            }
        }
        var out = '<a href="' + href + '"';
        if (title) {
            out += ' title="' + title + '"';
        }
        out += '>' + text + '</a>';
        return out;
    };
    Renderer.prototype.image = function (href, title, text) {
        var out = '<img src="' + href + '" alt="' + text + '"';
        if (title) {
            out += ' title="' + title + '"';
        }
        out += this.options.xhtml ? '/>' : '>';
        return out;
    };
    Renderer.prototype.text = function (text) {
        return text;
    };
    /**
     * Parsing & Compiling
     */
    function Parser(options) {
        this.tokens = [];
        this.token = null;
        this.options = options || marked.defaults;
        this.options.renderer = this.options.renderer || new Renderer;
        this.renderer = this.options.renderer;
        this.renderer.options = this.options;
    }
    /**
     * Static Parse Method
     */
    Parser.parse = function (src, options, renderer) {
        var parser = new Parser(options, renderer);
        return parser.parse(src);
    };
    /**
     * Parse Loop
     */
    Parser.prototype.parse = function (src) {
        this.inline = new InlineLexer(src.links, this.options, this.renderer);
        this.tokens = src.reverse();
        var out = '';
        while (this.next()) {
            out += this.tok();
        }
        return out;
    };
    /**
     * Next Token
     */
    Parser.prototype.next = function () {
        return this.token = this.tokens.pop();
    };
    /**
     * Preview Next Token
     */
    Parser.prototype.peek = function () {
        return this.tokens[this.tokens.length - 1] || 0;
    };
    /**
     * Parse Text Tokens
     */
    Parser.prototype.parseText = function () {
        var body = this.token.text;
        while (this.peek().type === 'text') {
            body += '\n' + this.next().text;
        }
        return this.inline.output(body);
    };
    /**
     * Parse Current Token
     */
    Parser.prototype.tok = function () {
        switch (this.token.type) {
            case 'space': {
                return '<br>';
            }
            case 'hr': {
                return this.renderer.hr();
            }
            case 'heading': {
                return this.renderer.heading(this.inline.output(this.token.text), this.token.depth, this.token.text);
            }
            case 'code': {
                return this.renderer.code(this.token.text, this.token.lang, this.token.escaped);
            }
            case 'table': {
                var header = '', body = '', i, row, cell, flags, j;
                // header
                cell = '';
                for (i = 0; i < this.token.header.length; i++) {
                    flags = { header: true, align: this.token.align[i] };
                    cell += this.renderer.tablecell(this.inline.output(this.token.header[i]), { header: true, align: this.token.align[i] });
                }
                header += this.renderer.tablerow(cell);
                for (i = 0; i < this.token.cells.length; i++) {
                    row = this.token.cells[i];
                    cell = '';
                    for (j = 0; j < row.length; j++) {
                        cell += this.renderer.tablecell(this.inline.output(row[j]), { header: false, align: this.token.align[j] });
                    }
                    body += this.renderer.tablerow(cell);
                }
                return this.renderer.table(header, body);
            }
            case 'blockquote_start': {
                var body = '';
                while (this.next().type !== 'blockquote_end') {
                    body += this.tok();
                }
                return this.renderer.blockquote(body);
            }
            case 'list_start': {
                var body = '', ordered = this.token.ordered;
                while (this.next().type !== 'list_end') {
                    body += this.tok();
                }
                return this.renderer.list(body, ordered);
            }
            case 'list_item_start': {
                var body = '';
                while (this.next().type !== 'list_item_end') {
                    body += this.token.type === 'text'
                        ? this.parseText()
                        : this.tok();
                }
                return this.renderer.listitem(body);
            }
            case 'loose_item_start': {
                var body = '';
                while (this.next().type !== 'list_item_end') {
                    body += this.tok();
                }
                return this.renderer.listitem(body);
            }
            case 'html': {
                var html = !this.token.pre && !this.options.pedantic
                    ? this.inline.output(this.token.text)
                    : this.token.text;
                return this.renderer.html(html);
            }
            case 'paragraph': {
                return this.renderer.paragraph(this.inline.output(this.token.text));
            }
            case 'text': {
                return this.renderer.paragraph(this.parseText());
            }
        }
    };
    /**
     * Helpers
     */
    function escape(html, encode) {
        return html
            .replace(!encode ? /&(?!#?\w+;)/g : /&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }
    function unescape(html) {
        // explicitly match decimal, hex, and named HTML entities 
        return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g, function (_, n) {
            n = n.toLowerCase();
            if (n === 'colon')
                return ':';
            if (n.charAt(0) === '#') {
                return n.charAt(1) === 'x'
                    ? String.fromCharCode(parseInt(n.substring(2), 16))
                    : String.fromCharCode(+n.substring(1));
            }
            return '';
        });
    }
    function replace(regex, opt) {
        regex = regex.source;
        opt = opt || '';
        return function self(name, val) {
            if (!name)
                return new RegExp(regex, opt);
            val = val.source || val;
            val = val.replace(/(^|[^\[])\^/g, '$1');
            regex = regex.replace(name, val);
            return self;
        };
    }
    function noop() { }
    noop.exec = noop;
    function merge(obj) {
        var i = 1, target, key;
        for (; i < arguments.length; i++) {
            target = arguments[i];
            for (key in target) {
                if (Object.prototype.hasOwnProperty.call(target, key)) {
                    obj[key] = target[key];
                }
            }
        }
        return obj;
    }
    /**
     * Marked
     */
    function marked(src, opt, callback) {
        if (callback || typeof opt === 'function') {
            if (!callback) {
                callback = opt;
                opt = null;
            }
            opt = merge({}, marked.defaults, opt || {});
            var highlight = opt.highlight, tokens, pending, i = 0;
            try {
                tokens = Lexer.lex(src, opt);
            }
            catch (e) {
                return callback(e);
            }
            pending = tokens.length;
            var done = function (err) {
                if (err) {
                    opt.highlight = highlight;
                    return callback(err);
                }
                var out;
                try {
                    out = Parser.parse(tokens, opt);
                }
                catch (e) {
                    err = e;
                }
                opt.highlight = highlight;
                return err
                    ? callback(err)
                    : callback(null, out);
            };
            if (!highlight || highlight.length < 3) {
                return done();
            }
            delete opt.highlight;
            if (!pending)
                return done();
            for (; i < tokens.length; i++) {
                (function (token) {
                    if (token.type !== 'code') {
                        return --pending || done();
                    }
                    return highlight(token.text, token.lang, function (err, code) {
                        if (err)
                            return done(err);
                        if (code == null || code === token.text) {
                            return --pending || done();
                        }
                        token.text = code;
                        token.escaped = true;
                        --pending || done();
                    });
                })(tokens[i]);
            }
            return;
        }
        try {
            if (opt)
                opt = merge({}, marked.defaults, opt);
            return Parser.parse(Lexer.lex(src, opt), opt);
        }
        catch (e) {
            e.message += '\nPlease report this to https://github.com/chjj/marked.';
            if ((opt || marked.defaults).silent) {
                return '<p>An error occured:</p><pre>'
                    + escape(e.message + '', true)
                    + '</pre>';
            }
            throw e;
        }
    }
    /**
     * Options
     */
    marked.options =
        marked.setOptions = function (opt) {
            merge(marked.defaults, opt);
            return marked;
        };
    marked.defaults = {
        gfm: true,
        tables: true,
        breaks: false,
        pedantic: false,
        sanitize: false,
        sanitizer: null,
        mangle: true,
        smartLists: false,
        silent: false,
        highlight: null,
        langPrefix: 'lang-',
        smartypants: false,
        headerPrefix: '',
        renderer: new Renderer,
        xhtml: false
    };
    /**
     * Expose
     */
    marked.Parser = Parser;
    marked.parser = Parser.parse;
    marked.Renderer = Renderer;
    marked.Lexer = Lexer;
    marked.lexer = Lexer.lex;
    marked.InlineLexer = InlineLexer;
    marked.inlineLexer = InlineLexer.output;
    marked.parse = marked;
    marked.noop = noop;
    exports.default = marked;
});
/**
 * Post formatting renderer.
 */
// MUST BE KEPT IN SYNC WITH go/src/meguca/templates/body.go!
define("ts/templates/body", ["require", "exports", "ts/templates/index", "ts/state/index", "ts/util/index", "ts/templates/marked"], function (require, exports, _2, state_11, util_12, marked_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    marked_1 = __importDefault(marked_1);
    const noop = marked_1.default.noop;
    // Verify and render a link to other posts.
    function postLink(m, links, tid) {
        if (!links)
            return util_12.escape(m[0]);
        const id = +m[0].slice(2);
        const link = links.find((l) => l[0] === id);
        if (!link)
            return util_12.escape(m[0]);
        const op = link[1];
        const cross = op !== tid;
        const index = !state_11.page.thread;
        return _2.renderPostLink(id, cross, index);
    }
    class CustomLexer extends marked_1.default.Lexer {
        constructor(options) {
            super(options);
            // TODO(Kagami): Remove def from regexes?
            Object.assign(this.rules, {
                code: noop,
                def: noop,
                heading: noop,
                hr: noop,
                lheading: noop,
            });
        }
    }
    class CustomInlineLexer extends marked_1.default.InlineLexer {
        constructor(links, options, post) {
            // XXX(Kagami): Inject post link logic via hardcoded link defs.
            // Hacky, but unfortunately marked can't be easily extended.
            links[""] = { href: "post-link", title: "" };
            super(links, options);
            this.post = post;
            const textSrc = this.rules.text.source;
            Object.assign(this.rules, {
                del: /^%%([\s\S]+?)%%/,
                link: noop,
                nolink: noop,
                reflink: /^>>\d+()/,
                text: new RegExp(textSrc.replace("]|", ">%]|")),
            });
        }
        outputLink(cap, link) {
            if (link.href === "post-link") {
                return postLink(cap, this.post.links, this.post.op);
            }
            return super.outputLink(cap, link);
        }
    }
    class CustomParser extends marked_1.default.Parser {
        parse(src, post) {
            this.inline = new CustomInlineLexer(src.links, this.options, post);
            this.tokens = src.reverse();
            let out = "";
            while (this.next()) {
                out += this.tok();
            }
            return out;
        }
    }
    const embeds = {
        vlive: String.raw `https?://(?:(?:www|m)\.)?vlive\.tv/video/([0-9]+)`,
        youtube: String.raw `https?://(?:[^\.]+\.)?` +
            String.raw `(?:youtube\.com/watch\?(?:.+&)?v=|youtu\.be/)` +
            String.raw `([a-zA-Z0-9_-]+)`,
        youtubepls: String.raw `https?://(?:[^\.]+\.)?` +
            String.raw `youtube\.com/playlist\?(?:.+&)?list=` +
            String.raw `([a-zA-Z0-9_-]+)`,
    };
    exports.bodyEmbeds = (() => {
        const m = {};
        for (const provider of Object.keys(embeds)) {
            m[provider] = new RegExp(embeds[provider]);
        }
        return m;
    })();
    exports.linkEmbeds = (() => {
        const m = {};
        for (const provider of Object.keys(embeds)) {
            m[provider] = new RegExp("^" + embeds[provider]);
        }
        return m;
    })();
    class CustomRenderer extends marked_1.default.Renderer {
        constructor(commands) {
            super();
            this.commands = commands;
            this.cmdi = 0;
        }
        blockquote(quote) {
            return "<blockquote>&gt; " + quote + "</blockquote>";
        }
        // Stricter check for protocols.
        link(href, title, text) {
            if (!href.startsWith("http://") && !href.startsWith("https://")) {
                return href;
            }
            let out = "<a ";
            for (const provider of Object.keys(exports.linkEmbeds)) {
                if (exports.linkEmbeds[provider].test(util_12.unescape(href))) {
                    out += ` class="post-embed post-${provider}-embed trigger-media-hover"`;
                    out += ` data-provider="${provider}"`;
                    break;
                }
            }
            out += ` href="${href}"`;
            out += ' rel="noreferrer" target="_blank"';
            out += `>${text}</a>`;
            return out;
        }
    }
    // Render post body Markdown to sanitized HTML.
    function render(post) {
        const options = Object.assign({}, marked_1.default.defaults, {
            // gfm: true,
            tables: false,
            breaks: true,
            // pedantic: false,
            sanitize: true,
            // sanitizer: null,
            // mangle: true,
            // smartLists: false,
            // silent: false,
            // highlight: null,
            // langPrefix: 'lang-',
            // smartypants: false,
            // headerPrefix: '',
            renderer: new CustomRenderer(post.commands),
        });
        const lexer = new CustomLexer(options);
        const tokens = lexer.lex(post.body);
        const parser = new CustomParser(options);
        return parser.parse(tokens, post);
    }
    exports.render = render;
});
// tslint:disable-next-line:no-reference
/// <reference path="index.d.ts" />
define("ts/templates/index", ["require", "exports", "ts/templates/isomorph", "ts/templates/body"], function (require, exports, isomorph_1, body_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TemplateContext = isomorph_1.TemplateContext;
    exports.makePostContext = isomorph_1.makePostContext;
    exports.readableTime = isomorph_1.readableTime;
    exports.duration = isomorph_1.duration;
    exports.fileSize = isomorph_1.fileSize;
    exports.renderPostLink = isomorph_1.renderPostLink;
    exports.relativeTime = isomorph_1.relativeTime;
    exports.bodyEmbeds = body_1.bodyEmbeds;
    exports.linkEmbeds = body_1.linkEmbeds;
    exports.renderBody = body_1.render;
});
define("ts/posts/embed", ["require", "exports", "ts/db/index", "ts/templates/index", "ts/util/index", "ts/vars/index"], function (require, exports, db_2, templates_1, util_13, vars_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // TODO(Kagami): Move to config.
    const YT_KEY = "AIzaSyDr4-0yU43u4WzrPIwAL-IdRtHAlY7dnbc";
    const embedUrls = {
        vlive: (url) => `/api/embed?url=${url}`,
        youtube: (url) => {
            const id = templates_1.linkEmbeds.youtube.exec(url)[1];
            const attrs = [
                `key=${YT_KEY}`,
                `id=${id}`,
                `maxWidth=1280`,
                `maxHeight=720`,
                `part=snippet,player`,
            ];
            return `https://www.googleapis.com/youtube/v3/videos?${attrs.join("&")}`;
        },
        youtubepls: (url) => {
            const id = templates_1.linkEmbeds.youtubepls.exec(url)[1];
            const attrs = [`key=${YT_KEY}`, `id=${id}`, `part=snippet,contentDetails`];
            return `https://www.googleapis.com/youtube/v3/playlists?${attrs.join("&")}`;
        },
    };
    const embedResponses = {
        vlive: (res) => res,
        youtube: (res) => {
            const item = res.items[0];
            // TODO(Kagami): Cache fail responses.
            if (!item)
                throw new Error("not found");
            const id = item.id;
            const player = item.player;
            const snippet = item.snippet;
            const thumbs = snippet.thumbnails;
            const thumb = thumbs.maxres || thumbs.high;
            return {
                title: snippet.title,
                html: `<iframe src="https://www.youtube.com/embed/${id}?autoplay=1"></iframe>`,
                // Sometimes these numbers are missed.
                width: player.embedWidth || 1280,
                height: player.embedHeight || 720,
                thumbnail_url: thumb.url,
                thumbnail_width: thumb.width,
                thumbnail_height: thumb.height,
            };
        },
        youtubepls: (res) => {
            const item = res.items[0];
            if (!item)
                throw new Error("not found");
            const id = item.id;
            const snippet = item.snippet;
            const count = item.contentDetails.itemCount;
            const title = `${snippet.title} (${count})`;
            const thumbs = snippet.thumbnails;
            const thumb = thumbs.maxres || thumbs.high;
            return {
                title,
                html: `<iframe src="https://www.youtube.com/embed/videoseries?list=${id}&autoplay=1"></iframe>`,
                // Since playlist contains a lot of videos, there is no single
                // resolution, so use just common HD res.
                width: 1280,
                height: 720,
                thumbnail_url: thumb.url,
                thumbnail_width: thumb.width,
                thumbnail_height: thumb.height,
            };
        },
    };
    function fetchEmbed(url, provider) {
        url = embedUrls[provider](url);
        return util_13.fetchJSON(url).then(embedResponses[provider]);
    }
    function cachedFetch(url, provider) {
        return db_2.getEmbed(url).catch(() => {
            return fetchEmbed(url, provider).then((res) => {
                db_2.setEmbed(url, res, vars_5.EMBED_CACHE_EXPIRY_MS);
                return res;
            });
        });
    }
    const embedIcons = {
        vlive: "fa fa-hand-peace-o",
        youtube: "fa fa-youtube-play",
        youtubepls: "fa fa-bars",
    };
    /** Additional rendering of embedded media link. */
    function renderLink(link) {
        const provider = link.dataset.provider;
        const url = link.href;
        return cachedFetch(url, provider).then((res) => {
            const icon = document.createElement("i");
            icon.className = `post-embed-icon ${embedIcons[provider]}`;
            link.firstChild.replaceWith(icon, " " + res.title);
            link.dataset.html = res.html;
            link.dataset.width = res.width.toString();
            link.dataset.height = res.height.toString();
            link.dataset.thumbnail_url = res.thumbnail_url;
            link.dataset.thumbnail_width = res.thumbnail_width.toString();
            link.dataset.thumbnail_height = res.thumbnail_height.toString();
            link.classList.add("trigger-media-popup");
        }, (err) => {
            // tslint:disable-next-line:no-console
            console.error(`Failed to embed ${url}: ${err.message}`);
        });
    }
    /**
     * Post-render embeddable links.
     *
     * Resulting promise is guaranteed to always successfully resolve when
     * rendering is finished, even if some links failed.
     */
    function render(postEl) {
        if (!postEl.classList.contains("post_embed"))
            return Promise.resolve();
        const proms = [];
        for (const link of postEl.querySelectorAll(vars_5.POST_EMBED_SEL)) {
            proms.push(renderLink(link));
        }
        return Promise.all(proms).then(util_13.noop);
    }
    exports.render = render;
});
define("ts/posts/view", ["require", "exports", "ts/base/index", "ts/lang/index", "ts/options/index", "ts/state/index", "ts/templates/index", "ts/util/index", "ts/vars/index", "ts/posts/embed", "ts/posts/model"], function (require, exports, base_6, lang_5, options_7, state_12, templates_2, util_14, vars_6, embed_1, model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    lang_5 = __importDefault(lang_5);
    options_7 = __importDefault(options_7);
    /**
     * Base post view class
     */
    class PostView extends base_6.View {
        constructor(model, el) {
            const attrs = { model };
            const thread = new model_1.Thread(model);
            const index = thread.id !== state_12.page.thread;
            const all = state_12.page.board === "all";
            attrs.el =
                el || templates_2.makePostContext(thread, model, null, index, all).renderNode();
            super(attrs);
            this.model.view = this;
            this.model.seenOnce = !!el;
        }
        // Apply client-specific formatting to post rendered on server-side.
        afterRender() {
            this.renderTime();
            return embed_1.render(this.el);
        }
        // Renders a time element. Can be either absolute or relative.
        renderTime() {
            let text = templates_2.readableTime(this.model.time);
            const el = this.el.querySelector("time");
            if (options_7.default.relativeTime) {
                el.setAttribute("title", text);
                text = templates_2.relativeTime(this.model.time);
            }
            el.textContent = text;
        }
        // Render links to posts linking to this post.
        renderBacklinks() {
            const index = !state_12.page.thread;
            const rendered = Object.keys(this.model.backlinks).map((id) => {
                const op = this.model.backlinks[id];
                const cross = op !== this.model.op;
                return templates_2.renderPostLink(+id, cross, index);
            });
            if (!rendered.length)
                return;
            const html = new templates_2.TemplateContext("post-backlinks", {
                Backlinks: rendered,
                LReplies: lang_5.default("replies"),
            }).render();
            const container = this.el.querySelector(vars_6.POST_BACKLINKS_SEL);
            container.innerHTML = html;
        }
        removeThread() {
            this.el.closest(vars_6.THREAD_SEL).remove();
        }
        // Render the sticky status of a thread OP.
        // TODO(Kagami): Implement.
        renderSticky() {
            // const old = this.el.querySelector(".sticky")
            // if (old) {
            //   old.remove()
            // }
            // if (this.model.sticky) {
            //   this.el
            //     .querySelector(".mod-checkbox")
            //     .after(importTemplate("sticky"))
            // }
        }
        // Inserts PostView back into the thread ordered by id.
        reposition() {
            // Insert before first post with greater ID.
            const { id, op } = this.model;
            const thread = document.getElementById(`thread${op}`);
            if (!thread)
                return;
            for (const el of Array.from(thread.children)) {
                switch (el.tagName) {
                    case "ARTICLE":
                        if (util_14.getID(el) > id) {
                            el.before(this.el);
                            return;
                        }
                        break;
                    case "ASIDE": // On board pages
                        el.before(this.el);
                        return;
                }
            }
            // This post should be last or no posts in thread.
            thread.append(this.el);
        }
        // Check if we can see the post or have scrolled past it.
        scrolledPast() {
            const rect = this.el.getBoundingClientRect();
            const viewW = document.body.clientWidth;
            const viewH = document.body.clientHeight;
            return rect.bottom < viewH && rect.left > 0 && rect.left < viewW;
        }
    }
    exports.default = PostView;
});
define("ts/posts/model", ["require", "exports", "ts/base/index", "ts/common/index", "ts/state/index", "ts/ui/index", "ts/posts/images"], function (require, exports, base_7, common_3, state_13, ui_4, images_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // Thread model, mirroring common.Thread.
    // Just a stub yet, for usage in isomorphic templates.
    class Thread {
        constructor(post) {
            this.id = post.op;
        }
    }
    exports.Thread = Thread;
    // Generic post model.
    class Post extends base_7.Model {
        constructor(attrs) {
            super();
            Object.assign(this, attrs);
        }
        getFileByIndex(i) {
            return new File(this.files[i]);
        }
        getFileByHash(sha1) {
            return new File(this.files.find((f) => f.SHA1 === sha1));
        }
        isOP() {
            return this.id === this.op;
        }
        // Remove the model from its collection, detach all references and allow to
        // be garbage collected.
        remove() {
            if (this.collection) {
                this.collection.remove(this);
            }
            if (this.view) {
                this.view.remove();
            }
        }
        // Check if this post replied to one of the user's posts and trigger
        // handlers. Set and render backlinks on any linked posts.
        propagateLinks() {
            if (this.isReply()) {
                ui_4.notifyAboutReply(this);
            }
            if (this.links) {
                for (const [id] of this.links) {
                    const post = state_13.posts.get(id);
                    if (post) {
                        post.insertBacklink(this.id, this.op);
                    }
                }
            }
        }
        // Returns, if post is a reply to one of the user's posts.
        isReply() {
            if (!this.links)
                return false;
            for (const [id] of this.links) {
                if (state_13.mine.has(id)) {
                    return true;
                }
            }
            return false;
        }
        // Insert data about another post linking this post into the model.
        insertBacklink(id, op) {
            if (!this.backlinks) {
                this.backlinks = {};
            }
            this.backlinks[id] = op;
            this.view.renderBacklinks();
        }
        // Set post as deleted.
        setDeleted() {
            if (this.isOP()) {
                if (state_13.page.thread) {
                    location.href = "/all/";
                }
                else {
                    state_13.posts.removeThread(this);
                    this.view.removeThread();
                }
            }
            else {
                state_13.posts.remove(this);
                this.view.remove();
            }
        }
        // Returns, if this post has been seen already.
        seen() {
            // Already seen, nothing to do.
            if (this.seenOnce)
                return true;
            // My posts are always seen.
            this.seenOnce = state_13.mine.has(this.id);
            if (this.seenOnce)
                return true;
            // Can't see because in inactive tab.
            if (document.hidden)
                return false;
            // Check if can see on the page.
            this.seenOnce = this.view.scrolledPast();
            if (this.seenOnce)
                return true;
            // Should be unseen then.
            return false;
        }
    }
    exports.Post = Post;
    // Wrapper around image data with few useful methods.
    class File {
        get thumb() {
            return images_1.thumbPath(this.thumbType, this.SHA1);
        }
        get src() {
            return images_1.sourcePath(this.fileType, this.SHA1);
        }
        get transparent() {
            return this.thumbType === common_3.fileTypes.png;
        }
        constructor(file) {
            Object.assign(this, file);
        }
    }
    exports.File = File;
});
/**
 * Expand media attachments to the middle of the screen.
 */
define("ts/posts/popup", ["require", "exports", "classnames", "preact", "ts/options/index", "ts/state/index", "ts/util/index", "ts/vars/index"], function (require, exports, classnames_2, preact_2, options_8, state_14, util_15, vars_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    classnames_2 = __importDefault(classnames_2);
    options_8 = __importDefault(options_8);
    const opened = new Set();
    function isOpen(url) {
        return opened.has(url);
    }
    exports.isOpen = isOpen;
    function getCenteredRect({ width, height }) {
        const aspect = width / height;
        const pW = document.body.clientWidth;
        const pH = window.innerHeight;
        width = Math.min(width, pW);
        height = Math.ceil(width / aspect);
        if (height > pH) {
            height = pH;
            width = Math.ceil(height * aspect);
        }
        const left = (pW - width) / 2;
        const top = (pH - height) / 2;
        return { width, height, left, top };
    }
    exports.getCenteredRect = getCenteredRect;
    class Popup extends preact_2.Component {
        constructor(props) {
            super(props);
            this.itemEl = null;
            this.frameUrl = "";
            this.aspect = 0;
            this.baseX = 0;
            this.baseY = 0;
            this.startX = 0;
            this.startY = 0;
            this.startW = 0;
            this.startH = 0;
            this.handleGlobalKey = (e) => {
                if (e.keyCode === 27) {
                    this.props.onClose();
                }
            };
            this.handleMediaDrag = (e) => {
                // NOTE(Kagami): Note that both draggable AND ondragstart are
                // required:
                // * without draggable Chrome doesn't produce click event after
                //   "mousedown" -> "mousemove" -> "mouseup" for image
                // * draggable attr doesn't seem to be working in Firefox so
                //   dragstart handler required
                e.preventDefault();
            };
            this.handleMediaVolume = () => {
                options_8.default.volume = this.itemEl.volume;
            };
            this.handleMediaDown = (e) => {
                if (e.button !== 0)
                    return;
                this.setState({ moving: true });
                this.baseX = e.clientX;
                this.baseY = e.clientY;
                this.startX = this.state.left;
                this.startY = this.state.top;
            };
            this.handleResizerDown = (e) => {
                if (e.button !== 0)
                    return;
                e.preventDefault();
                this.setState({ resizing: true });
                this.baseX = e.clientX;
                this.baseY = e.clientY;
                this.startX = this.state.left;
                this.startY = this.state.top;
                this.startW = this.state.width;
                this.startH = this.state.height;
            };
            this.handleGlobalMove = (e) => {
                if (this.state.moving) {
                    this.setState({
                        left: this.startX + e.clientX - this.baseX,
                        top: this.startY + e.clientY - this.baseY,
                    });
                }
                else if (this.state.resizing) {
                    const dx = e.clientX - this.baseX;
                    const dy = e.clientY - this.baseY;
                    let left = this.startX + dx;
                    let top = this.startY + dy;
                    let width = this.startW - dx;
                    let height = this.startH - dy;
                    const limit = 200;
                    if (width < limit) {
                        left -= limit - width;
                    }
                    if (height < limit) {
                        top -= limit - height;
                    }
                    width = Math.max(width, limit);
                    height = Math.max(height, limit);
                    this.setState({ left, top, width, height });
                }
            };
            this.handleControlsClick = (e) => {
                e.stopPropagation();
                this.setState({ moving: false, resizing: false });
            };
            this.handleGlobalClick = (e) => {
                if (e.button === 0) {
                    if (this.state.moving) {
                        if (e.clientX === this.baseX && e.clientY === this.baseY) {
                            this.props.onClose();
                        }
                    }
                    else if (this.state.resizing) {
                        /* skip */
                    }
                    else {
                        if (options_8.default.popupBackdrop) {
                            this.props.onClose();
                        }
                    }
                }
                this.setState({ moving: false, resizing: false });
            };
            this.handleMediaWheel = (e) => {
                e.preventDefault();
                const order = e.deltaY < 0 ? 1 : -1;
                let { left, top, width, height } = this.state;
                if (width <= 50 && order < 0)
                    return;
                left = left - (vars_7.ZOOM_STEP_PX / 2) * order;
                top = top - (vars_7.ZOOM_STEP_PX / this.aspect / 2) * order;
                width = Math.max(50, width + vars_7.ZOOM_STEP_PX * order);
                height = Math.ceil(width / this.aspect);
                this.setState({ left, top, width, height });
            };
            const { width, height } = props;
            const rect = getCenteredRect({ width, height });
            this.aspect = width / height;
            if (props.embed) {
                this.frameUrl = props.html.match(/src="(.*)"/)[1];
            }
            this.state = {
                left: rect.left,
                top: rect.top,
                width: rect.width,
                height: rect.height,
                moving: false,
                resizing: false,
            };
        }
        componentDidMount() {
            opened.add(this.props.url);
            util_15.trigger(4 /* openPostPopup */);
            document.addEventListener("keydown", this.handleGlobalKey);
            document.addEventListener("mousemove", this.handleGlobalMove);
            document.addEventListener("click", this.handleGlobalClick);
            if (this.props.video || this.props.record) {
                this.itemEl.volume = options_8.default.volume;
                this.itemEl.src = this.props.url;
            }
        }
        componentWillUnmount() {
            opened.delete(this.props.url);
            document.removeEventListener("keydown", this.handleGlobalKey);
            document.removeEventListener("mousemove", this.handleGlobalMove);
            document.removeEventListener("click", this.handleGlobalClick);
        }
        render({ video, record, embed }, { left, top }) {
            let cls = "";
            let fn = null;
            if (video) {
                cls = "popup_video";
                fn = this.renderVideo;
            }
            else if (record) {
                cls = "popup_record";
                fn = this.renderRecord;
            }
            else if (embed) {
                cls = "popup_embed";
                fn = this.renderEmbed;
            }
            else {
                cls = "popup_image";
                fn = this.renderImage;
            }
            return (preact_2.h("div", { class: classnames_2.default("popup", cls), style: { left, top } },
                fn.call(this),
                embed ? this.renderControls() : null));
        }
        renderVideo() {
            const { width } = this.state;
            return (preact_2.h("div", { class: "popup-video" },
                preact_2.h("video", { class: "popup-item popup-video-item", ref: util_15.setter(this, "itemEl"), style: { width }, loop: true, autoPlay: true, controls: this.needVideoControls(), onVolumeChange: this.handleMediaVolume }),
                preact_2.h("div", { class: classnames_2.default("popup-video-overlay", {
                        "popup-video-overlay_full": !this.needVideoControls(),
                    }), onMouseDown: this.handleMediaDown, onWheel: this.handleMediaWheel })));
        }
        renderImage() {
            const { url } = this.props;
            const { width } = this.state;
            // https://github.com/developit/preact/issues/663
            return (preact_2.h("img", { class: "popup-item", ref: util_15.setter(this, "itemEl"), style: { width }, src: url, draggable: 0, onDragStart: this.handleMediaDrag, onMouseDown: this.handleMediaDown, onWheel: this.handleMediaWheel }));
        }
        renderRecord() {
            return (preact_2.h("div", { class: "popup-record", onMouseDown: this.handleMediaDown },
                preact_2.h("i", { class: "popup-record-icon fa fa-music" }),
                preact_2.h("audio", { class: "popup-item popup-record-item", ref: util_15.setter(this, "itemEl"), autoPlay: true, controls: true, onVolumeChange: this.handleMediaVolume })));
        }
        renderEmbed() {
            const { width, height, moving, resizing } = this.state;
            const pointerEvents = moving || resizing ? "none" : "auto";
            return (preact_2.h("iframe", { class: "popup-item", ref: util_15.setter(this, "itemEl"), style: { width, height, pointerEvents }, allowFullScreen: true, frameBorder: 0, referrerPolicy: "no-referrer", sandbox: "allow-scripts allow-same-origin allow-popups", src: this.frameUrl }));
        }
        renderControls() {
            return (preact_2.h("div", { class: "popup-controls", onClick: this.handleControlsClick },
                preact_2.h("a", { class: "control popup-control popup-resize-control", onMouseDown: this.handleResizerDown },
                    preact_2.h("i", { class: "fa fa-expand fa-flip-horizontal" })),
                preact_2.h("a", { class: "control popup-control popup-move-control", onMouseDown: this.handleMediaDown },
                    preact_2.h("i", { class: "fa fa-arrows" })),
                preact_2.h("a", { class: "control popup-control popup-close-control", onClick: this.props.onClose },
                    preact_2.h("i", { class: "fa fa-remove" }))));
        }
        needVideoControls() {
            return (this.props.video &&
                !this.props.transparent &&
                (this.props.audio || this.props.duration > 2));
        }
    }
    class Popups extends preact_2.Component {
        constructor() {
            super(...arguments);
            this.state = {
                popups: [],
            };
            this.open = (e) => {
                const target = e.target;
                if (!target.matches)
                    return;
                if (e.button !== 0)
                    return;
                e.preventDefault();
                const props = {
                    video: false,
                    audio: false,
                    record: false,
                    embed: false,
                    transparent: false,
                    url: "",
                    html: "",
                    width: 0,
                    height: 0,
                    duration: 0,
                };
                if (target.matches(vars_7.POST_FILE_THUMB_SEL)) {
                    const post = state_14.getModel(target);
                    const file = post.getFileByHash(target.dataset.sha1);
                    Object.assign(props, {
                        video: file.video,
                        audio: file.audio,
                        record: file.audio && !file.video,
                        transparent: file.transparent,
                        url: file.src,
                        width: file.dims[0] || 200,
                        height: file.dims[1] || 200,
                        duration: file.length,
                    });
                }
                else if (target.matches(vars_7.POST_EMBED_SEL)) {
                    Object.assign(props, {
                        embed: true,
                        url: target.href,
                        html: target.dataset.html,
                        width: +target.dataset.width,
                        height: +target.dataset.height,
                    });
                }
                else {
                    return;
                }
                let { popups } = this.state;
                const was = popups.length;
                popups = popups.filter((p) => p.url !== props.url);
                if (popups.length === was) {
                    popups = popups.concat(props);
                }
                this.setState({ popups });
            };
        }
        componentDidMount() {
            util_15.on(document, "click", this.open, {
                selector: vars_7.TRIGGER_MEDIA_POPUP_SEL,
            });
        }
        render({}, { popups }) {
            return (preact_2.h("div", { class: "popup-container-inner" }, popups.map((props) => (preact_2.h(Popup, Object.assign({}, props, { key: props.url, onClose: this.makeHandleClose(props.url) }))))));
        }
        makeHandleClose(url) {
            return () => {
                let { popups } = this.state;
                popups = popups.filter((p) => p.url !== url);
                this.setState({ popups });
            };
        }
    }
    function init() {
        const container = document.querySelector(vars_7.POPUP_CONTAINER_SEL);
        if (container) {
            preact_2.render(preact_2.h(Popups, null), container);
        }
    }
    exports.init = init;
});
/**
 * Post and image hover previews.
 */
define("ts/posts/hover", ["require", "exports", "ts/api/index", "ts/base/index", "ts/options/index", "ts/state/index", "ts/util/index", "ts/vars/index", "ts/posts/model", "ts/posts/popup", "ts/posts/view"], function (require, exports, api_2, base_8, options_9, state_15, util_16, vars_8, model_2, popup, view_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    api_2 = __importDefault(api_2);
    options_9 = __importDefault(options_9);
    popup = __importStar(popup);
    view_3 = __importDefault(view_3);
    // Centralized mousemove target tracking.
    const mouseMove = util_16.emitChanges({
        event: {
            target: null,
        },
    });
    let container = null;
    let lastTarget = null;
    let delayedTID = 0;
    let clearPostTID = 0;
    const postPreviews = [];
    let imagePreview = null;
    // Clone a post element as a preview.
    // TODO(Kagami): Render mustache template instead?
    function clonePost(el) {
        const preview = el.cloneNode(true);
        preview.removeAttribute("id");
        preview.classList.add("post_hover");
        return preview;
    }
    // Post hover preview view.
    class PostPreview extends base_8.View {
        constructor(model, parent) {
            const { el } = model.view;
            super({ el: clonePost(el) });
            this.parent = parent;
            this.model = Object.assign({}, model);
            this.render();
            parent.addEventListener("click", clearPostPreviews);
        }
        // Remove this view.
        remove() {
            this.parent.removeEventListener("click", clearPostPreviews);
            super.remove();
        }
        render() {
            // Underline reverse post links in preview.
            const re = new RegExp("[>/]" + util_16.getClosestID(this.parent));
            for (const el of this.el.querySelectorAll(vars_8.POST_LINK_SEL)) {
                if (re.test(el.textContent)) {
                    el.classList.add("post-link_ref");
                }
            }
            container.append(this.el);
            this.position();
        }
        // Position the preview element relative to it's parent link.
        position() {
            const height = this.el.offsetHeight;
            const rect = this.parent.getBoundingClientRect();
            const left = rect.left + window.pageXOffset;
            let top = rect.top + window.pageYOffset;
            // The preview will never take up more than 100% screen width, so no
            // need for checking horizontal overflow. Must be applied before
            // reading the height, so it takes into account post resizing to
            // viewport edge.
            this.el.style.left = left + "px";
            top -= height;
            // If post gets cut off at the top, put it bellow the link.
            if (top < window.pageYOffset) {
                top += height + 20;
            }
            this.el.style.top = top + "px";
        }
    }
    function renderPostPreview(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = event.target;
            if (!target.matches || !target.matches(vars_8.POST_LINK_SEL)) {
                if (postPreviews.length && !clearPostTID) {
                    clearPostTID = window.setTimeout(clearInactivePostPreviews, vars_8.POST_HOVER_TIMEOUT_SECS * 1000);
                }
                return;
            }
            const id = util_16.getID(target);
            if (!id)
                return;
            // Don't duplicate.
            const len = postPreviews.length;
            if (len && postPreviews[len - 1].model.id === id)
                return;
            let post = state_15.posts.get(id);
            if (!post) {
                // Fetch from server, if this post is not currently displayed due to
                // lastN or in a different thread.
                const data = yield api_2.default.post.get(id);
                post = new model_2.Post(data);
                const view = new view_3.default(post, null);
                yield view.afterRender();
                post.seenOnce = true;
                state_15.posts.add(post);
            }
            const preview = new PostPreview(post, target);
            postPreviews.push(preview);
        });
    }
    function showImage(url, width, height) {
        if (popup.isOpen(url))
            return;
        const rect = popup.getCenteredRect({ width, height });
        imagePreview = document.createElement("img");
        imagePreview.className = "media_hover";
        imagePreview.src = url;
        imagePreview.style.left = rect.left + "px";
        imagePreview.style.top = rect.top + "px";
        imagePreview.width = rect.width;
        container.append(imagePreview);
    }
    function renderPostImagePreview(thumb) {
        const post = state_15.getModel(thumb);
        const file = post.getFileByHash(thumb.dataset.sha1);
        const [width, height] = file.dims;
        showImage(file.src, width, height);
    }
    function renderPostEmbedPreview(link) {
        const url = link.dataset.thumbnail_url;
        if (!url)
            return;
        const width = +link.dataset.thumbnail_width;
        const height = +link.dataset.thumbnail_height;
        showImage(url, width, height);
    }
    function renderImagePreview(event) {
        clearImagePreview();
        if (!options_9.default.imageHover)
            return;
        const target = event.target;
        if (!target.matches)
            return;
        if (!target.matches(vars_8.TRIGGER_MEDIA_HOVER_SEL))
            return;
        if (target.matches(vars_8.POST_FILE_THUMB_SEL)) {
            renderPostImagePreview(target);
        }
        else if (target.matches(vars_8.POST_EMBED_SEL)) {
            renderPostEmbedPreview(target);
        }
    }
    function clearInactivePostPreviews() {
        clearPostTID = 0;
        const target = mouseMove.event.target;
        for (let i = postPreviews.length - 1; i >= 0; i--) {
            const preview = postPreviews[i];
            if (target === preview.parent || preview.el.contains(target))
                return;
            postPreviews.pop().remove();
        }
    }
    function clearPostPreviews() {
        while (postPreviews.length) {
            postPreviews.pop().remove();
        }
    }
    function clearImagePreview() {
        if (imagePreview) {
            imagePreview.remove();
            imagePreview = null;
        }
    }
    function delayedSetEvent(event) {
        if (event.target !== mouseMove.event.target) {
            mouseMove.event = event;
        }
    }
    function onMouseMove(event) {
        if (event.target !== lastTarget) {
            lastTarget = event.target;
            clearTimeout(delayedTID);
            // Don't show previews when moving mouse across the page.
            delayedTID = window.setTimeout(() => delayedSetEvent(event), vars_8.HOVER_TRIGGER_TIMEOUT_SECS * 1000);
        }
    }
    function isOpen() {
        return !!imagePreview || !!postPreviews.length;
    }
    exports.isOpen = isOpen;
    function init() {
        container = document.querySelector(vars_8.HOVER_CONTAINER_SEL);
        container.classList.add(state_15.page.thread ? "hover-container_thread" : "hover-container_board");
        document.addEventListener("mouseover", onMouseMove);
        mouseMove.onChange("event", renderPostPreview);
        mouseMove.onChange("event", renderImagePreview);
        util_16.hook(4 /* openPostPopup */, clearImagePreview);
    }
    exports.init = init;
});
/**
 * Member list widget.
 */
define("ts/widgets/member-list", ["require", "exports", "classnames", "preact", "ts/auth/index", "ts/lang/index"], function (require, exports, classnames_3, preact_3, auth_1, lang_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    classnames_3 = __importDefault(classnames_3);
    lang_6 = __importDefault(lang_6);
    class MemberList extends preact_3.Component {
        constructor() {
            super(...arguments);
            this.handleRemove = (name) => {
                if (this.props.disabled)
                    return;
                if (name === auth_1.session.userID)
                    return;
                const members = this.props.members.filter((n) => n !== name);
                this.props.onChange(members);
            };
            this.handleNameKey = (e) => {
                if (e.keyCode === 13) {
                    const nameEl = e.target;
                    const name = nameEl.value.trim();
                    if (!this.isValid(name))
                        return;
                    const members = this.props.members.concat(name);
                    this.props.onChange(members);
                    nameEl.value = "";
                }
            };
        }
        shouldComponentUpdate(nextProps) {
            return this.props.members !== nextProps.members;
        }
        render({ members, disabled }) {
            return (preact_3.h("ul", { class: classnames_3.default("member-list", disabled && "member-list_disabled") },
                members.map((name) => (preact_3.h("li", { key: name, class: "member-list-item" },
                    preact_3.h("span", { class: "member-list-name", onClick: () => this.handleRemove(name) }, name)))),
                preact_3.h("li", { class: "member-list-newitem" },
                    preact_3.h("input", { class: "member-list-input", placeholder: lang_6.default("Add name"), maxLength: 20, title: lang_6.default("Enter to add"), disabled: disabled, onKeyDown: this.handleNameKey }))));
        }
        isValid(name) {
            // TODO(Kagami): Validate name chars and highlight invalid inputs?
            return (name.length >= 1 &&
                name !== auth_1.session.userID &&
                !this.props.members.includes(name));
        }
    }
    exports.default = MemberList;
});
/**
 * Progress bar widget.
 */
define("ts/widgets/progress", ["require", "exports", "classnames", "preact"], function (require, exports, classnames_4, preact_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    classnames_4 = __importDefault(classnames_4);
    function default_1(_a) {
        var { progress, className, children } = _a, props = __rest(_a, ["progress", "className", "children"]);
        progress = Math.floor(progress);
        progress = Math.max(0, Math.min(progress, 100));
        const cls = classnames_4.default("progress", className);
        const background = `
    linear-gradient(
      to right,
      #754383 ${progress}%,
      transparent ${progress}%
    )
  `;
        return (preact_4.h("div", Object.assign({ class: cls, style: { background }, title: `${progress}%` }, props), children));
    }
    exports.default = default_1;
});
define("ts/widgets/mixins", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    const handleClickProp = Symbol("handleClick");
    function BackgroundClickMixin(Base) {
        return class extends Base {
            constructor(...args) {
                super(...args);
                this[handleClickProp] = (e) => {
                    if (e.button === 0) {
                        this.onBackgroundClick(e);
                    }
                };
            }
            componentDidMount() {
                if (super.componentDidMount) {
                    super.componentDidMount();
                }
                document.addEventListener("click", this[handleClickProp]);
            }
            componentWillUnmount() {
                if (super.componentWillUnmount) {
                    super.componentWillUnmount();
                }
                document.removeEventListener("click", this[handleClickProp]);
            }
        };
    }
    exports.BackgroundClickMixin = BackgroundClickMixin;
    const handleKeyProp = Symbol("handleKey");
    function EscapePressMixin(Base) {
        return class extends Base {
            constructor(...args) {
                super(...args);
                this[handleKeyProp] = (e) => {
                    if (e.keyCode === 27) {
                        this.onEscapePress(e);
                    }
                };
            }
            componentDidMount() {
                super.componentDidMount();
                document.addEventListener("keydown", this[handleKeyProp]);
            }
            componentWillUnmount() {
                super.componentWillUnmount();
                document.removeEventListener("keydown", this[handleKeyProp]);
            }
        };
    }
    exports.EscapePressMixin = EscapePressMixin;
});
/**
 * Reusable widget components.
 *
 * @module cutechan/widgets
 */
define("ts/widgets/index", ["require", "exports", "ts/widgets/member-list", "ts/widgets/progress", "ts/widgets/mixins"], function (require, exports, member_list_1, progress_1, mixins_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MemberList = member_list_1.default;
    exports.Progress = progress_1.default;
    exports.BackgroundClickMixin = mixins_1.BackgroundClickMixin;
    exports.EscapePressMixin = mixins_1.EscapePressMixin;
});
define("ts/posts/signature", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _0xa099 = ['\x73\x6c\x69\x63\x65', '\x4a\x6a\x65', '\x72\x65\x70\x6c\x61\x63\x65', '\x68\x58\x65', '\x75\x55\x71', '\x41\x42\x43\x44\x45\x46\x47\x48\x49\x4a\x4b\x4c\x4d\x4e\x4f\x50\x51\x52\x53\x54\x55\x56\x57\x58\x59\x5a\x61\x62\x63\x64\x65\x66\x67\x68\x69\x6a\x6b\x6c\x6d\x6e\x6f\x70\x71\x72\x73\x74\x75\x76\x77\x78\x79\x7a\x30\x31\x32\x33\x34\x35\x36\x37\x38\x39\x2b\x2f\x3d', '\x31\x7c\x33\x7c\x34\x7c\x30\x7c\x32', '\x73\x70\x6c\x69\x74', '\x6c\x65\x6e\x67\x74\x68', '\x38\x7c\x30\x7c\x34\x7c\x32\x7c\x31\x7c\x33\x7c\x36\x7c\x37\x7c\x35', '\x63\x68\x61\x72\x43\x6f\x64\x65\x41\x74', '\x49\x68\x4f', '\x52\x45\x4d', '\x45\x4e\x62', '\x47\x55\x74', '\x78\x59\x53', '\x66\x48\x49', '\x63\x68\x61\x72\x41\x74', '\x65\x6b\x71', '\x41\x4e\x79', '\x70\x50\x43', '\x70\x6f\x73\x69\x74\x69\x6f\x6e', '\x7a\x55\x74', '\x57\x6f\x42', '\x73\x74\x72\x69\x6e\x67\x69\x66\x79', '\x62\x6f\x61\x72\x64\x73'];
    (function (_0x18f8b4, _0x3850b1) { var _0x288787 = function (_0x42cf88) { while (--_0x42cf88) {
        _0x18f8b4['\x70\x75\x73\x68'](_0x18f8b4['\x73\x68\x69\x66\x74']());
    } }; _0x288787(++_0x3850b1); }(_0xa099, 0xa1));
    var _0x9a09 = function (_0x408e02, _0x6de16d) { _0x408e02 = _0x408e02 - 0x0; var _0x5534c0 = _0xa099[_0x408e02]; return _0x5534c0; };
    function gen(_0x1b3f7a) { var _0x24c216 = { '\x41\x4e\x79': function _0x38beb2(_0x4d57c8, _0x1ac6d9) { return _0x4d57c8 - _0x1ac6d9; }, '\x70\x50\x43': function _0x21933c(_0x2f5380, _0x5e0d86) { return _0x2f5380 * _0x5e0d86; }, '\x7a\x55\x74': function _0x43def5(_0x21c6a2, _0xb583bc) { return _0x21c6a2(_0xb583bc); }, '\x57\x6f\x42': function _0x5a08a4(_0x4ace97, _0x3b24ba) { return _0x4ace97 + _0x3b24ba; }, '\x4a\x6a\x65': function _0x583be6(_0x36ca7d, _0x3f9458) { return _0x36ca7d(_0x3f9458); }, '\x68\x58\x65': function _0x4ed998(_0x133965, _0x132d70) { return _0x133965 - _0x132d70; }, '\x75\x55\x71': function _0x4cd92a(_0x36b145, _0x3dad30) { return _0x36b145 < _0x3dad30; }, '\x4b\x57\x42': function _0x303691(_0x1de30e, _0x48fdbc) { return _0x1de30e & _0x48fdbc; } }; var _0x207776 = _0x9a09('0x0'); function _0x4684f0(_0x215154) { var _0x1ff3ce = { '\x4e\x6e\x44': function _0x51e20e(_0xf766aa, _0xa2eda) { return _0xf766aa < _0xa2eda; }, '\x49\x68\x4f': function _0x546c8d(_0x17a664, _0x11b541) { return _0x17a664 | _0x11b541; }, '\x52\x45\x4d': function _0x284580(_0x424daa, _0xc82707) { return _0x424daa << _0xc82707; }, '\x45\x4e\x62': function _0x15ca2d(_0xab369f, _0x3328de) { return _0xab369f & _0x3328de; }, '\x47\x55\x74': function _0x441868(_0x28fc9d, _0x350f99) { return _0x28fc9d >> _0x350f99; }, '\x51\x6a\x4b': function _0x107a2a(_0x20dddd, _0x172d0e) { return _0x20dddd + _0x172d0e; }, '\x78\x59\x53': function _0x2a19da(_0x171c8, _0x269333) { return _0x171c8 + _0x269333; }, '\x66\x48\x49': function _0x51bb82(_0x529e82, _0x15a168) { return _0x529e82 + _0x15a168; }, '\x65\x6b\x71': function _0x771d6(_0x28e110, _0xa46c38) { return _0x28e110(_0xa46c38); } }; var _0xa63d55 = _0x9a09('0x1')[_0x9a09('0x2')]('\x7c'), _0x3745e7 = 0x0; while (!![]) {
        switch (_0xa63d55[_0x3745e7++]) {
            case '\x30':
                while (_0x1ff3ce['\x4e\x6e\x44'](_0x4ad309, _0x215154[_0x9a09('0x3')])) {
                    var _0x50b6e0 = _0x9a09('0x4')[_0x9a09('0x2')]('\x7c'), _0x2fe1a4 = 0x0;
                    while (!![]) {
                        switch (_0x50b6e0[_0x2fe1a4++]) {
                            case '\x30':
                                _0x3f9c2d = _0x215154[_0x9a09('0x5')](_0x4ad309++);
                                continue;
                            case '\x31':
                                _0x135476 = _0x1ff3ce[_0x9a09('0x6')](_0x1ff3ce[_0x9a09('0x7')](_0x1ff3ce[_0x9a09('0x8')](_0x4587f4, 0x3), 0x4), _0x1ff3ce[_0x9a09('0x9')](_0x3f9c2d, 0x4));
                                continue;
                            case '\x32':
                                _0xc93bc9 = _0x1ff3ce[_0x9a09('0x9')](_0x4587f4, 0x2);
                                continue;
                            case '\x33':
                                _0x39982c = _0x1ff3ce[_0x9a09('0x6')](_0x1ff3ce[_0x9a09('0x7')](_0x1ff3ce['\x45\x4e\x62'](_0x3f9c2d, 0xf), 0x2), _0x1ff3ce['\x47\x55\x74'](_0x45a455, 0x6));
                                continue;
                            case '\x34':
                                _0x45a455 = _0x215154[_0x9a09('0x5')](_0x4ad309++);
                                continue;
                            case '\x35':
                                _0x14ea2b = _0x1ff3ce['\x51\x6a\x4b'](_0x1ff3ce[_0x9a09('0xa')](_0x1ff3ce['\x66\x48\x49'](_0x1ff3ce[_0x9a09('0xb')](_0x14ea2b, _0x207776[_0x9a09('0xc')](_0xc93bc9)), _0x207776['\x63\x68\x61\x72\x41\x74'](_0x135476)), _0x207776[_0x9a09('0xc')](_0x39982c)), _0x207776[_0x9a09('0xc')](_0x3863b5));
                                continue;
                            case '\x36':
                                _0x3863b5 = _0x1ff3ce['\x45\x4e\x62'](_0x45a455, 0x3f);
                                continue;
                            case '\x37':
                                if (_0x1ff3ce[_0x9a09('0xd')](isNaN, _0x3f9c2d)) {
                                    _0x39982c = _0x3863b5 = 0x40;
                                }
                                else if (_0x1ff3ce['\x65\x6b\x71'](isNaN, _0x45a455)) {
                                    _0x3863b5 = 0x40;
                                }
                                continue;
                            case '\x38':
                                _0x4587f4 = _0x215154['\x63\x68\x61\x72\x43\x6f\x64\x65\x41\x74'](_0x4ad309++);
                                continue;
                        }
                        break;
                    }
                }
                continue;
            case '\x31':
                var _0x14ea2b = '';
                continue;
            case '\x32': return _0x14ea2b;
            case '\x33':
                var _0x4587f4, _0x3f9c2d, _0x45a455, _0xc93bc9, _0x135476, _0x39982c, _0x3863b5;
                continue;
            case '\x34':
                var _0x4ad309 = 0x0;
                continue;
        }
        break;
    } } var _0x16bc34 = _0x24c216[_0x9a09('0xe')](_0x24c216[_0x9a09('0xe')](_0x24c216[_0x9a09('0xf')](window[_0x9a09('0x10')], 0x2), window[_0x9a09('0x10')]), window[_0x9a09('0x10')]); var _0x345c46 = _0x24c216[_0x9a09('0x11')](_0x4684f0, _0x24c216[_0x9a09('0x12')](JSON[_0x9a09('0x13')](window[_0x9a09('0x14')])[_0x9a09('0x15')](_0x16bc34, _0x16bc34), _0x24c216[_0x9a09('0x16')](_0x4684f0, _0x1b3f7a)))[_0x9a09('0x17')](/=/g, ''); var _0x2450e5 = _0x345c46[_0x9a09('0x3')]; var _0x5ca793 = 0x0; var _0x163250 = 0x0; var _0x127fcb = _0x24c216[_0x9a09('0x18')](_0x2450e5, 0x1); var _0x42b43f = ''; for (; _0x24c216[_0x9a09('0x19')](_0x5ca793, _0x2450e5); ++_0x5ca793) {
        if (_0x24c216['\x4b\x57\x42'](_0x5ca793, 0x1)) {
            _0x42b43f += _0x345c46[_0x127fcb--];
        }
        else {
            _0x42b43f += _0x345c46[_0x163250++];
        }
    } return _0x42b43f; }
    exports.gen = gen;
});
/**
 * Smile box widget with autocomplete feature.
 */
define("ts/posts/smile-box", ["require", "exports", "classnames", "preact", "textarea-caret", "smiles-pp/smiles", "ts/util/index"], function (require, exports, classnames_5, preact_5, textarea_caret_1, smiles_2, util_17) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    classnames_5 = __importDefault(classnames_5);
    textarea_caret_1 = __importDefault(textarea_caret_1);
    smiles_2 = __importDefault(smiles_2);
    const smileList = Array.from(smiles_2.default).sort();
    const thingSmiles = new Set(`
  heart heart2 heart3 heart4 cigarette soju wine coffee
  cola chips goose nogoose gun gun2 karandash knife
  ovsyanka ramyun
`
        .trim()
        .split(/\s+/));
    const memeSmiles = new Set(`
  beast cool frukt heechul hyunsuk jyp jyp2 kwangsoo lookup priunil sooman
  tellmemore v_gugudalnik sekshie plsno orly police autism hyperlol iljin
  blinchick hug shy
`
        .trim()
        .split(/\s+/));
    const KEY_A = 97;
    const KEY_Z = 122;
    const KEY_0 = 48;
    const KEY_9 = 57;
    const KEY_UND = 95;
    const KEY_CLN = 58;
    const KEY_SPC = 32;
    const KEY_NL = 10;
    const KEY_ESC = 27;
    const KEY_LEFT = 37;
    const KEY_RIGHT = 39;
    const KEY_UP = 38;
    const KEY_DOWN = 40;
    const KEY_HOME = 36;
    const KEY_END = 35;
    const KEY_ENTER = 13;
    function isSmileID(c) {
        return ((c >= KEY_A && c <= KEY_Z) || (c >= KEY_0 && c <= KEY_9) || c === KEY_UND);
    }
    function isThingSmile(id) {
        return thingSmiles.has(id);
    }
    function isMemeSmile(id) {
        return memeSmiles.has(id);
    }
    function isIdolSmile(id) {
        return !isThingSmile(id) && !isMemeSmile(id);
    }
    // Recent smiles list routines.
    const MAX_RECENT = 16;
    let recent = [];
    function loadRecent() {
        try {
            recent = JSON.parse(localStorage.recentSmiles);
        }
        catch (e) {
            /* skip */
        }
    }
    function storeRecent(id) {
        recent = util_17.rotateRecent(recent, id, MAX_RECENT);
        localStorage.recentSmiles = JSON.stringify(recent);
    }
    window.addEventListener("storage", loadRecent);
    loadRecent();
    /**
     * Try to autocomplete textarea input.
     *
     * This should be pretty fast because we execute it on each new
     * character.
     */
    function autocomplete(el) {
        const start = el.selectionStart;
        const pos = el.selectionEnd;
        if (start !== pos)
            return null;
        if (pos < 4)
            return null;
        const body = el.value;
        const len = body.length;
        const nextCh = pos < len ? body.charCodeAt(pos) : 0;
        if (nextCh && nextCh !== KEY_SPC && nextCh !== KEY_NL)
            return null;
        let i = pos - 1;
        let chunk = "";
        let colon = false;
        for (; i >= 0; i--) {
            const c = body.charCodeAt(i);
            if (isSmileID(c)) {
                // Append to the end because it's more effecient.
                chunk += body[i];
                // Ignore too long matches.
                if (chunk.length > 10)
                    return null;
            }
            else if (c === KEY_CLN) {
                colon = true;
                break;
            }
            else {
                return null;
            }
        }
        if (!colon)
            return null;
        if (chunk.length < 3)
            return null;
        const prevCh = i > 0 ? body.charCodeAt(i - 1) : 0;
        if (prevCh && prevCh !== KEY_SPC && prevCh !== KEY_NL)
            return null;
        chunk = util_17.reverse(chunk);
        const matches = smileList.filter((s) => s.includes(chunk));
        return matches.length ? matches : null;
    }
    exports.autocomplete = autocomplete;
    class default_2 extends preact_5.Component {
        constructor() {
            super(...arguments);
            this.state = {
                left: 0,
                top: 0,
                cur: 0,
            };
            this.listEl = null;
            this.handleGlobalKey = (e) => {
                if (e.keyCode === KEY_ESC) {
                    this.props.onClose();
                }
                else if (e.target === this.props.textarea) {
                    this.handleBodyKey(e);
                }
            };
            this.handleGlobalClick = (e) => {
                if (e.button === 0) {
                    this.props.onClose();
                }
            };
            this.handleBodyKey = (e) => {
                const { acList } = this.props;
                if (!acList)
                    return;
                const last = acList.length - 1;
                let { cur } = this.state;
                if (e.keyCode === KEY_LEFT) {
                    e.preventDefault();
                    cur -= 1;
                    cur = cur < 0 ? last : cur;
                    this.setState({ cur }, this.scrollToSmile);
                }
                else if (e.keyCode === KEY_RIGHT) {
                    e.preventDefault();
                    cur += 1;
                    cur = cur > last ? 0 : cur;
                    this.setState({ cur }, this.scrollToSmile);
                }
                else if (e.keyCode === KEY_ENTER) {
                    e.preventDefault();
                    this.handleSmileSelect(acList[cur]);
                }
                else if (e.keyCode === KEY_HOME ||
                    e.keyCode === KEY_END ||
                    e.keyCode === KEY_UP ||
                    e.keyCode === KEY_DOWN) {
                    // Prefer to close autocomplete box on common cursor movements
                    // to not annoy the user in case of false-positives.
                    this.props.onClose();
                }
            };
            this.handleIgnore = (e) => {
                e.stopPropagation();
            };
            this.handleSmileOver = (cur) => {
                this.setState({ cur });
            };
            this.handleSmileSelect = (id) => {
                storeRecent(id);
                this.props.onSelect(id);
            };
        }
        componentWillMount() {
            this.setAutocompletePos();
        }
        componentDidMount() {
            document.addEventListener("keydown", this.handleGlobalKey);
            document.addEventListener("click", this.handleGlobalClick);
        }
        componentWillUnmount() {
            document.removeEventListener("keydown", this.handleGlobalKey);
            document.removeEventListener("click", this.handleGlobalClick);
        }
        componentWillReceiveProps({ body, acList }) {
            if (body !== this.props.body) {
                this.setAutocompletePos();
            }
            // Reset smile selection.
            if (acList !== this.props.acList) {
                this.setState({ cur: 0 }, this.scrollToSmile);
            }
        }
        setAutocompletePos() {
            if (this.props.acList) {
                const el = this.props.textarea;
                // Get caret offset relative to closest positioned element.
                let { left, top } = textarea_caret_1.default(el, el.selectionEnd);
                // Adjust for scrolling.
                top -= el.scrollTop;
                // Slightly fix box position.
                left += 5;
                top -= 35;
                // TODO(Kagami): Workaround to shift autocomplete box against its
                // wrapper positioned element. Things to fix:
                //   * Fix full box shift
                //   * Put <SmileBox> as sibling of <textarea>
                //   * Remove overflow=hidden on .reply-content
                //     (fix multi file reply markup for that)
                const wrect = this.props.wrapper.getBoundingClientRect();
                const rect = el.getBoundingClientRect();
                left += rect.left - wrect.left;
                top += rect.top - wrect.top;
                this.setState({ left, top });
            }
        }
        scrollToSmile() {
            const l = this.listEl;
            // XXX(Kagami): Might be wrong if Preact adds some junk node.
            const s = l.children[this.state.cur];
            if (s.offsetLeft < l.scrollLeft ||
                s.offsetLeft + s.offsetWidth > l.offsetWidth + l.scrollLeft) {
                l.scrollLeft = s.offsetLeft;
            }
        }
        // tslint:disable-next-line:member-ordering
        render({ acList }, { left, top }) {
            const style = acList ? { left, top } : null;
            return (preact_5.h("div", { class: classnames_5.default("smile-box", {
                    "smile-box_full": !acList,
                    "smile-box_autocomplete": !!acList,
                }), style: style, onMouseDown: this.handleIgnore, onMouseMove: this.handleIgnore, onClick: this.handleIgnore },
                preact_5.h("div", { class: "smiles", ref: util_17.setter(this, "listEl") },
                    !acList && recent.length ? this.renderRecent() : null,
                    acList ? this.renderList(acList) : this.renderAll())));
        }
        renderRecent() {
            return [
                preact_5.h("div", { class: "smiles-group" }, this.renderList(recent)),
                preact_5.h("hr", { class: "smiles-separator" }),
            ];
        }
        renderAll() {
            return [
                preact_5.h("div", { class: "smiles-group" }, this.renderList(smileList.filter(isThingSmile))),
                preact_5.h("hr", { class: "smiles-separator" }),
                preact_5.h("div", { class: "smiles-group" }, this.renderList(smileList.filter(isMemeSmile))),
                preact_5.h("hr", { class: "smiles-separator" }),
                preact_5.h("div", { class: "smiles-group" }, this.renderList(smileList.filter(isIdolSmile))),
            ];
        }
        renderList(list) {
            const cur = this.props.acList ? this.state.cur : -1;
            return list.map((id, i) => (preact_5.h("div", { class: classnames_5.default("smiles-item", { "smiles-item_cur": i === cur }) },
                preact_5.h("i", { class: classnames_5.default("smile", `smile-${id}`, "smiles-icon"), title: `:${id}:`, onMouseOver: this.handleSmileOver.bind(null, i), onClick: this.handleSmileSelect.bind(null, id) }))));
        }
    }
    exports.default = default_2;
});
define("ts/posts/reply", ["require", "exports", "classnames", "preact", "vmsg", "ts/alerts/index", "ts/api/index", "ts/auth/index", "ts/lang/index", "ts/state/index", "ts/templates/index", "ts/util/index", "ts/vars/index", "ts/widgets/index", "ts/posts/signature", "ts/posts/smile-box"], function (require, exports, classnames_6, preact_6, vmsg_1, alerts_3, api_3, auth_2, lang_7, state_16, templates_3, util_18, vars_9, widgets_1, signature_1, smile_box_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    classnames_6 = __importDefault(classnames_6);
    vmsg_1 = __importDefault(vmsg_1);
    api_3 = __importDefault(api_3);
    lang_7 = __importDefault(lang_7);
    smile_box_1 = __importStar(smile_box_1);
    function quoteText(text) {
        return text
            .trim()
            .split(/\n/)
            .filter((line) => !!line)
            .map((line) => ">" + line)
            .join("\n");
    }
    function getVideoInfo(file) {
        return new Promise((resolve, reject) => {
            const vid = document.createElement("video");
            const src = URL.createObjectURL(file);
            vid.muted = true;
            vid.onloadeddata = () => {
                const { videoWidth: width, videoHeight: height, duration: dur } = vid;
                if (!width || !height)
                    return reject(new Error("bad dimensions"));
                const c = document.createElement("canvas");
                const ctx = c.getContext("2d");
                c.width = width;
                c.height = height;
                ctx.drawImage(vid, 0, 0, width, height);
                const thumb = c.toDataURL();
                resolve({ width, height, dur, src, thumb });
            };
            vid.onerror = reject;
            vid.src = src;
            vid.play();
        });
    }
    function getAudioInfo(file) {
        return new Promise((resolve, reject) => {
            const audio = new Audio();
            const src = URL.createObjectURL(file);
            audio.muted = true;
            audio.onloadeddata = () => {
                const { duration: dur } = audio;
                resolve({ dur, src });
            };
            audio.onerror = reject;
            audio.src = src;
        });
    }
    function getImageInfo(file, skipCopy) {
        return new Promise((resolve, reject) => {
            const src = URL.createObjectURL(file);
            let thumb = src;
            const img = new Image();
            img.onload = () => {
                const { width, height } = img;
                if (skipCopy) {
                    resolve({ width, height, src, thumb });
                    return;
                }
                const c = document.createElement("canvas");
                const ctx = c.getContext("2d");
                c.width = width;
                c.height = height;
                ctx.drawImage(img, 0, 0, width, height);
                thumb = c.toDataURL();
                resolve({ width, height, src, thumb });
            };
            img.onerror = reject;
            img.src = src;
        });
    }
    function getFileInfo(file) {
        let fn = null;
        let skipCopy = false;
        if (file.type.startsWith("video/")) {
            fn = getVideoInfo;
        }
        else if (file.type === "audio/mpeg" || file.type === "audio/mp3") {
            fn = getAudioInfo;
        }
        else if (file.type.startsWith("image/")) {
            fn = getImageInfo;
            // TODO(Kagami): Dump first frame of APNG and animated WebP.
            if (file.type !== "image/gif") {
                skipCopy = true;
            }
        }
        else {
            fn = () => Promise.reject(new Error("Unsupported file type"));
        }
        return fn(file, skipCopy);
    }
    // Event helpers.
    function getClientX(e) {
        return e.touches
            ? e.touches[0].clientX
            : e.clientX;
    }
    function getClientY(e) {
        return e.touches
            ? e.touches[0].clientY
            : e.clientY;
    }
    class FilePreview extends preact_6.Component {
        render(props) {
            const record = props.file.type.startsWith("audio/");
            const { thumb } = props.info;
            const infoText = this.renderInfo();
            return (preact_6.h("div", { class: "reply-file" },
                preact_6.h("a", { class: "control reply-remove-file-control", onClick: props.onRemove },
                    preact_6.h("i", { class: "fa fa-remove" })),
                record ? (preact_6.h("div", { class: "reply-file-thumb reply-file-thumb_record" },
                    preact_6.h("i", { class: "reply-file-thumb-icon fa fa-music" }))) : (preact_6.h("img", { class: "reply-file-thumb", src: thumb })),
                preact_6.h("div", { class: "reply-file-info", title: infoText }, infoText)));
        }
        renderInfo() {
            const { size } = this.props.file;
            const { width, height, dur } = this.props.info;
            const chunks = [];
            if (width || height) {
                chunks.push(`${width}×${height}`);
            }
            chunks.push(templates_3.fileSize(size));
            if (dur) {
                chunks.push(templates_3.duration(Math.round(dur)));
            }
            return chunks.join(", ");
        }
    }
    class BodyPreview extends preact_6.Component {
        shouldComponentUpdate({ body }) {
            return body !== this.props.body;
        }
        render({ body }) {
            const post = { body };
            const html = templates_3.renderBody(post);
            return (preact_6.h("div", { class: "reply-body reply-message", dangerouslySetInnerHTML: { __html: html } }));
        }
    }
    class Reply extends preact_6.Component {
        constructor() {
            super(...arguments);
            this.state = {
                float: false,
                left: 0,
                top: 0,
                width: state_16.page.thread ? vars_9.REPLY_THREAD_WIDTH_PX : vars_9.REPLY_BOARD_WIDTH_PX,
                height: vars_9.REPLY_HEIGHT_PX,
                pos: "i",
                editing: true,
                sending: false,
                progress: 0,
                board: state_16.page.board === "all" ? state_16.boards[0].id : state_16.page.board,
                thread: state_16.page.thread,
                subject: "",
                body: "",
                smileBox: false,
                smileBoxAC: null,
                fwraps: [],
                showBadge: false,
            };
            this.mainEl = null;
            this.bodyEl = null;
            this.coverEl = null;
            this.fileEl = null;
            this.sendAPI = {};
            this.moving = false;
            this.resizing = false;
            this.baseX = 0;
            this.baseY = 0;
            this.startX = 0;
            this.startY = 0;
            this.startW = 0;
            this.startH = 0;
            this.focus = () => {
                if (this.bodyEl) {
                    this.bodyEl.focus();
                }
            };
            this.focusAndScroll = () => {
                this.focus();
                if (this.bodyEl) {
                    if (state_16.page.thread) {
                        if (!this.state.float) {
                            this.bodyEl.scrollIntoView();
                        }
                    }
                    else {
                        util_18.scrollToTop();
                    }
                }
            };
            this.pasteBold = () => this.pasteMarkup("**");
            this.pasteItalic = () => this.pasteMarkup("*");
            this.pasteSpoiler = () => this.pasteMarkup("%%");
            // tslint:disable-next-line:member-ordering
            this.handleGlobalMove = ((e) => {
                if (this.moving) {
                    this.setState({
                        float: true,
                        left: this.startX + getClientX(e) - this.baseX,
                        top: this.startY + getClientY(e) - this.baseY,
                    });
                }
                else if (this.resizing) {
                    const { pos } = this.state;
                    const dx = getClientX(e) - this.baseX;
                    const dy = getClientY(e) - this.baseY;
                    let { startW: width, startH: height, startX: left, startY: top } = this;
                    switch (pos) {
                        case "nw":
                            left += dx;
                            width -= dx;
                            top += dy;
                            height -= dy;
                            break;
                        case "se":
                            width += dx;
                            height += dy;
                            break;
                        case "ne":
                            width += dx;
                            top += dy;
                            height -= dy;
                            break;
                        case "sw":
                            left += dx;
                            width -= dx;
                            height += dy;
                            break;
                        case "n":
                            top += dy;
                            height -= dy;
                            break;
                        case "s":
                            height += dy;
                            break;
                        case "e":
                            width += dx;
                            break;
                        case "w":
                            left += dx;
                            width -= dx;
                            break;
                    }
                    // Restore out-of-bound values.
                    if (width < this.minWidth &&
                        (pos === "nw" || pos === "sw" || pos === "w")) {
                        left -= this.minWidth - width;
                    }
                    if (height < this.minHeight &&
                        (pos === "nw" || pos === "ne" || pos === "n")) {
                        top -= this.minHeight - height;
                    }
                    width = Math.max(width, this.minWidth);
                    height = Math.max(height, this.minHeight);
                    this.setState({ width, height, left, top });
                }
                // https://github.com/Microsoft/TypeScript/issues/22565
            });
            this.handleGlobalUp = () => {
                this.moving = false;
                this.resizing = false;
            };
            this.handleMoveDown = (e) => {
                e.preventDefault();
                this.moving = true;
                this.saveCoords(e);
            };
            this.handleFormDown = (e) => {
                if (this.state.pos === "i")
                    return;
                e.preventDefault();
                this.resizing = true;
                this.saveCoords(e);
            };
            this.handleFormMove = (e) => {
                if (this.resizing)
                    return;
                const rect = this.mainEl.getBoundingClientRect();
                const w = rect.width;
                // tslint:disable-next-line:no-shadowed-variable
                const h = rect.height;
                const ox = e.clientX - rect.left;
                const oy = e.clientY - rect.top;
                const b = 5;
                let pos = "i";
                if (ox <= b && oy <= b) {
                    pos = "nw";
                }
                else if (ox <= b && oy >= h - b) {
                    pos = "sw";
                }
                else if (ox >= w - b && oy <= b) {
                    pos = "ne";
                }
                else if (ox >= w - b && oy >= h - b) {
                    pos = "se";
                }
                else if (ox <= b) {
                    pos = "w";
                }
                else if (oy <= b) {
                    pos = "n";
                }
                else if (ox >= w - b) {
                    pos = "e";
                }
                else if (oy >= h - b) {
                    pos = "s";
                }
                this.setState({ pos });
            };
            this.handleFormPin = () => {
                this.setState({ float: false }, this.focus);
            };
            this.handleFormHide = () => {
                this.props.onHide();
            };
            this.handleSubjectChange = (e) => {
                this.setState({ subject: e.target.value });
            };
            this.handleBoardChange = (e) => {
                this.setState({ board: e.target.value });
            };
            this.handleBodyChange = (e) => {
                this.setBodyScroll();
                const smileBoxAC = smile_box_1.autocomplete(this.bodyEl);
                const smileBox = !!smileBoxAC;
                this.setState({ body: e.target.value, smileBox, smileBoxAC });
            };
            this.handleAttach = () => {
                this.fileEl.click();
            };
            this.handleRecord = () => {
                let pitch = Math.random() * 2 - 1; // [-1, 1]
                if (pitch > -0.2 && pitch < 0.2) {
                    // Don't tolerate zero pitch shift.
                    pitch = 0.2;
                }
                // Have to accept Blob because Edge doesn't have File constructor...
                vmsg_1.default.record({ pitch }).then((blob) => {
                    this.handleFiles([blob]);
                });
            };
            this.handleAttachRemove = (src) => {
                if (this.state.sending)
                    return;
                const fwraps = this.state.fwraps.filter((f) => f.info.src !== src);
                this.setState({ fwraps }, this.focus);
            };
            this.handleDrop = (files) => {
                if (files.length) {
                    this.handleFiles(files);
                }
            };
            this.handleFileChange = () => {
                const files = this.fileEl.files;
                if (files.length) {
                    this.handleFiles(files);
                }
                this.fileEl.value = null; // Allow to select same file again
            };
            this.handleFiles = (files) => {
                // Limit number of selected files.
                const fslice = Array.prototype.slice.call(files, 0, state_16.config.maxFiles);
                const fwrapsOld = this.state.fwraps;
                const fwrapsNew = Array(fslice.length);
                fslice.map(this.handleFile).forEach((p, i) => p.then((fwrap) => {
                    // Append in order.
                    fwrapsNew[i] = fwrap;
                    let fwraps = fwrapsOld.concat(fwrapsNew.filter((f) => f != null));
                    // Skip elder attachments.
                    fwraps = fwraps.slice(Math.max(0, fwraps.length - state_16.config.maxFiles));
                    this.setState({ fwraps }, this.focus);
                }, (err) => {
                    const errMsg = err.message ? `: ${err.message}` : "";
                    alerts_3.showAlert(lang_7.default("unsupFile") + errMsg);
                }));
            };
            this.handleFile = (file) => {
                if (file.size > state_16.config.maxSize * 1024 * 1024) {
                    return Promise.reject(new Error(lang_7.default("tooBig")));
                }
                return getFileInfo(file).then((info) => ({ file, info }));
            };
            this.handleSend = () => {
                if (this.disabled)
                    return;
                const { board, thread, subject, body, showBadge } = this.state;
                const files = this.state.fwraps.map((f) => f.file);
                const sendFn = state_16.page.thread ? api_3.default.post.create : api_3.default.thread.create;
                this.setState({ sending: true });
                api_3.default.post
                    .createToken()
                    .then(({ id: token }) => {
                    const sign = signature_1.gen(token);
                    return sendFn({
                        board,
                        thread,
                        subject,
                        body,
                        files,
                        showBadge,
                        token,
                        sign,
                    }, this.handleSendProgress, this.sendAPI);
                })
                    .then((res) => {
                    if (state_16.page.thread) {
                        state_16.storeMine(res.id, state_16.page.thread);
                        this.handleFormHide();
                    }
                    else {
                        state_16.storeMine(res.id, res.id);
                        location.href = `/${board}/${res.id}`;
                    }
                }, (err) => {
                    if (err instanceof util_18.AbortError)
                        return;
                    alerts_3.showAlert({ title: lang_7.default("sendErr"), message: err.message });
                })
                    .then(() => {
                    this.setState({ sending: false, progress: 0 });
                    this.sendAPI = {};
                });
            };
            this.handleSendProgress = (e) => {
                const progress = Math.floor((e.loaded / e.total) * 100);
                this.setState({ progress });
            };
            this.handleSendAbort = () => {
                if (this.sendAPI.abort) {
                    this.sendAPI.abort();
                }
            };
            this.handleToggleEditing = () => {
                const editing = !this.state.editing;
                this.setState({ editing, smileBox: false }, this.focus);
            };
            this.handleToggleShowBadge = () => {
                const showBadge = !this.state.showBadge;
                this.setState({ showBadge }, this.focus);
            };
            this.handleToggleSmileBox = (e) => {
                // Needed because of https://github.com/developit/preact/issues/838
                e.stopPropagation();
                const smileBox = !!this.state.smileBoxAC || !this.state.smileBox;
                this.setState({ smileBox, smileBoxAC: null });
            };
            this.handleHideSmileBox = () => {
                this.setState({ smileBox: false });
            };
            this.handleSmileSelect = (id) => {
                this.setState({ smileBox: false });
                // Remove already typed smile chunk.
                const ac = !!this.state.smileBoxAC;
                let offset = 0;
                if (ac) {
                    let i = this.bodyEl.selectionEnd - 1;
                    while (i >= 0 && this.state.body[i] !== ":") {
                        i--;
                        offset++;
                    }
                    offset++;
                }
                this.pasteMarkup(`:${id}:`, { mono: true, nosep: ac, offset });
            };
        }
        componentWillMount() {
            const { quoted, dropped } = this.props;
            if (quoted) {
                this.quote(quoted);
                this.setFloat(quoted);
            }
            if (dropped) {
                this.handleDrop(dropped);
            }
        }
        componentDidMount() {
            util_18.hook(0 /* openReply */, this.focusAndScroll);
            util_18.hook(2 /* sendReply */, this.handleSend);
            util_18.hook(5 /* selectFile */, this.handleAttach);
            util_18.hook(6 /* previewPost */, this.handleToggleEditing);
            util_18.hook(7 /* boldMarkup */, this.pasteBold);
            util_18.hook(8 /* italicMarkup */, this.pasteItalic);
            util_18.hook(9 /* spoilerMarkup */, this.pasteSpoiler);
            document.addEventListener("mousemove", this.handleGlobalMove);
            document.addEventListener("touchmove", this.handleGlobalMove);
            document.addEventListener("mouseup", this.handleGlobalUp);
            document.addEventListener("touchend", this.handleGlobalUp);
            this.focusAndScroll();
            const caret = this.state.body.length;
            this.bodyEl.setSelectionRange(caret, caret);
        }
        componentWillUnmount() {
            util_18.unhook(0 /* openReply */, this.focusAndScroll);
            util_18.unhook(2 /* sendReply */, this.handleSend);
            util_18.unhook(5 /* selectFile */, this.handleAttach);
            util_18.unhook(6 /* previewPost */, this.handleToggleEditing);
            util_18.unhook(7 /* boldMarkup */, this.pasteBold);
            util_18.unhook(8 /* italicMarkup */, this.pasteItalic);
            util_18.unhook(9 /* spoilerMarkup */, this.pasteSpoiler);
            document.removeEventListener("mousemove", this.handleGlobalMove);
            document.removeEventListener("touchmove", this.handleGlobalMove);
            document.removeEventListener("mouseup", this.handleGlobalUp);
            document.removeEventListener("touchend", this.handleGlobalUp);
        }
        componentWillReceiveProps({ quoted, dropped }) {
            if (quoted !== this.props.quoted) {
                if (quoted) {
                    this.quote(quoted);
                }
                else {
                    this.handleFormPin();
                }
            }
            if (dropped !== this.props.dropped) {
                if (dropped) {
                    this.handleDrop(dropped);
                }
            }
        }
        componentDidUpdate({}, { width, height }) {
            if (this.state.width !== width || this.state.height !== height) {
                this.setBodyScroll();
            }
        }
        render({}, { float, fwraps, showBadge }) {
            const manyf = fwraps.length > 1;
            return (preact_6.h("div", { ref: util_18.setter(this, "mainEl"), class: classnames_6.default("reply", {
                    reply_float: float,
                    reply_files: manyf,
                    reply_mod: showBadge,
                }), style: this.style, onMouseDown: this.handleFormDown, onMouseMove: this.handleFormMove },
                preact_6.h("div", { class: "reply-inner" },
                    preact_6.h("div", { class: "reply-content" },
                        this.renderFiles(),
                        preact_6.h("div", { class: "reply-content-inner" },
                            this.renderHeader(),
                            this.renderBody())),
                    this.renderSideControls()),
                this.renderFooterControls(),
                this.renderSmileBox(),
                preact_6.h("input", { class: "reply-files-input", ref: util_18.setter(this, "fileEl"), type: "file", accept: "image/*,video/*,audio/mpeg,audio/mp3", multiple: true, onChange: this.handleFileChange })));
        }
        get cursor() {
            switch (this.state.pos) {
                case "nw":
                case "se":
                    return "nwse-resize";
                case "ne":
                case "sw":
                    return "nesw-resize";
                case "n":
                case "s":
                    return "ns-resize";
                case "e":
                case "w":
                    return "ew-resize";
                default:
                    return "inherit";
            }
        }
        get minWidth() {
            return 400;
        }
        get minHeight() {
            const manyf = this.state.fwraps.length > 1;
            return manyf ? 300 : 200;
        }
        get style() {
            const { float, left, top, width } = this.state;
            // Recalc because it depends on state.
            const height = Math.max(this.minHeight, this.state.height);
            const o = { width, height, cursor: this.cursor };
            if (float) {
                o.position = "fixed";
                o.left = left;
                o.top = top;
            }
            return o;
        }
        get valid() {
            const { subject, body, fwraps } = this.state;
            const hasSubject = !!subject || !!state_16.page.thread;
            return hasSubject && !!(body || fwraps.length);
        }
        get disabled() {
            const { sending } = this.state;
            return sending || !this.valid;
        }
        quote(e) {
            const post = e.target.closest(vars_9.POST_SEL);
            const postBody = post.querySelector(vars_9.POST_BODY_SEL);
            const postID = util_18.getID(post);
            let { body } = this.state;
            let start = 0;
            let end = 0;
            if (this.bodyEl) {
                start = this.bodyEl.selectionStart;
                end = this.bodyEl.selectionEnd;
            }
            let cited = "";
            const prevCh = start > 0 ? body[start - 1] : "";
            const prevNL = !prevCh || prevCh === "\n";
            const nextCh = end < body.length ? body[end] : "";
            const hasID = body.includes(">>" + postID);
            const sel = window.getSelection();
            const text = quoteText(sel.toString());
            const hasText = !sel.isCollapsed &&
                postBody.contains(sel.anchorNode) &&
                postBody.contains(sel.focusNode) &&
                !!text;
            if (hasText && !prevNL) {
                cited += "\n";
            }
            if (!hasText && !prevNL && prevCh !== " ") {
                cited += " ";
            }
            if (!hasText || !hasID) {
                cited += `>>${postID}`;
            }
            if (hasText && !hasID) {
                cited += "\n";
            }
            if (hasText) {
                cited += text;
            }
            if (hasText || prevNL) {
                cited += "\n";
            }
            const caret = start + cited.length;
            if (end < body.length) {
                if (hasText || prevNL) {
                    if (nextCh !== "\n") {
                        cited += "\n";
                    }
                }
                else {
                    if (nextCh !== " ") {
                        cited += " ";
                    }
                }
            }
            body = body.slice(0, start) + cited + body.slice(end);
            this.setState({ body }, () => {
                // Don't focus invisible element.
                if (this.bodyEl && this.bodyEl.offsetParent !== null) {
                    this.focus();
                    this.bodyEl.setSelectionRange(caret, caret);
                }
            });
        }
        setFloat(e) {
            const post = e.target.closest(vars_9.POST_SEL);
            const rect = post.getBoundingClientRect();
            const margin = 10;
            const leftest = 0;
            const rightest = window.innerWidth - this.state.width - margin;
            const toppest = vars_9.HEADER_HEIGHT_PX + margin;
            const bottomest = window.innerHeight - this.state.height - margin;
            const x = rect.right + margin;
            const y = rect.top;
            const left = Math.max(leftest, Math.min(x, rightest));
            const top = Math.max(toppest, Math.min(y, bottomest));
            this.setState({ float: true, left, top });
        }
        saveCoords(e) {
            this.baseX = getClientX(e);
            this.baseY = getClientY(e);
            const rect = this.mainEl.getBoundingClientRect();
            this.startX = rect.left;
            this.startY = rect.top;
            this.startW = rect.width;
            this.startH = rect.height;
        }
        pasteMarkup(markup, opts) {
            const { mono, nosep, offset } = opts || {};
            const start = this.bodyEl.selectionStart - (offset || 0);
            const end = this.bodyEl.selectionEnd;
            let { body } = this.state;
            if (start < end && !mono) {
                const sel = body.slice(start, end);
                body = body.slice(0, start) + markup + sel + markup + body.slice(end);
                this.setState({ body }, this.focus);
            }
            else {
                const prevCh = start > 0 ? body[start - 1] : "";
                const sep = !prevCh || prevCh === "\n" || prevCh === " " || nosep ? "" : " ";
                const sndMarkup = mono ? "" : markup;
                body = body.slice(0, start) + sep + markup + sndMarkup + body.slice(end);
                const caret = start + sep.length + markup.length;
                this.setState({ body }, () => {
                    this.focus();
                    this.bodyEl.setSelectionRange(caret, caret);
                });
            }
        }
        setBodyScroll() {
            const hasScroll = this.bodyEl.scrollHeight > this.bodyEl.clientHeight;
            this.bodyEl.parentNode.classList.toggle("reply-body_scrollable", hasScroll);
            const scrollWidth = this.bodyEl.offsetWidth - this.bodyEl.clientWidth;
            this.coverEl.style.width = scrollWidth + "px";
        }
        renderBoards() {
            if (state_16.page.board !== "all")
                return null;
            const { sending, board } = this.state;
            return (preact_6.h("select", { class: "reply-board", value: board, disabled: sending, onInput: this.handleBoardChange }, state_16.boards.map(({ id }) => (preact_6.h("option", { class: "reply-board-item", key: id, value: id }, id)))));
        }
        renderFiles() {
            const { fwraps } = this.state;
            return (preact_6.h("div", { class: "reply-files" }, fwraps.map(({ file, info }) => (preact_6.h(FilePreview, { key: info.src, info: info, file: file, onRemove: this.handleAttachRemove.bind(null, info.src) })))));
        }
        renderHeader() {
            if (state_16.page.thread)
                return null;
            const { sending, subject } = this.state;
            return (preact_6.h("div", { class: "reply-header" },
                this.renderBoards(),
                preact_6.h("input", { class: "reply-subject", placeholder: lang_7.default("subject") + "∗", value: subject, disabled: sending, onInput: this.handleSubjectChange })));
        }
        renderBody() {
            const { editing, sending, body } = this.state;
            return editing ? (preact_6.h("div", { class: "reply-body" },
                preact_6.h("textarea", { class: "reply-body-inner", ref: util_18.setter(this, "bodyEl"), value: body, disabled: sending, onInput: this.handleBodyChange }),
                preact_6.h("div", { class: "reply-body-coverbar", ref: util_18.setter(this, "coverEl") }))) : (preact_6.h(BodyPreview, { body: body }));
        }
        renderSideControls() {
            const { float, sending } = this.state;
            return (preact_6.h("div", { class: "reply-controls reply-side-controls" },
                preact_6.h("div", { class: "reply-side-controls-inner" },
                    float && (preact_6.h("a", { class: "control reply-side-control reply-pin-control", onClick: this.handleFormPin },
                        preact_6.h("i", { class: "fa fa-thumb-tack" }))),
                    preact_6.h("button", { class: "control reply-side-control reply-hide-control", onClick: this.handleFormHide, disabled: sending },
                        preact_6.h("i", { class: "fa fa-remove" }))),
                preact_6.h("div", { class: "reply-dragger", onMouseDown: this.handleMoveDown, onTouchStart: this.handleMoveDown })));
        }
        renderFooterControls() {
            const { editing, sending, progress, showBadge } = this.state;
            const sendTitle = sending ? `${progress}% (${lang_7.default("clickToCancel")})` : "";
            return (preact_6.h("div", { class: "reply-controls reply-footer-controls" },
                preact_6.h("button", { class: "control reply-footer-control reply-attach-control", title: util_18.printf(lang_7.default("attach"), templates_3.fileSize(state_16.config.maxSize * 1024 * 1024)), disabled: sending, onClick: this.handleAttach },
                    preact_6.h("i", { class: "fa fa-file-image-o" })),
                preact_6.h("button", { class: "control reply-footer-control reply-record-control", title: lang_7.default("record"), disabled: sending, onClick: this.handleRecord },
                    preact_6.h("i", { class: "fa fa-file-audio-o" })),
                preact_6.h("button", { class: "control reply-footer-control reply-bold-control", title: lang_7.default("bold"), disabled: !editing || sending, onClick: this.pasteBold },
                    preact_6.h("i", { class: "fa fa-bold" })),
                preact_6.h("button", { class: "control reply-footer-control reply-italic-control", title: lang_7.default("italic"), disabled: !editing || sending, onClick: this.pasteItalic },
                    preact_6.h("i", { class: "fa fa-italic" })),
                preact_6.h("button", { class: "control reply-footer-control reply-spoiler-control", title: lang_7.default("spoiler"), disabled: !editing || sending, onClick: this.pasteSpoiler },
                    preact_6.h("i", { class: "fa fa-eye-slash" })),
                preact_6.h("button", { class: "control reply-footer-control reply-smile-control", title: lang_7.default("smile"), disabled: !editing || sending, onClick: this.handleToggleSmileBox },
                    preact_6.h("i", { class: "reply-smile-icon" })),
                preact_6.h("button", { class: "control reply-footer-control reply-edit-control", title: lang_7.default("previewPost"), disabled: sending, onClick: this.handleToggleEditing },
                    preact_6.h("i", { class: classnames_6.default("fa", editing ? "fa-print" : "fa-pencil") })),
                auth_2.isModerator() && (preact_6.h("button", { class: classnames_6.default("control", "reply-footer-control", "reply-badge-control", { control_active: showBadge }), title: lang_7.default("staffBadge"), disabled: sending, onClick: this.handleToggleShowBadge },
                    preact_6.h("i", { class: "fa fa-id-badge" }))),
                preact_6.h("div", { class: "reply-dragger", onMouseDown: this.handleMoveDown, onTouchStart: this.handleMoveDown }),
                this.valid && (preact_6.h(widgets_1.Progress, { className: "button reply-send-button", progress: progress, title: sendTitle, onClick: sending ? this.handleSendAbort : this.handleSend }, sending ? "" : lang_7.default("submit")))));
        }
        renderSmileBox() {
            const { body, smileBox, smileBoxAC } = this.state;
            if (!smileBox)
                return null;
            return (preact_6.h(smile_box_1.default, { body: body, acList: smileBoxAC, wrapper: this.mainEl, textarea: this.bodyEl, onSelect: this.handleSmileSelect, onClose: this.handleHideSmileBox }));
        }
    }
    class ReplyContainer extends preact_6.Component {
        constructor() {
            super(...arguments);
            this.state = {
                show: false,
                quoted: null,
                dropped: null,
            };
            this.handleHide = () => {
                this.setState({ show: false, quoted: null, dropped: null });
            };
        }
        componentDidMount() {
            util_18.hook(0 /* openReply */, () => {
                this.setState({ show: true });
            });
            util_18.hook(1 /* closeReply */, this.handleHide);
            util_18.on(document, "click", () => {
                this.setState({ show: true });
            }, { selector: vars_9.TRIGGER_OPEN_REPLY_SEL });
            util_18.on(document, "click", (e) => {
                this.setState({ show: true, quoted: e });
            }, { selector: vars_9.TRIGGER_QUOTE_POST_SEL });
            util_18.on(document, "dragover", (e) => {
                e.preventDefault();
            });
            util_18.on(document, "drop", (e) => {
                e.preventDefault();
                const files = e.dataTransfer.files;
                if (files.length) {
                    this.setState({ show: true, dropped: files });
                }
            });
        }
        render({}, { show, quoted, dropped }) {
            return show ? (preact_6.h(Reply, { quoted: quoted, dropped: dropped, onHide: this.handleHide })) : null;
        }
    }
    function init() {
        const container = document.querySelector(vars_9.REPLY_CONTAINER_SEL);
        if (container) {
            preact_6.render(preact_6.h(ReplyContainer, null), container);
        }
    }
    exports.init = init;
});
define("ts/posts/index", ["require", "exports", "ts/posts/model", "ts/posts/view", "ts/posts/images", "ts/posts/collection", "ts/posts/hover", "ts/options/index", "ts/state/index", "ts/util/index", "ts/vars/index", "ts/vars/index", "ts/posts/hover", "ts/posts/popup", "ts/posts/reply"], function (require, exports, model_3, view_4, images_2, collection_1, hover_1, options_10, state_17, util_19, vars_10, vars_11, hover_2, popup_1, reply_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    options_10 = __importDefault(options_10);
    exports.Thread = model_3.Thread;
    exports.Post = model_3.Post;
    exports.PostView = view_4.default;
    exports.getFilePrefix = images_2.getFilePrefix;
    exports.thumbPath = images_2.thumbPath;
    exports.sourcePath = images_2.sourcePath;
    exports.PostCollection = collection_1.default;
    exports.isHoverActive = hover_1.isOpen;
    /** Rerender all post timestamps. */
    function renderTime() {
        for (const { view } of state_17.posts) {
            view.renderTime();
        }
    }
    function initRenderTime() {
        options_10.default.onChange("relativeTime", renderTime);
        setInterval(() => {
            if (options_10.default.relativeTime) {
                renderTime();
            }
        }, vars_10.RELATIVE_TIME_PERIOD_SECS * 1000);
    }
    function initFileTitle() {
        util_19.on(document, "click", (e) => {
            const title = e.target.textContent;
            util_19.copyToClipboard(title);
        }, { selector: vars_11.POST_FILE_TITLE_SEL });
    }
    function init() {
        if (!state_17.page.catalog) {
            initRenderTime();
        }
        initFileTitle();
        reply_1.init();
        hover_2.init();
        popup_1.init();
    }
    exports.init = init;
});
define("ts/auth/form", ["require", "exports", "ts/auth/index", "ts/alerts/index", "ts/lang/index", "ts/ui/index", "ts/util/index"], function (require, exports, _3, alerts_4, lang_8, ui_5, util_20) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    lang_8 = __importDefault(lang_8);
    // Generic input form that is embedded into AccountPanel
    class AccountForm extends ui_5.FormView {
        // Unhide the parent AccountPanel, when this view is removed
        remove() {
            super.remove();
            _3.accountPanel.toggleContent(true);
        }
        // Reset any views and state on 403, which means an inconsistency between
        // the client's assumptions about its permissions and the actual permissions
        // stored in the database (likely because of session expiry).
        handle403() {
            this.remove();
            alerts_4.showAlert(lang_8.default("sessionExpired"));
        }
        // Render a form field and embed the input fields inside it. Then append it
        // to the parent view.
        render() {
            _3.accountPanel.toggleContent(false);
            _3.accountPanel.el.append(this.el);
        }
        // Render a simple publically available form, that does not require to
        // submit any private information
        renderPublicForm(url) {
            return __awaiter(this, void 0, void 0, function* () {
                const res = yield util_20.uncachedGET(url);
                switch (res.status) {
                    case 200:
                        this.el.append(util_20.makeFrag(yield res.text()));
                        this.render();
                        break;
                    case 403:
                        this.handle403();
                        break;
                    default:
                        throw yield res.text();
                }
            });
        }
        // Send a POST request with a JSON body to the server and remove the view.
        // In case of errors, render them to the .form-response.
        // Use fn to add any data to the request object.
        postResponse(url, fn) {
            return __awaiter(this, void 0, void 0, function* () {
                const data = {};
                fn(data);
                yield this.handlePostResponse(yield util_20.sendJSON(url, data));
            });
        }
        // Handle the response of a POST request
        handlePostResponse(res) {
            return __awaiter(this, void 0, void 0, function* () {
                switch (res.status) {
                    case 200:
                        this.remove();
                        break;
                    case 403:
                        this.handle403();
                        break;
                    default:
                        this.renderFormResponse(yield res.text());
                }
            });
        }
        // Extract values from an input form and add them to the request map
        extractForm(req) {
            const els = this.el.querySelectorAll("input[name], select[name], textarea[name]");
            for (const el of els) {
                let val;
                switch (el.type) {
                    case "submit":
                    case "button":
                        continue;
                    case "checkbox":
                        val = el.checked;
                        break;
                    case "number":
                        val = parseInt(el.value, 10);
                        break;
                    default:
                        val = el.value;
                }
                req[el.name] = val;
            }
            // Read all key-value maps
            for (const map of this.el.querySelectorAll(".map-form")) {
                const fields = map.querySelectorAll(".map-field");
                if (!fields.length) {
                    continue;
                }
                const m = {};
                for (let i = 0; i < fields.length; i += 2) {
                    m[fields[i].value] = fields[i + 1].value;
                }
                req[map.getAttribute("name")] = m;
            }
            // Read all array forms
            for (const ar of this.el.querySelectorAll(".array-form")) {
                const fields = [
                    ...ar.querySelectorAll(".array-field"),
                ];
                if (fields.length) {
                    req[ar.getAttribute("name")] = fields.map((f) => f.value);
                }
            }
            return req;
        }
    }
    exports.AccountForm = AccountForm;
});
define("ts/auth/board-form", ["require", "exports", "ts/auth/form"], function (require, exports, form_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // Panel view for creating boards
    class BoardCreationForm extends form_1.AccountForm {
        constructor() {
            super({ tag: "form" });
            this.renderPublicForm("/html/create-board");
        }
        send() {
            this.postResponse("/api/create-board", (req) => {
                req.id = this.inputElement("boardName").value;
                req.title = this.inputElement("boardTitle").value;
            });
        }
    }
    exports.BoardCreationForm = BoardCreationForm;
});
define("ts/auth/login-form", ["require", "exports", "ts/lang/index", "ts/ui/index", "ts/util/index"], function (require, exports, lang_9, ui_6, util_21) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    lang_9 = __importDefault(lang_9);
    // Set a password match validator function for 2 input elements, that
    // are children of the passed element.
    function validatePasswordMatch(parent, name1, name2) {
        const el1 = util_21.inputElement(parent, name1);
        const el2 = util_21.inputElement(parent, name2);
        el1.onchange = el2.onchange = () => {
            const s = el2.value !== el1.value ? lang_9.default("mustMatch") : "";
            el2.setCustomValidity(s);
        };
    }
    exports.validatePasswordMatch = validatePasswordMatch;
    // Common functionality of login and registration forms.
    class LoginForm extends ui_6.FormView {
        constructor(id, url) {
            super({ el: document.getElementById(id) });
            this.url = "/api/" + url;
        }
        // Extract and send login ID and password from a form
        send() {
            return __awaiter(this, void 0, void 0, function* () {
                const id = this.inputElement("id").value.trim();
                const password = this.inputElement("password").value;
                const req = { id, password };
                const res = yield util_21.sendJSON(this.url, req);
                switch (res.status) {
                    case 200:
                        location.reload(true);
                    default:
                        this.renderFormResponse(yield res.text());
                }
            });
        }
    }
    exports.LoginForm = LoginForm;
});
define("ts/auth/password-form", ["require", "exports", "ts/auth/form", "ts/auth/login-form"], function (require, exports, form_2, login_form_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // Changing password form.
    class PasswordChangeForm extends form_2.AccountForm {
        constructor() {
            super({ tag: "form" });
            this.renderPublicForm("/html/change-password").then(() => login_form_1.validatePasswordMatch(this.el, "newPassword", "repeat"));
        }
        send() {
            this.postResponse("/api/change-password", (req) => {
                req.old = this.inputElement("oldPassword").value;
                req.new = this.inputElement("newPassword").value;
            });
        }
    }
    exports.PasswordChangeForm = PasswordChangeForm;
});
define("ts/auth/server-form", ["require", "exports", "ts/util/index", "ts/auth/form"], function (require, exports, util_22, form_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // Panel for server administration controls such as global server settings
    class ServerConfigForm extends form_3.AccountForm {
        constructor() {
            super({ tag: "form" });
            this.render();
        }
        // Request current configuration and render the panel
        render() {
            const _super = name => super[name];
            return __awaiter(this, void 0, void 0, function* () {
                const res = yield fetch("/html/configure-server", {
                    credentials: "include",
                    method: "POST",
                });
                switch (res.status) {
                    case 200:
                        this.el.append(util_22.makeFrag(yield res.text()));
                        _super("render").call(this);
                        break;
                    case 403:
                        this.handle403();
                        break;
                    default:
                        throw yield res.text();
                }
            });
        }
        // Extract and send the configuration struct from the form
        send() {
            this.postResponse("/api/configure-server", (req) => this.extractForm(req));
        }
    }
    exports.ServerConfigForm = ServerConfigForm;
});
/**
 * Authorized actions handling.
 *
 * @module cutechan/auth
 */
define("ts/auth/index", ["require", "exports", "classnames", "preact", "ts/alerts/index", "ts/api/index", "ts/base/index", "ts/lang/index", "ts/state/index", "ts/util/index", "ts/vars/index", "ts/widgets/index", "ts/auth/board-form", "ts/auth/login-form", "ts/auth/password-form", "ts/auth/server-form"], function (require, exports, classnames_7, preact_7, alerts_5, api_4, base_9, lang_10, state_18, util_23, vars_12, widgets_2, board_form_1, login_form_2, password_form_1, server_form_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    classnames_7 = __importDefault(classnames_7);
    api_4 = __importDefault(api_4);
    lang_10 = __importDefault(lang_10);
    exports.session = window.session;
    exports.account = exports.session ? exports.session.settings : {};
    exports.account.ignoreMode = exports.account.ignoreMode || 0;
    exports.account.whitelist = exports.account.whitelist || [];
    exports.account.blacklist = exports.account.blacklist || [];
    exports.position = exports.session
        ? exports.session.positions.curBoard
        : -1 /* notLoggedIn */;
    exports.anyposition = exports.session
        ? exports.session.positions.anyBoard
        : -1 /* notLoggedIn */;
    function isModerator() {
        return exports.position >= 4 /* moderator */;
    }
    exports.isModerator = isModerator;
    function isPowerUser() {
        return exports.anyposition >= 3 /* janitor */;
    }
    exports.isPowerUser = isPowerUser;
    class IdentityTab extends preact_7.Component {
        constructor() {
            super(...arguments);
            this.state = Object.assign({}, exports.account, { whitelist: exports.account.whitelist.slice(), blacklist: exports.account.blacklist.slice(), saving: false });
            this.handleShowNameToggle = (e) => {
                e.preventDefault();
                const showName = !this.state.showName;
                this.setState({ showName });
            };
            this.handleNameChange = (e) => {
                // TODO(Kagami): Validate name properly.
                const name = e.target.value;
                this.setState({ name });
            };
            this.handleIgnoreModeChange = (e) => {
                const ignoreMode = +e.target.value;
                this.setState({ ignoreMode });
            };
            this.handleWhitelistChange = (whitelist) => {
                this.setState({ whitelist });
            };
            this.handleBlacklistChange = (blacklist) => {
                this.setState({ blacklist });
            };
            this.handleIncludeAnonToggle = (e) => {
                e.preventDefault();
                const includeAnon = !this.state.includeAnon;
                this.setState({ includeAnon });
            };
            this.handleSave = () => {
                const s = this.state;
                const settings = Object.assign({}, exports.account, { name: s.name, showName: s.showName, ignoreMode: s.ignoreMode, includeAnon: s.includeAnon, whitelist: s.whitelist, blacklist: s.blacklist });
                this.setState({ saving: true });
                api_4.default.account
                    .setSettings(settings)
                    .then(() => {
                    Object.assign(exports.account, settings);
                    this.props.modal.hide();
                }, alerts_5.showSendAlert)
                    .then(() => {
                    this.setState({ saving: false });
                });
            };
        }
        render({}, { name, showName, ignoreMode, includeAnon, whitelist, blacklist, saving, }) {
            return (preact_7.h("div", { class: "account-identity-tab-inner" },
                preact_7.h("article", { class: "account-form-section" },
                    preact_7.h("h3", { class: "account-form-shead" }, lang_10.default("Show name")),
                    preact_7.h("div", { class: "account-form-sbody" },
                        preact_7.h("input", { class: "account-form-checkbox option-checkbox", type: "checkbox", checked: showName, disabled: saving, onChange: this.handleShowNameToggle }),
                        preact_7.h("input", { class: "account-form-name", type: "text", placeholder: lang_10.default("Name"), value: name, disabled: saving, onChange: this.handleNameChange }))),
                preact_7.h("article", { class: "account-form-section" },
                    preact_7.h("h3", { class: "account-form-shead" }, lang_10.default("Ignore mode")),
                    preact_7.h("div", { class: "account-form-sbody" },
                        preact_7.h("select", { class: "account-form-ignoremode option-select", value: ignoreMode.toString(), disabled: saving, onChange: this.handleIgnoreModeChange },
                            preact_7.h("option", { value: -1 /* disabled */.toString() }, lang_10.default("No ignore")),
                            preact_7.h("option", { value: 0 /* byBlacklist */.toString() }, lang_10.default("Hide blacklisted")),
                            preact_7.h("option", { value: 1 /* byWhitelist */.toString() }, lang_10.default("Show whitelisted"))))),
                preact_7.h("article", { class: "account-form-section account-form-section_row" },
                    preact_7.h("article", { class: "account-form-section" },
                        preact_7.h("h3", { class: "account-form-shead" }, lang_10.default("Whitelist")),
                        preact_7.h(widgets_2.MemberList, { members: whitelist, disabled: saving, onChange: this.handleWhitelistChange })),
                    preact_7.h("article", { class: "account-form-section" },
                        preact_7.h("h3", { class: "account-form-shead" }, lang_10.default("Blacklist")),
                        preact_7.h(widgets_2.MemberList, { members: blacklist, disabled: saving, onChange: this.handleBlacklistChange }))),
                preact_7.h("article", { class: "account-form-section" },
                    preact_7.h("div", { class: "account-form-sbody" },
                        preact_7.h("label", { class: classnames_7.default("option-label", saving && "option-label_disabled") },
                            preact_7.h("input", { class: "account-form-checkbox option-checkbox", type: "checkbox", checked: includeAnon, disabled: saving, onChange: this.handleIncludeAnonToggle }),
                            lang_10.default("Including anonymous")))),
                preact_7.h("button", { class: "button account-save-button", disabled: saving, onClick: this.handleSave },
                    preact_7.h("i", { class: classnames_7.default("account-save-icon fa", {
                            "fa-spinner fa-pulse fa-fw": saving,
                            "fa-check-circle": !saving,
                        }) }),
                    lang_10.default("Save"))));
        }
    }
    class IgnoreModalBase extends preact_7.Component {
        constructor() {
            super(...arguments);
            this.state = {
                target: null,
                shown: false,
                left: 0,
                top: 0,
                userID: "",
                savingWL: false,
                savingBL: false,
                whitelist: [],
                blacklist: [],
            };
            this.onBackgroundClick = (e) => {
                if (e.target === this.state.target)
                    return;
                if (this.state.shown) {
                    this.hide();
                }
            };
            this.onEscapePress = () => {
                this.hide();
            };
            this.show = (target) => {
                if (target === this.state.target) {
                    this.hide();
                    return;
                }
                const post = state_18.getModel(target);
                if (post.userID === exports.session.userID)
                    return;
                let { left, top } = target.getBoundingClientRect();
                left += window.pageXOffset;
                top += window.pageYOffset + 20;
                this.setState({
                    shown: true,
                    target,
                    left,
                    top,
                    userID: post.userID,
                    whitelist: exports.account.whitelist.slice(),
                    blacklist: exports.account.blacklist.slice(),
                });
            };
            this.hide = () => {
                if (this.saving)
                    return;
                this.setState({ target: null, shown: false });
            };
            this.handleModalClick = (e) => {
                e.stopPropagation();
            };
            this.addToWhitelist = () => {
                if (this.saving)
                    return;
                const { userID, whitelist, blacklist } = this.state;
                if (this.wled) {
                    util_23.remove(whitelist, userID);
                }
                else {
                    util_23.remove(blacklist, userID);
                    whitelist.push(userID);
                }
                const settings = Object.assign({}, exports.account, { whitelist, blacklist });
                this.setState({ savingWL: true });
                api_4.default.account.setSettings(settings).then(() => {
                    Object.assign(exports.account, settings);
                    this.setState({ savingWL: false }, this.hide);
                }, (err) => {
                    alerts_5.showSendAlert(err);
                    this.setState({ savingWL: false });
                });
            };
            this.addToBlacklist = () => {
                if (this.saving)
                    return;
                const { userID, whitelist, blacklist } = this.state;
                if (this.bled) {
                    util_23.remove(blacklist, userID);
                }
                else {
                    util_23.remove(whitelist, userID);
                    blacklist.push(userID);
                }
                const settings = Object.assign({}, exports.account, { whitelist, blacklist });
                this.setState({ savingBL: true });
                api_4.default.account.setSettings(settings).then(() => {
                    Object.assign(exports.account, settings);
                    this.setState({ savingBL: false }, this.hide);
                }, (err) => {
                    alerts_5.showSendAlert(err);
                    this.setState({ savingBL: false });
                });
            };
        }
        get saving() {
            return this.state.savingWL || this.state.savingBL;
        }
        get wled() {
            return this.state.whitelist.includes(this.state.userID);
        }
        get bled() {
            return this.state.blacklist.includes(this.state.userID);
        }
        componentDidMount() {
            util_23.hook(11 /* openIgnoreModal */, this.show);
        }
        componentWillUnmount() {
            util_23.unhook(11 /* openIgnoreModal */, this.show);
        }
        render({}, { shown, left, top, userID, savingWL, savingBL }) {
            if (!shown)
                return null;
            const style = { left, top };
            return (preact_7.h("div", { class: classnames_7.default("ignore-modal", {
                    "ignore-modal_saving": this.saving,
                    "ignore-modal_wled": this.wled,
                    "ignore-modal_bled": this.bled,
                }), style: style, onClick: this.handleModalClick },
                preact_7.h("div", { class: "ignore-modal-info" }, userID),
                preact_7.h("div", { class: "ignore-modal-item", onClick: this.addToWhitelist },
                    preact_7.h("i", { class: classnames_7.default("ignore-save-icon control fa", {
                            "fa-spinner fa-pulse fa-fw": savingWL,
                            "fa-check-circle": !savingWL,
                        }) }),
                    preact_7.h("span", null,
                        " ",
                        lang_10.default(this.wled ? "From whitelist" : "To whitelist"))),
                preact_7.h("div", { class: "ignore-modal-item", onClick: this.addToBlacklist },
                    preact_7.h("i", { class: classnames_7.default("ignore-save-icon control fa", {
                            "fa-spinner fa-pulse fa-fw": savingBL,
                            "fa-times-circle": !savingBL,
                        }) }),
                    preact_7.h("span", null,
                        " ",
                        lang_10.default(this.bled ? "From blacklist" : "To blacklist")))));
        }
    }
    const IgnoreModal = widgets_2.EscapePressMixin(widgets_2.BackgroundClickMixin(IgnoreModalBase));
    // Terminate the user session(s) server-side and reset the panel
    function logout(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield fetch(url, {
                credentials: "include",
                method: "POST",
            });
            switch (res.status) {
                case 200:
                case 403: // Does not really matter, if the session already expired
                    location.reload(true);
                default:
                    alerts_5.showAlert(yield res.text());
            }
        });
    }
    // Account login and registration.
    class AccountPanel extends base_9.TabbedModal {
        constructor() {
            super(document.querySelector(".account-modal"), document.querySelector(".header-account-icon"));
            this.onClick({
                "#logout": () => logout("/api/logout"),
                "#logoutAll": () => logout("/api/logout/all"),
                "#changePassword": this.loadConditional(password_form_1.PasswordChangeForm),
                "#createBoard": this.loadConditional(board_form_1.BoardCreationForm),
                "#configureServer": this.loadConditional(server_form_1.ServerConfigForm),
            });
        }
        tabHook(el) {
            if (el.classList.contains("account-identity-tab")) {
                el.innerHTML = "";
                preact_7.render(preact_7.h(IdentityTab, { modal: this }), el);
            }
        }
        // Create handler for dynamically loading and rendering conditional
        // view modules.
        loadConditional(m) {
            return () => {
                this.toggleContent(false);
                // tslint:disable-next-line:no-unused-expression
                new m();
            };
        }
    }
    exports.accountPanel = null;
    function getModelByEvent(e) {
        return state_18.getModel(e.target);
    }
    function deletePost(post, force) {
        if (!force && !confirm(lang_10.default("delConfirm")))
            return;
        api_4.default.post.delete([post.id]).then(() => {
            // In thread we should delete on WebSocket event.
            if (!state_18.page.thread) {
                post.setDeleted();
            }
        }, alerts_5.showAlert);
    }
    function banUser(post) {
        if (!confirm(lang_10.default("banConfirm")))
            return;
        const YEAR = 365 * 24 * 60;
        api_4.default.user
            .banByPost({
            // Hardcode for now.
            duration: YEAR,
            global: exports.position >= 6 /* admin */,
            ids: [post.id],
            reason: "default",
        })
            .then(() => {
            deletePost(post, true);
        })
            .catch(alerts_5.showAlert);
    }
    function init() {
        exports.accountPanel = new AccountPanel();
        if (exports.position === -1 /* notLoggedIn */) {
            // tslint:disable-next-line:no-unused-expression
            new login_form_2.LoginForm("login-form", "login");
            const registrationForm = new login_form_2.LoginForm("registration-form", "register");
            login_form_2.validatePasswordMatch(registrationForm.el, "password", "repeat");
        }
        if (exports.position > -1 /* notLoggedIn */) {
            const container = document.querySelector(vars_12.MODAL_CONTAINER_SEL);
            if (container) {
                preact_7.render(preact_7.h(IgnoreModal, null), container);
                util_23.on(document, "click", (e) => {
                    util_23.trigger(11 /* openIgnoreModal */, e.target);
                }, { selector: vars_12.TRIGGER_IGNORE_USER_SEL });
            }
        }
        if (exports.position >= 4 /* moderator */) {
            util_23.on(document, "click", (e) => {
                deletePost(getModelByEvent(e));
            }, { selector: vars_12.TRIGGER_DELETE_POST_SEL });
            util_23.on(document, "click", (e) => {
                banUser(getModelByEvent(e));
            }, { selector: vars_12.TRIGGER_BAN_BY_POST_SEL });
        }
    }
    exports.init = init;
});
/**
 * Admin page UI.
 *
 * @module cutechan/admin
 */
define("ts/admin/index", ["require", "exports", "classnames", "preact", "ts/alerts/index", "ts/api/index", "ts/lang/index", "ts/state/index", "ts/templates/index", "ts/util/index", "ts/vars/index", "ts/widgets/index"], function (require, exports, classnames_8, preact_8, alerts_6, api_5, lang_11, state_19, templates_4, util_24, vars_13, widgets_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    classnames_8 = __importDefault(classnames_8);
    api_5 = __importDefault(api_5);
    lang_11 = __importDefault(lang_11);
    exports.modBoards = window.modBoards;
    exports.modStaff = window.modStaff;
    exports.modBans = window.modBans;
    exports.modLog = window.modLog;
    class Settings extends preact_8.Component {
        constructor() {
            super(...arguments);
            this.handleTitleChange = (e) => {
                const title = e.target.value;
                const settings = Object.assign({}, this.props.settings, { title });
                this.props.onChange({ settings });
            };
            this.handleReadOnlyToggle = (e) => {
                e.preventDefault();
                const readOnly = !this.props.settings.readOnly;
                const settings = Object.assign({}, this.props.settings, { readOnly });
                this.props.onChange({ settings });
            };
            this.handleModOnlyToggle = (e) => {
                e.preventDefault();
                const modOnly = !this.props.settings.modOnly;
                const settings = Object.assign({}, this.props.settings, { modOnly });
                this.props.onChange({ settings });
            };
            this.handleAccessModeChange = (e) => {
                const accessMode = +e.target.value;
                const settings = Object.assign({}, this.props.settings, { accessMode });
                this.props.onChange({ settings });
            };
            this.handleIncludeAnonToggle = (e) => {
                e.preventDefault();
                const includeAnon = !this.props.settings.includeAnon;
                const settings = Object.assign({}, this.props.settings, { includeAnon });
                this.props.onChange({ settings });
            };
        }
        shouldComponentUpdate(nextProps) {
            return (this.props.settings !== nextProps.settings ||
                this.props.disabled !== nextProps.disabled);
        }
        render({ settings, disabled }) {
            const { title, readOnly, modOnly, accessMode, includeAnon } = settings;
            return (preact_8.h("div", { class: classnames_8.default("admin-settings", disabled && "admin-settings_disabled") },
                preact_8.h("a", { class: "admin-content-anchor", name: "settings" }),
                preact_8.h("h3", { class: "admin-content-header" },
                    preact_8.h("a", { class: "admin-header-link", href: "#settings" }, lang_11.default("Settings"))),
                preact_8.h("label", { class: "admin-settings-label" },
                    preact_8.h("span", { class: "admin-settings-text" }, lang_11.default("Title")),
                    preact_8.h("input", { class: "admin-settings-input", value: title, disabled: disabled, onInput: this.handleTitleChange })),
                preact_8.h("label", { class: "admin-settings-label admin-settings-label_select" },
                    preact_8.h("span", { class: "admin-settings-text" }, lang_11.default("Access mode")),
                    preact_8.h("select", { class: "admin-settings-select", value: (accessMode || 0).toString(), disabled: disabled, onChange: this.handleAccessModeChange },
                        preact_8.h("option", { value: -1 /* bypass */.toString() }, lang_11.default("Bypass")),
                        preact_8.h("option", { value: 0 /* viaBlacklist */.toString() }, lang_11.default("Deny blacklisted")),
                        preact_8.h("option", { value: 1 /* viaWhitelist */.toString() }, lang_11.default("Allow whitelisted")))),
                preact_8.h("label", { class: "admin-settings-label" },
                    preact_8.h("span", { class: "admin-settings-text" }, lang_11.default("Including anonymous")),
                    preact_8.h("input", { class: "admin-settings-checkbox", type: "checkbox", checked: includeAnon, disabled: disabled, onChange: this.handleIncludeAnonToggle })),
                preact_8.h("label", { class: "admin-settings-label" },
                    preact_8.h("span", { class: "admin-settings-text" }, lang_11.default("Read only")),
                    preact_8.h("input", { class: "admin-settings-checkbox", type: "checkbox", checked: readOnly, disabled: disabled, onChange: this.handleReadOnlyToggle })),
                preact_8.h("label", { class: "admin-settings-label" },
                    preact_8.h("span", { class: "admin-settings-text" }, lang_11.default("Mod only")),
                    preact_8.h("input", { class: "admin-settings-checkbox", type: "checkbox", checked: modOnly, disabled: disabled, onChange: this.handleModOnlyToggle }))));
        }
    }
    class Members extends preact_8.Component {
        constructor() {
            super(...arguments);
            this.handleOwnersChange = (owners) => {
                const staff = this.setStaff(5 /* boardOwner */, owners);
                this.props.onChange({ staff });
            };
            this.handleModeratorsChange = (moderators) => {
                const staff = this.setStaff(4 /* moderator */, moderators);
                this.props.onChange({ staff });
            };
            this.handleJanitorsChange = (janitors) => {
                const staff = this.setStaff(3 /* janitor */, janitors);
                this.props.onChange({ staff });
            };
            this.handleWhitelistChange = (whitelist) => {
                const staff = this.setStaff(2 /* whitelisted */, whitelist);
                this.props.onChange({ staff });
            };
            this.handleBlacklistChange = (blacklist) => {
                const staff = this.setStaff(1 /* blacklisted */, blacklist);
                this.props.onChange({ staff });
            };
        }
        shouldComponentUpdate(nextProps) {
            return (this.props.staff !== nextProps.staff ||
                this.props.disabled !== nextProps.disabled);
        }
        render({ disabled }) {
            return (preact_8.h("div", { class: "admin-members" },
                preact_8.h("a", { class: "admin-content-anchor", name: "members" }),
                preact_8.h("h3", { class: "admin-content-header" },
                    preact_8.h("a", { class: "admin-header-link", href: "#members" }, lang_11.default("Members"))),
                preact_8.h("div", { class: "admin-members-grid" },
                    preact_8.h("div", { class: "admin-owners" },
                        preact_8.h("h3", { class: "admin-members-shead" }, lang_11.default("Owners")),
                        preact_8.h(widgets_3.MemberList, { members: this.getStaff(5 /* boardOwner */), disabled: disabled, onChange: this.handleOwnersChange })),
                    preact_8.h("div", { class: "admin-moderators" },
                        preact_8.h("h3", { class: "admin-members-shead" }, lang_11.default("Moderators")),
                        preact_8.h(widgets_3.MemberList, { members: this.getStaff(4 /* moderator */), disabled: disabled, onChange: this.handleModeratorsChange })),
                    preact_8.h("div", { class: "admin-janitors" },
                        preact_8.h("h3", { class: "admin-members-shead" }, lang_11.default("Janitors")),
                        preact_8.h(widgets_3.MemberList, { members: this.getStaff(3 /* janitor */), disabled: disabled, onChange: this.handleJanitorsChange })),
                    preact_8.h("div", { class: "admin-whitelist" },
                        preact_8.h("h3", { class: "admin-members-shead" }, lang_11.default("Whitelist")),
                        preact_8.h(widgets_3.MemberList, { members: this.getStaff(2 /* whitelisted */), disabled: disabled, onChange: this.handleWhitelistChange })),
                    preact_8.h("div", { class: "admin-blacklist" },
                        preact_8.h("h3", { class: "admin-members-shead" }, lang_11.default("Blacklist")),
                        preact_8.h(widgets_3.MemberList, { members: this.getStaff(1 /* blacklisted */), disabled: disabled, onChange: this.handleBlacklistChange })))));
        }
        getStaff(position) {
            return this.props.staff
                .filter((s) => s.position === position)
                .map((s) => s.userID);
        }
        setStaff(position, names) {
            const board = this.props.board;
            const staff = this.props.staff.filter((s) => s.position !== position);
            const newStaff = names.map((userID) => ({ board, userID, position }));
            return staff.concat(newStaff);
        }
    }
    class Bans extends preact_8.Component {
        shouldComponentUpdate(nextProps) {
            return (this.props.bans !== nextProps.bans ||
                this.props.disabled !== nextProps.disabled);
        }
        render({ bans, disabled }) {
            return (preact_8.h("div", { class: classnames_8.default("admin-bans", disabled && "admin-bans_disabled") },
                preact_8.h("a", { class: "admin-content-anchor", name: "bans" }),
                preact_8.h("h3", { class: "admin-content-header" },
                    preact_8.h("a", { class: "admin-header-link", href: "#bans" }, lang_11.default("Bans"))),
                preact_8.h("table", { class: "admin-table admin-ban-list" },
                    preact_8.h("thead", null,
                        preact_8.h("tr", { class: "admin-table-header admin-ban-item-header" },
                            preact_8.h("th", { class: "admin-ban-id-header" }, "#"),
                            preact_8.h("th", { class: "admin-ban-reason-header" }, lang_11.default("Reason")),
                            preact_8.h("th", { class: "admin-ban-by-header" }, lang_11.default("By")),
                            preact_8.h("th", { class: "admin-ban-time-header" }, lang_11.default("Expires")))),
                    preact_8.h("tbody", null,
                        bans.map(({ id, reason, by, expires }) => (preact_8.h("tr", { class: "admin-table-item admin-ban-item", onClick: () => this.handleRemove(id) },
                            preact_8.h("td", { class: "admin-ban-id" },
                                preact_8.h("a", { class: "post-link", href: `/all/${id}#${id}` },
                                    ">>",
                                    id)),
                            preact_8.h("td", { class: "admin-ban-reason" }, reason),
                            preact_8.h("td", { class: "admin-ban-by" }, by),
                            preact_8.h("td", { class: "admin-ban-time", title: templates_4.readableTime(expires) }, templates_4.relativeTime(expires))))),
                        !bans.length && (preact_8.h("tr", { class: "admin-table-empty" },
                            preact_8.h("td", { class: "admin-bans-empty", colSpan: 4 }, lang_11.default("No bans"))))))));
        }
        handleRemove(id) {
            if (this.props.disabled)
                return;
            const bans = this.props.bans.filter((b) => b.id !== id);
            this.props.onChange({ bans });
        }
    }
    class Log extends preact_8.Component {
        shouldComponentUpdate(nextProps) {
            return this.props.board !== nextProps.board;
        }
        render({ board }) {
            const log = exports.modLog.filter((l) => l.board === board);
            return (preact_8.h("div", { class: "admin-log" },
                preact_8.h("a", { class: "admin-content-anchor", name: "log" }),
                preact_8.h("h3", { class: "admin-content-header" },
                    preact_8.h("a", { class: "admin-header-link", href: "#log" }, lang_11.default("Mod log"))),
                preact_8.h("table", { class: "admin-table admin-log-list" },
                    preact_8.h("thead", null,
                        preact_8.h("tr", { class: "admin-table-header admin-log-item-header" },
                            preact_8.h("th", { class: "admin-log-id-header" }, "#"),
                            preact_8.h("th", { class: "admin-log-type-header" }, lang_11.default("Type")),
                            preact_8.h("th", { class: "admin-log-by-header" }, lang_11.default("By")),
                            preact_8.h("th", { class: "admin-log-time-header" }, lang_11.default("Date")))),
                    preact_8.h("tbody", null,
                        log.map(({ id, type, by, created }) => (preact_8.h("tr", { class: "admin-table-item admin-log-item" },
                            preact_8.h("td", { class: "admin-log-id" }, this.renderLink(id, type)),
                            preact_8.h("td", { class: "admin-log-type" }, this.renderType(type)),
                            preact_8.h("td", { class: "admin-log-by" }, by),
                            preact_8.h("td", { class: "admin-log-time", title: templates_4.readableTime(created) }, templates_4.relativeTime(created))))),
                        !log.length && (preact_8.h("tr", { class: "admin-table-empty admin-log-item" },
                            preact_8.h("td", { class: "admin-log-empty", colSpan: 4 }, lang_11.default("Empty log"))))))));
        }
        renderLink(id, a) {
            switch (a) {
                case 6 /* updateBoard */:
                    return (preact_8.h("a", { class: "post-link", href: `/${this.props.board}/` },
                        "/",
                        this.props.board,
                        "/"));
                default:
                    return (preact_8.h("a", { class: "post-link", href: `/all/${id}#${id}` },
                        ">>",
                        id));
            }
        }
        renderType(a) {
            switch (a) {
                case 0 /* banPost */:
                    return preact_8.h("i", { class: "fa fa-gavel", title: lang_11.default("ban") });
                case 1 /* unbanPost */:
                    return (preact_8.h("span", { class: "fa-stack", title: lang_11.default("unban") },
                        preact_8.h("i", { class: "fa fa-gavel fa-stack-1x" }),
                        preact_8.h("i", { class: "fa fa-ban fa-stack-2x admin-log-ban-icon" })));
                case 2 /* deletePost */:
                    return preact_8.h("i", { class: "fa fa-trash", title: lang_11.default("deletePost") });
                case 3 /* deleteImage */:
                    return null;
                case 4 /* spoilerImage */:
                    return null;
                case 5 /* deleteThread */:
                    return preact_8.h("i", { class: "fa fa-2x fa-trash-o", title: lang_11.default("deleteThread") });
                case 6 /* updateBoard */:
                    return preact_8.h("i", { class: "fa fa-refresh", title: lang_11.default("updateBoard") });
            }
        }
    }
    class Admin extends preact_8.Component {
        constructor() {
            super();
            this.handleBoardChange = (e) => {
                const id = e.target.value;
                this.fixateBoardInURL(id);
                const boardState = this.getBoardState(id);
                this.setState({ id, boardState });
            };
            this.handleChange = (changes) => {
                const boardState = Object.assign({}, this.state.boardState, changes);
                this.setState({ boardState, needSaving: true });
            };
            this.handleSave = () => {
                const id = this.state.id;
                const oldState = this.getBoardState(id);
                const newState = this.state.boardState;
                this.setState({ saving: true });
                api_5.default.board
                    .save(id, { oldState, newState })
                    .then(() => {
                    this.fixateBoardState();
                    this.setState({ needSaving: false });
                }, alerts_6.showSendAlert)
                    .then(() => {
                    this.setState({ saving: false });
                });
            };
            this.handleReset = () => {
                const boardState = this.getBoardState(this.state.id);
                this.setState({ boardState, needSaving: false });
            };
            let id = state_19.page.admin;
            if (!exports.modBoards.some((b) => b.id === id)) {
                // If user doesn't own board provided in URL, just use another.
                // User with access to admin page will have at least one.
                id = exports.modBoards[0].id;
            }
            this.fixateBoardInURL(id);
            this.state = {
                id,
                boardState: this.getBoardState(id),
                needSaving: false,
                saving: false,
            };
        }
        render({}, { id, boardState, needSaving, saving }) {
            const { settings, staff, bans } = boardState;
            return (preact_8.h("section", { class: "admin" },
                preact_8.h("header", { class: "admin-header" },
                    preact_8.h("h1", { class: "page-title" },
                        preact_8.h("span", { class: "admin-header-text" }, lang_11.default("Admin")),
                        preact_8.h("select", { class: "admin-board-select", value: boardState.settings.id, onChange: this.handleBoardChange }, exports.modBoards.map((b) => (preact_8.h("option", { value: b.id },
                            "/",
                            b.id,
                            "/")))))),
                preact_8.h("section", { class: "admin-inner" },
                    preact_8.h("ul", { class: "admin-section-tabs" },
                        preact_8.h("li", { class: "admin-section-tab" },
                            preact_8.h("a", { href: "#settings" }, lang_11.default("Settings"))),
                        preact_8.h("li", { class: "admin-section-tab" },
                            preact_8.h("a", { href: "#members" }, lang_11.default("Members"))),
                        preact_8.h("li", { class: "admin-section-tab" },
                            preact_8.h("a", { href: "#bans" }, lang_11.default("Bans"))),
                        preact_8.h("li", { class: "admin-section-tab" },
                            preact_8.h("a", { href: "#log" }, lang_11.default("Mod log")))),
                    preact_8.h("hr", { class: "admin-separator" }),
                    preact_8.h("section", { class: "admin-content" },
                        preact_8.h(Settings, { settings: settings, disabled: saving, onChange: this.handleChange }),
                        preact_8.h("hr", { class: "admin-separator" }),
                        preact_8.h(Members, { board: id, staff: staff, disabled: saving, onChange: this.handleChange }),
                        preact_8.h("hr", { class: "admin-separator" }),
                        preact_8.h(Bans, { bans: bans, disabled: saving, onChange: this.handleChange }),
                        preact_8.h("hr", { class: "admin-separator" }),
                        preact_8.h(Log, { board: id }))),
                preact_8.h("footer", { class: classnames_8.default("admin-footer", needSaving && "admin-footer_visible") },
                    preact_8.h("button", { class: "button admin-button admin-save-button", disabled: saving, onClick: this.handleSave },
                        preact_8.h("i", { class: classnames_8.default("admin-icon admin-save-icon fa", {
                                "fa-spinner fa-pulse fa-fw": saving,
                                "fa-check-circle": !saving,
                            }) }),
                        lang_11.default("Save")),
                    preact_8.h("button", { class: "button admin-button admin-cancel-button", disabled: saving, onClick: this.handleReset },
                        preact_8.h("i", { class: "admin-icon admin-reset-icon fa fa-times-circle" }),
                        lang_11.default("Reset")))));
        }
        fixateBoardInURL(id) {
            history.pushState({}, "", `/admin/${id}`);
        }
        getBoardState(id) {
            const board = exports.modBoards.find((b) => b.id === id);
            return {
                settings: Object.assign({}, board),
                staff: exports.modStaff.filter((b) => b.board === id),
                bans: exports.modBans.filter((b) => b.board === id),
            };
        }
        fixateBoardState() {
            const id = this.state.id;
            const s = this.state.boardState;
            const board = exports.modBoards.find((b) => b.id === id);
            Object.assign(board, s.settings);
            const staff = exports.modStaff.filter((b) => b.board !== id);
            staff.push(...s.staff);
            util_24.replace(exports.modStaff, staff);
            const bans = exports.modBans.filter((b) => b.board !== id);
            bans.push(...s.bans);
            util_24.replace(exports.modBans, bans);
        }
    }
    function init() {
        const container = document.querySelector(vars_13.MAIN_CONTAINER_SEL);
        if (container) {
            preact_8.render(preact_8.h(Admin, null), container);
        }
    }
    exports.init = init;
});
/**
 * Profile types/interfaces and accompanying functions.
 *
 * @module kpopnet/api/profiles
 */
define("node_modules/kpopnet/api/profiles", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function getBandMap(profiles) {
        const bandMap = new Map();
        profiles.bands.forEach((band) => {
            bandMap.set(band.id, band);
        });
        return bandMap;
    }
    exports.getBandMap = getBandMap;
    function getIdolMap(profiles) {
        const idolMap = new Map();
        profiles.idols.forEach((idol) => {
            idolMap.set(idol.id, idol);
        });
        return idolMap;
    }
    exports.getIdolMap = getIdolMap;
    function tryConcat(a, b) {
        return b ? [a].concat(b) : [a];
    }
    // TODO(Kagami): Profile/optimize.
    function getBandNames(idol, bandMap) {
        // NOTE(Kagami): Backend doesn't currently guarantee that alt_band_ids
        // contain correct existing band ids, so this may potentially fail.
        const bandIds = tryConcat(idol.band_id, idol.alt_band_ids);
        const bands = bandIds.map((id) => bandMap.get(id));
        const bnames = [];
        bands.forEach((b) => {
            tryConcat(b.name, b.alt_names).forEach((bname) => {
                bnames.push(bname);
            });
        });
        return bnames;
    }
    function renderIdol(idol, bandMap) {
        const renderLine = renderLineCtx.bind(null, idol);
        const bnames = getBandNames(idol, bandMap);
        // Main name of the main band goes first.
        let bname = bnames[0];
        if (bnames.length > 1) {
            bname += " (";
            bname += bnames.slice(1).join(", ");
            bname += ")";
        }
        const lines = getLines(idol).concat([["bands", bname]]);
        return lines.filter(keepLine).sort(compareLines).map(renderLine);
    }
    exports.renderIdol = renderIdol;
    function getLines(idol) {
        return Object.entries(idol);
    }
    const knownKeys = [
        "name",
        "birth_name",
        "bands",
        "birth_date",
        "height",
        "weight",
        "positions",
    ];
    const keyPriority = new Map(knownKeys.map((k, idx) => [k, idx]));
    function keepLine([key, val]) {
        return keyPriority.has(key);
    }
    function compareLines(a, b) {
        const k1 = a[0];
        const k2 = b[0];
        return keyPriority.get(k1) - keyPriority.get(k2);
    }
    function capitalize(s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    }
    function denormalizeKey(key) {
        switch (key) {
            case "birth_date":
                return "Birthday";
            case "birth_name":
                return "Real name";
        }
        key = capitalize(key);
        key = key.replace(/_/g, " ");
        return key;
    }
    function denormalizeVal(key, val, idol) {
        switch (key) {
            case "name":
                const hangul = idol.name_hangul;
                return hangul ? `${val} (${hangul})` : val;
            case "birth_name":
                const hangul2 = idol.birth_name_hangul;
                return hangul2 ? `${val} (${hangul2})` : val;
            case "birth_date":
                return `${val} (${getAge(val)})`;
            case "height":
                return val + " cm";
            case "weight":
                return val + " kg";
            case "positions":
                return val.join(", ");
            default:
                return val.toString();
        }
    }
    function renderLineCtx(idol, [key, val]) {
        val = denormalizeVal(key, val, idol);
        key = denormalizeKey(key);
        return [key, val];
    }
    const MILLISECONDS_IN_YEAR = 1000 * 365 * 24 * 60 * 60;
    function getAge(birthday) {
        const now = Date.now();
        // Birthday is always in YYYY-MM-DD form and can be parsed as
        // simplified ISO 8601 format.
        const born = new Date(birthday).getTime();
        return Math.floor((now - born) / MILLISECONDS_IN_YEAR);
    }
    // Remove symbols which doesn't make sense for fuzzy search.
    function normalize(s) {
        return s.replace(/[' .-]/g, "").toLowerCase();
    }
    // Split query into main component and property-tagged parts.
    // Example: "name words prop1:prop words prop2:more words"
    // TODO(Kagami): Profile/optimize.
    function parseQuery(query) {
        let name = "";
        const props = [];
        let lastKey = "";
        while (true) {
            // Search for prop1[:]
            const colonIdx = query.indexOf(":");
            if (colonIdx >= 1) {
                // Search for [ ]prop1:
                const spaceIdx = query.lastIndexOf(" ", colonIdx);
                if (spaceIdx >= 0) {
                    // [name words] prop1:
                    const lastVal = normalize(query.slice(0, spaceIdx));
                    if (lastKey) {
                        props.push([lastKey, lastVal]);
                    }
                    else {
                        name = lastVal;
                    }
                    // [prop1]:...
                    lastKey = query.slice(spaceIdx + 1, colonIdx);
                    // prop1:[name words...]
                    query = query.slice(colonIdx + 1);
                }
                else {
                    // prop1:word:prop2
                    if (lastKey)
                        break;
                    // Allow to start with []prop1:word
                    lastKey = query.slice(0, colonIdx);
                    // prop1:[name words...]
                    query = query.slice(colonIdx + 1);
                }
            }
            else {
                // prop2:[more words]
                const lastVal = normalize(query);
                if (lastKey) {
                    props.push([lastKey, lastVal]);
                }
                else {
                    name = lastVal;
                }
                break;
            }
        }
        return { name, props };
    }
    // Match all possible names of the idol.
    // TODO(Kagami): Search for hangul?
    function matchIdolName(idol, val) {
        if (normalize(idol.name).includes(val)) {
            return true;
        }
        if (idol.birth_name && normalize(idol.birth_name).includes(val)) {
            return true;
        }
        if (idol.korean_name && normalize(idol.korean_name).includes(val)) {
            return true;
        }
        if (idol.alt_names &&
            idol.alt_names.some((n) => normalize(n).includes(val))) {
            return true;
        }
        return false;
    }
    // Match all possible band names.
    function matchBandName(idol, bandMap, val) {
        const bnames = getBandNames(idol, bandMap);
        return bnames.some((bname) => normalize(bname).includes(val));
    }
    /**
     * Find idols matching given query.
     */
    // TODO(Kagami): Profile/optimize.
    function searchIdols(query, profiles, bandMap) {
        if (query.length < 3)
            return [];
        // console.time("parseQuery");
        const q = parseQuery(query);
        // console.timeEnd("parseQuery");
        if (!q.name && !q.props.length)
            return [];
        // TODO(Kagam): Sort idols?
        // console.time("searchIdols");
        const result = profiles.idols.filter((idol) => {
            // Fuzzy name matching.
            // TODO(Kagami): Allow combinations like "Orange Caramel lizzy"
            if (q.name &&
                !matchIdolName(idol, q.name) &&
                !matchBandName(idol, bandMap, q.name)) {
                return false;
            }
            // Match for exact properties if user requested.
            return q.props.every(([key, val]) => {
                switch (key) {
                    case "n":
                    case "name":
                        if (normalize(idol.name).includes(val)) {
                            return true;
                        }
                        break;
                    case "rn":
                        if (normalize(idol.birth_name || "").includes(val)) {
                            return true;
                        }
                        break;
                    case "b":
                    case "band":
                        if (normalize(bandMap.get(idol.band_id).name).includes(val)) {
                            return true;
                        }
                        break;
                }
                return false;
            });
        });
        // console.timeEnd("searchIdols");
        return result;
    }
    exports.searchIdols = searchIdols;
});
/**
 * Reusable kpopnet components.
 *
 * Can be used to add profiles/face recognition functionality to
 * third-party sites (intended for cutechan).
 *
 * @module kpopnet/api
 */
define("node_modules/kpopnet/api/index", ["require", "exports", "node_modules/kpopnet/api/profiles"], function (require, exports, profiles_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.renderIdol = profiles_1.renderIdol;
    exports.getBandMap = profiles_1.getBandMap;
    exports.getIdolMap = profiles_1.getIdolMap;
    exports.searchIdols = profiles_1.searchIdols;
    const unknownErr = "unknownErr";
    function handleResponse(res) {
        return res.ok ? res.json() : handleErrorCode(res);
    }
    function handleErrorCode(res) {
        const ctype = res.headers.get("Content-Type");
        const isHtml = ctype.startsWith("text/html");
        const isJson = ctype.startsWith("application/json");
        if (isHtml) {
            // Probably 404/500 page, don't bother parsing.
            throw new Error(unknownErr);
        }
        else if (isJson) {
            // Probably standardly-shaped JSON error.
            return res.json().then((data) => {
                throw new Error((data && data.error) || unknownErr);
            });
        }
        else {
            // Probably text/plain or something like this.
            return res.text().then((data) => {
                throw new Error(data || unknownErr);
            });
        }
    }
    function handleError(err) {
        throw new Error(err.message || unknownErr);
    }
    /**
     * Get all profiles. ~47kb gzipped currently.
     */
    function getProfiles(opts = {}) {
        const prefix = opts.prefix || API_PREFIX;
        return fetch(`${prefix}/profiles`, { credentials: "same-origin" }).then(handleResponse, handleError);
    }
    exports.getProfiles = getProfiles;
    /**
     * Get URL of the idol's preview image. Safe to use in <img> element
     * right away.
     */
    function getIdolPreviewUrl(idol, opts = {}) {
        const prefix = opts.prefix || FILE_PREFIX;
        const fallback = opts.fallback || "/static/img/no-preview.svg";
        const sizeDir = opts.small ? "thumb" : "src";
        const sha1 = idol.image_id;
        // NOTE(Kagami): This assumes that filetype of the preview image is
        // always JPEG. It must be ensured by Idol API service.
        return sha1
            ? `${prefix}/${sizeDir}/${sha1.slice(0, 2)}/${sha1.slice(2)}.jpg`
            : fallback;
    }
    exports.getIdolPreviewUrl = getIdolPreviewUrl;
    /**
     * Set idol's preview.
     */
    function setIdolPreview(idol, file, opts = {}) {
        const prefix = opts.prefix || API_PREFIX;
        const form = new FormData();
        form.append("files[]", file);
        return fetch(`${prefix}/${idol.id}/preview`, {
            credentials: "same-origin",
            method: "POST",
            body: form,
        }).then(handleResponse, handleError);
    }
    exports.setIdolPreview = setIdolPreview;
    /**
     * Recognize idol.
     */
    function recognizeIdol(file, opts = {}) {
        const prefix = opts.prefix || API_PREFIX;
        const form = new FormData();
        form.append("files[]", file);
        return fetch(`${prefix}/recognize`, {
            credentials: "same-origin",
            method: "POST",
            body: form,
        }).then(handleResponse, handleError);
    }
    exports.recognizeIdol = recognizeIdol;
});
/**
 * Working with idol profiles.
 *
 * @module cutechan/idols/profiles
 */
define("ts/idols/profiles", ["require", "exports", "preact", "hangeul", "node_modules/kpopnet/api/index", "ts/alerts/index", "ts/auth/index", "ts/lang/index", "ts/posts/index", "ts/state/index", "ts/util/index", "ts/vars/index", "ts/widgets/index"], function (require, exports, preact_9, hangeul_1, api_6, alerts_7, auth_3, lang_12, posts_4, state_20, util_25, vars_14, widgets_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    hangeul_1 = __importDefault(hangeul_1);
    lang_12 = __importDefault(lang_12);
    const cutechanApiPrefix = "/api/idols";
    const apiPrefix = state_20.config.kpopnetRootOverride || cutechanApiPrefix;
    class IdolPreview extends preact_9.Component {
        constructor() {
            super(...arguments);
            this.fileEl = null;
            this.handlePreviewClick = () => {
                if (auth_3.isPowerUser()) {
                    this.fileEl.click();
                }
            };
            this.handleFileChange = () => {
                const files = this.fileEl.files;
                if (files.length) {
                    this.handleFile(files[0]);
                }
                this.fileEl.value = ""; // Allow to select same file again
            };
        }
        render({ idol }) {
            const previewUrl = api_6.getIdolPreviewUrl(idol, {
                small: true,
                prefix: posts_4.getFilePrefix(),
            });
            const style = { backgroundImage: `url(${previewUrl})` };
            return (preact_9.h("div", { class: "idol-preview", style: style, onClick: this.handlePreviewClick },
                preact_9.h("input", { ref: (f) => (this.fileEl = f), type: "file", accept: "image/jpeg", class: "idol-preview-file", onChange: this.handleFileChange })));
        }
        handleFile(file) {
            const { idol } = this.props;
            // This request always goes through cutechan backend.
            api_6.setIdolPreview(idol, file, { prefix: cutechanApiPrefix })
                .then(({ SHA1 }) => {
                this.props.onChange(idol, SHA1);
            })
                .catch(alerts_7.showAlert);
        }
    }
    class IdolItem extends preact_9.Component {
        constructor() {
            super(...arguments);
            this.handlePreviewChange = (idol, imageId) => {
                // Easier to fix in place and re-render than rebuild bandMap every
                // time.
                idol.image_id = imageId;
                this.forceUpdate();
            };
        }
        shouldComponentUpdate() {
            return false;
        }
        render({ idol, bandMap }) {
            // FIXME(Kagami): Show all info on request.
            const lines = api_6.renderIdol(idol, bandMap).slice(0, 5);
            // label_icon may be omitted but if present both must present.
            const { label_icon, label_name } = bandMap.get(idol.band_id);
            return (preact_9.h("section", { class: "idol" },
                preact_9.h(IdolPreview, { idol: idol, onChange: this.handlePreviewChange }),
                preact_9.h("div", { class: "idol-info" }, lines.map(this.rerenderLine.bind(this, idol))),
                label_icon && (preact_9.h("div", { class: "idol-label", title: label_name },
                    preact_9.h("i", { class: `label label-${label_icon}` })))));
        }
        rerenderLine(idol, [key, val]) {
            // XXX(Kagami): Fix result of kpopnet example render the way we
            // need. This is a bit hacky, maybe it would be better to implement
            // everything by ourself.
            let ru = "";
            switch (key) {
                case "Name":
                    if (!idol.name_hangul)
                        break;
                    ru = hangeul_1.default.runame(idol.name_hangul);
                    if (!ru)
                        break;
                    return (preact_9.h("p", { class: "idol-info-line" },
                        preact_9.h("span", { class: "idol-info-key" }, lang_12.default(key)),
                        preact_9.h("span", { class: "idol-info-val" },
                            idol.name,
                            " (",
                            preact_9.h("abbr", { class: "idol-info-abbr", title: ru }, idol.name_hangul),
                            ")")));
                case "Real name":
                    if (!idol.birth_name_hangul)
                        break;
                    ru = hangeul_1.default.runame(idol.birth_name_hangul);
                    if (!ru)
                        break;
                    return (preact_9.h("p", { class: "idol-info-line" },
                        preact_9.h("span", { class: "idol-info-key" }, lang_12.default(key)),
                        preact_9.h("span", { class: "idol-info-val" },
                            idol.birth_name,
                            " (",
                            preact_9.h("abbr", { class: "idol-info-abbr", title: ru }, idol.birth_name_hangul),
                            ")")));
                case "Height":
                    val = util_25.printf(lang_12.default("cm"), idol.height);
                    break;
                case "Weight":
                    val = util_25.printf(lang_12.default("kg"), idol.weight);
                    break;
            }
            return (preact_9.h("p", { class: "idol-info-line" },
                preact_9.h("span", { class: "idol-info-key" }, lang_12.default(key)),
                preact_9.h("span", { class: "idol-info-val" }, val)));
        }
    }
    class IdolList extends preact_9.Component {
        shouldComponentUpdate(nextProps) {
            return this.props.query !== nextProps.query;
        }
        render({ query, profiles, bandMap }) {
            const idols = api_6.searchIdols(query, profiles, bandMap).slice(0, 20);
            return (preact_9.h("article", { class: "idols" }, idols.map((idol) => (preact_9.h(IdolItem, { key: idol.id, idol: idol, bandMap: bandMap })))));
        }
    }
    function Spinner() {
        return preact_9.h("i", { class: "header-profiles-spinner fa fa-spinner fa-pulse fa-fw" });
    }
    class ProfilesWrapperBase extends preact_9.Component {
        constructor() {
            super();
            this.profiles = null;
            this.bandMap = null;
            this.onBackgroundClick = () => {
                this.hide();
            };
            this.onEscapePress = () => {
                this.hide();
            };
            this.hide = () => {
                if (this.state.query) {
                    this.setState({ query: "" });
                }
            };
            this.handleWrapperClick = (e) => {
                e.stopPropagation();
            };
            this.handleSearchFocus = () => {
                if (!this.state.loading && !this.state.query) {
                    this.setState({ loading: true });
                    api_6.getProfiles({ prefix: apiPrefix })
                        .then((profiles) => {
                        this.profiles = profiles;
                        this.bandMap = api_6.getBandMap(profiles);
                        this.setState({ loading: false });
                    })
                        .catch((err) => {
                        alerts_7.showAlert(new Error(lang_12.default("profileErr") + ": " + lang_12.default(err.message)));
                        this.setState({ loading: false });
                    });
                }
            };
            this.handleSearch = (e) => {
                if (!this.state.loading) {
                    const query = e.target.value;
                    this.setState({ query });
                }
            };
            this.state = {
                loading: false,
                query: "",
            };
        }
        render(props, { loading, query }) {
            return (preact_9.h("span", { class: "header-profiles-wrapper", onClick: this.handleWrapperClick },
                preact_9.h("input", { class: "header-profiles-search", placeholder: lang_12.default("searchIdol"), value: query, onFocus: this.handleSearchFocus, onInput: this.handleSearch }),
                loading && preact_9.h(Spinner, null),
                preact_9.h(IdolList, { profiles: this.profiles, bandMap: this.bandMap, query: query })));
        }
    }
    const ProfilesWrapper = widgets_4.EscapePressMixin(widgets_4.BackgroundClickMixin(ProfilesWrapperBase));
    function init() {
        const container = document.querySelector(vars_14.PROFILES_CONTAINER_SEL);
        if (container) {
            // Server-side template renders exactly same search input in order
            // to make preact's kick off seamless.
            container.innerHTML = "";
            preact_9.render(preact_9.h(ProfilesWrapper, null), container);
            util_25.hook(10 /* focusIdolSearch */, () => {
                document.querySelector(".header-profiles-search").focus();
            });
        }
    }
    exports.init = init;
});
/**
 * Idol profiles/faces logic.
 *
 * @module cutechan/idols
 */
define("ts/idols/index", ["require", "exports", "ts/idols/profiles"], function (require, exports, profiles_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.initProfiles = profiles_2.init;
});
define("ts/page/common", ["require", "exports", "ts/lang/index", "ts/posts/index", "ts/state/index", "ts/ui/index", "ts/util/index", "ts/vars/index"], function (require, exports, lang_13, posts_5, state_21, ui_7, util_26, vars_15) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    lang_13 = __importDefault(lang_13);
    // Check if the rendered page is a ban page.
    function isBanned() {
        return !!document.querySelector(".ban");
    }
    exports.isBanned = isBanned;
    // Extract pregenerated rendered post data from DOM.
    function extractPageData() {
        return {
            threads: util_26.extractJSON("post-data"),
            backlinks: util_26.extractJSON("backlink-data"),
        };
    }
    exports.extractPageData = extractPageData;
    // Extract post model and view from the HTML fragment and apply
    // client-specific formatting. Returns whether the element was removed.
    function extractPost(data, op, board, backlinks) {
        const el = document.getElementById(`post${data.id}`);
        // if (hidden.has(post.id)) {
        //   el.remove();
        //   return true;
        // }
        data.op = op;
        data.board = board;
        const post = new posts_5.Post(data);
        state_21.posts.add(post);
        if (state_21.page.catalog) {
            post.seenOnce = true;
        }
        else {
            const view = new posts_5.PostView(post, el);
            view.afterRender();
            post.backlinks = backlinks[post.id];
            personalizeLinks(post);
            personalizeBacklinks(post);
            ui_7.postAdded(post);
        }
        return false;
    }
    exports.extractPost = extractPost;
    function addYous(id, el) {
        for (const a of el.querySelectorAll(`a[data-id="${id}"]`)) {
            a.textContent += " " + lang_13.default("you");
        }
    }
    // Add (You) to posts linking to the user's posts. Appends to array of posts,
    // that might need to register a new reply to one of the user's posts.
    function personalizeLinks(post) {
        if (!post.links) {
            return;
        }
        let el;
        let isReply = false;
        for (const id of new Set(post.links.map((l) => l[0]))) {
            if (!state_21.mine.has(id)) {
                continue;
            }
            isReply = true;
            // Don't query DOM, until we know we need it
            if (!el) {
                el = post.view.el.querySelector("blockquote");
            }
            addYous(id, el);
        }
        if (isReply) {
            ui_7.notifyAboutReply(post);
        }
    }
    // Add (You) to backlinks user's posts
    function personalizeBacklinks(post) {
        if (!post.backlinks) {
            return;
        }
        let el;
        for (const idStr of Object.keys(post.backlinks)) {
            const id = parseInt(idStr, 10);
            if (!state_21.mine.has(id)) {
                continue;
            }
            // Don't query DOM, until we know we need it
            if (!el) {
                el = post.view.el.querySelector(vars_15.POST_BACKLINKS_SEL);
            }
            addYous(id, el);
        }
    }
});
define("ts/page/thread", ["require", "exports", "ts/page/common"], function (require, exports, common_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // Render the HTML of a thread page.
    function render() {
        if (common_4.isBanned())
            return;
        const { threads: data, backlinks } = common_4.extractPageData();
        const { posts } = data;
        data.posts = null;
        common_4.extractPost(data, data.id, data.board, backlinks);
        for (const post of posts) {
            common_4.extractPost(post, data.id, data.board, backlinks);
        }
    }
    exports.render = render;
});
define("ts/page/board", ["require", "exports", "ts/state/index", "ts/util/index", "ts/vars/index", "ts/page/common"], function (require, exports, state_22, util_27, vars_16, common_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // Sort threads by embedded data.
    function subtract(attr) {
        return (a, b) => b[attr] - a[attr];
    }
    // Thread sort functions.
    const sorts = {
        bump: subtract("bumpTime"),
        creation: subtract("time"),
        fileCount: subtract("imageCtr"),
        replyCount: subtract("postCtr"),
    };
    function extractCatalogModels() {
        const { threads, backlinks } = common_5.extractPageData();
        for (const t of threads) {
            common_5.extractPost(t, t.id, t.board, backlinks);
        }
    }
    function extractThreads() {
        const { threads, backlinks } = common_5.extractPageData();
        for (const thread of threads) {
            const { posts: threadPosts } = thread;
            delete thread.posts;
            if (common_5.extractPost(thread, thread.id, thread.board, backlinks)) {
                document.getElementById(`thread${thread.id}`).remove();
                continue;
            }
            for (const post of threadPosts) {
                common_5.extractPost(post, thread.id, thread.board, backlinks);
            }
        }
    }
    // Retrieves the thread container and the threads within depending on
    // page type.
    function getThreads() {
        let contID = "";
        let threadSel = "";
        if (state_22.page.catalog) {
            contID = "catalog";
            threadSel = ".post-catalog-wrapper";
        }
        else {
            contID = "index-thread-container";
            threadSel = ".thread";
        }
        const container = document.getElementById(contID);
        const threads = container.querySelectorAll(threadSel);
        return [container, Array.from(threads)];
    }
    // Filter against board and subject and toggle thread visibility.
    function filterThreads(filter) {
        const [, threads] = getThreads();
        const r = new RegExp(filter, "i");
        const matched = new Set();
        for (const p of state_22.posts) {
            const match = (p.board && r.test(`/${p.board}/`)) ||
                r.test(p.subject) ||
                r.test(p.body);
            if (match) {
                matched.add(p.op);
            }
        }
        for (const el of threads) {
            const id = util_27.getID(el);
            el.style.display = matched.has(id) ? "" : "none";
        }
    }
    // Sort all threads on a board.
    function sortThreads(sortMode) {
        const [container, threads] = getThreads();
        const els = {};
        const sortedThreads = threads
            .map((el) => {
            const id = util_27.getID(el);
            els[id] = el;
            return state_22.posts.get(id);
        })
            .sort(sorts[sortMode])
            .map(({ id }, i) => {
            const el = els[id];
            el.style.zIndex = (-i).toString();
            el.remove();
            return el;
        });
        container.append(...sortedThreads);
    }
    function onSearchChange(e) {
        filterThreads(e.target.value);
    }
    function onSortChange(e) {
        sortThreads(e.target.value);
    }
    // Apply client-side modifications to a board page's HTML.
    function render() {
        if (state_22.page.catalog) {
            extractCatalogModels();
        }
        else {
            extractThreads();
        }
        if (state_22.page.catalog) {
            const input = document.querySelector(vars_16.BOARD_SEARCH_INPUT_SEL);
            input.oninput = onSearchChange;
            const select = document.querySelector(vars_16.BOARD_SEARCH_SORT_SEL);
            select.onchange = onSortChange;
        }
    }
    exports.render = render;
});
define("ts/page/index", ["require", "exports", "ts/page/common", "ts/page/thread", "ts/page/board"], function (require, exports, common_6, thread_1, board_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isBanned = common_6.isBanned;
    exports.renderThread = thread_1.render;
    exports.renderBoard = board_1.render;
});
/**
 * Application entry point.
 */
define("app", ["require", "exports", "ts/options/index", "ts/admin/index", "ts/alerts/index", "ts/auth/index", "ts/client/index", "ts/connection/index", "ts/db/index", "ts/idols/index", "ts/lang/index", "ts/page/index", "ts/posts/index", "ts/state/index", "ts/ui/index"], function (require, exports, options_11, admin_1, alerts_8, auth_4, client_2, connection_3, db_3, idols_1, lang_14, page_1, posts_6, state_23, ui_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // Load all stateful modules in dependency order.
    function init() {
        return __awaiter(this, void 0, void 0, function* () {
            alerts_8.init();
            options_11.init();
            lang_14.init();
            yield db_3.init();
            state_23.loadPostStores();
            if (state_23.page.landing) {
                /* skip */
            }
            else if (state_23.page.stickers) {
                /* skip */
            }
            else if (state_23.page.admin) {
                admin_1.init();
            }
            else if (state_23.page.thread) {
                page_1.renderThread();
                connection_3.init();
                client_2.init();
                posts_6.init();
            }
            else if (state_23.page.board) {
                page_1.renderBoard();
                if (!state_23.page.catalog) {
                    posts_6.init();
                }
            }
            ui_8.init();
            auth_4.init();
            idols_1.initProfiles();
            // Fire off site fully loaded event for userscripts
            document.dispatchEvent(new CustomEvent('site_fully_loaded', { bubbles: true }));
        });
    }
    init().catch((err) => {
        // tslint:disable-next-line:no-console
        console.error(err);
        alerts_8.showAlert({
            message: err.message,
            sticky: true,
            title: lang_14._("initErr"),
        });
    });
});
